module.exports = {
  "systemMessage": {
    "captchaNotMatch": "验证码不匹配",
    "captchaError": "检查码输入错误，请重新输入"
  },
  "capitalFundDetails": {
    "title": "资金明细"
  },
  "financefund": {
    "endDate": "结束日期",
    "to": "至",
    "startDate": "开始日期"
  },
  "stockActivityPc": {
    "over": "已结束",
    "pleaseTryLater": "请稍后尝试",
    "sure": "确定",
    "inProgress": "进行中",
    "joinNow": "马上参加",
    "hint": "提示",
    "viewActivity": "查看活动",
    "time": "时间",
    "specialPriceArea": "优惠专区",
    "newYearEnvelopes": "新年开市红包等你拿"
  },
  "quotes": {
    "latestPrice": "最新价",
    "turnoverHeader": "成交量",
    "gainList": "涨幅榜",
    "optional": "自选",
    "title": "行情",
    "turnOver": "成交额",
    "upDown": "涨跌",
    "quotes": "行情",
    "speedList": "涨速榜",
    "turnOverRate": "换手率",
    "fastestfallling": "跌速榜",
    "nameCode": "名称代码",
    "dropList": "跌幅榜"
  },
  "timeBaoDetails": {
    "date": "日期",
    "back": "返回",
    "retrieve": "检索",
    "end": "没有更多了",
    "pickDate": "选择年月日",
    "title": "资金明细",
    "accountBalance": "账户余额"
  },
  "increaseInfo": {
    "subAccountBalAddition": "追加后子账户余额:",
    "lossWarnLineAddition": "追加后亏损警戒线（亏损比）:",
    "enterAdditionalAmountMsg": "请输入追加金额",
    "currentLossCloseLine": "当前亏损平仓线(亏损比）:",
    "additionalTitle": "追加配资金额",
    "contractNumber": "合约编号",
    "totAccountBal": "当前总账户余额:",
    "enterAdditionalAmount": "请输入追加金额 最低100元起",
    "marginTitle": "追加保证金",
    "yuan": "元",
    "currentLossWarnLine": "当前亏损警戒线(亏损比）:",
    "totAccountBalAddition": "追加后总账户余额:",
    "lossCloseLineAddition": "追加后亏损平仓线（亏损比）:",
    "currentSubBal": "当前子账户余额:",
    "appendNow": "立即追加"
  },
  "myAccountPc": {
    "foundwinners": "发现牛股",
    "securityNum": "凤凰证券会员",
    "fundOperation": "资金操作",
    "riskControlNotice": "风控通知",
    "fundingAccount": "配资账户",
    "redEnvelope": "现金红包",
    "diagnosis": "智能诊股",
    "versionNumber": "版本号",
    "completeMaterial": "完善资料",
    "agencyAccount": "代理账户",
    "firmOffer": "实盘交易",
    "lastLoginTime": "上次登陆时间",
    "friendCashCoupon": "好友现金券",
    "greetingMessage": "您好,{companyName}",
    "transactionInquiry": "交易查询",
    "fundingDetails": "资金明细",
    "timeTreasure": "时时宝",
    "myCashCoupon": "我的现金券",
    "myAccount": "我的账户",
    "regularTreasure": "定期宝",
    "festivalTreasure": "节日宝",
    "username": "用户名"
  },
  "withdrawPop": {
    "withdrawTo": "提款到"
  },
  "action": {
    "cancel": "取消",
    "getAllBalance": "一键余额查询",
    "certify": "证明",
    "collectToWallet": "归集到平台钱包",
    "Pay": "支付",
    "deductionOfStock": "扣除股票",
    "sendCash": "寄现金",
    "addUserControl": "用户风控",
    "updateUniAppLanguage": "生成UNIAPP文件",
    "freeze": "限制卖出",
    "one_click_ex_right_dividend_payment": "一键除权派息",
    "updateMaxNetRecharge": "更新最大净充值",
    "dumpdata": "导出",
    "addVoucherManagement": "送代金券",
    "closeOperation": "关闭操作",
    "checkNewStocks": "检查新股票",
    "cash": "兑现",
    "buyStock": " 系统买入股票",
    "forceCapitalClose": "强制结算",
    "BusinessDetails": "跳转链接",
    "add": "添加",
    "rechargeFinish": "充值完成",
    "collectAll": "一键归集",
    "userbank": "用户银行",
    "rejectAll": "全部拒绝",
    "add_sub_agent": "add_sub_agent",
    "frozen": "禁用",
    "pay": "付款",
    "partialClose": "部分卖出",
    "jumpUserAccount": "用户账户",
    "plus": "后台充值",
    "refreshTheStocks": "更新股票池",
    "calculateProfitAndLoss": "计算盈亏",
    "shortSellingUpload": "做空股票池上传",
    "unforbidden": "启用 ",
    "selectAdd": "选择添加",
    "getBalance": "余额获取",
    "checkAccount": "余额查询",
    "redpacketDetail": "开包明细",
    "orders": "订单管理",
    "export_file": "导出",
    "detail": "查看详情",
    "agent_account": "agent_account",
    "cancelWithOneClick": "一键取消",
    "minus": "后台扣除",
    "turnDown": "驳回",
    "save": "保存",
    "update": "修改",
    "updateDifferentTransactionTimeUsers": "是否不同交易时间用户",
    "delete": "删除",
    "runOnce": "执行一次",
    "unFreeze": "解冻卖出限制",
    "addRobot": "添加机器人",
    "InterestPaymentDeatails": "跳转链接",
    "reject": "驳回",
    "agentCommission": "佣金明细",
    "dividendReturn": "股息回报",
    "unFrozen": "强制解除冻结",
    "changeCostPrice": "更改成本价",
    "exRightsDividend": "除权派息",
    "cancel_buy_order": "撤销开仓委托",
    "address": "地址管理",
    "manageSTStock": "管理ST股票",
    "updateRsa": "更换密钥",
    "forbidden": "禁用",
    "clear": "清空",
    "updateCurrentPrice": "更新现价",
    "addRsa": "生成密钥",
    "flowLog": "资金流水",
    "closeCapital": "结算",
    "statGenerate": "生成统计数据",
    "addFirstGift": "新人礼品",
    "hide": "隐藏",
    "approveAll": "批量添加",
    "resetPwd": "重置密码",
    "addFriendCoupon": "送好友现金券",
    "approve": "批准",
    "selectOrAddUserBank": "选择或添加账户",
    "clone": "复制添加",
    "updateStopStocks": "更新停牌股票",
    "updateAdminlanguage": "生成ADMIN文件"
  },
  "activityDetails": {
    "title": "活动介绍"
  },
  "flow": {
    "contToRecharge": "继续新充值",
    "show": "显示",
    "back": "返回",
    "rechargeName": "充值名称",
    "title": "充值",
    "rechargeChannel": "充值通道",
    "amountGreater": "充值金额必须为大于100元",
    "enterAmount": "请输入正确的充值金额",
    "contactCustomerService": "请联系客服",
    "rechargeType": "选择您的充值方式",
    "rechargeMethod": "充值方式",
    "all": "全部",
    "amount": "充值金额",
    "rechargeInstructions": "获取实时入款卡，请自行通过手机/电脑/银行转账",
    "currentBalance": "当前余额",
    "understand": "我已经明白",
    "lastSelected": "上次选择",
    "submitAgain": "您已提交一笔同金额的充值正在审核处理中\\n若非新充值请勿重复提交?'",
    "selectRechargeType": "请选择充值类型",
    "yuan": "元",
    "activityArea": "活动专区",
    "hide": "隐藏",
    "maxIs2Mil": "人工入款金额最大金额为200万",
    "nextStep": "下一步",
    "noNewRecharge": "非新充值"
  },
  "announcement": {
    "back": "返回",
    "title": "平台公告"
  },
  "aboutus": {
    "title": "关于我们"
  },
  "rechargeInfo": {
    "reminderInfo": "请用本人(test)的账号自行转账后点《我已成功付款》，即可入款\\n转账金额须与系统一致，若有小数须带小数，否则次日到账",
    "reminder": "温馨提醒 : ",
    "accountName": "开户姓名",
    "rechargeNotice": "充值须知",
    "currentBalance": "当前余额",
    "back": "返回",
    "bankName": "银行名称",
    "payCountdown": "支付倒计时 :",
    "payPlease": "请付",
    "branch": "开户支行",
    "transferredMoney": "我已转账 申请充值",
    "contactCustService": "若10分钟内若未入款，请联系在线客服或专属客服。",
    "cancelAddress": "取消转账",
    "yuan": "元",
    "bankCardInfo": "银行卡信息",
    "payAmount": "支付金额",
    "recharge": "充值",
    "rechargeAddress": "充值地址 : ",
    "copy": "复制",
    "copySuccess": "复制成功",
    "recieptAmount": "到账金额",
    "cardNumber": "收款卡号",
    "rechargeQrCode": "充值二维码"
  },
  "commonloading": {
    "downloading": "加载中",
    "switchOtherLines": "如遇运行缓慢 请切换其他线路"
  },
  "operatevip": {
    "allocateFund": "我要配资",
    "lossWarning": "亏损预警线",
    "totalAllocation": "总配资金额",
    "times": "倍",
    "balance": "可用余额",
    "payment": "实付款",
    "day": "按天配资",
    "fundLowerLiquidation": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓， 为避免平仓发生，请时刻关注本金是否充足",
    "allocation": "配资资金",
    "agreement": "《服务协议》",
    "ticket": "代金券",
    "lossClosingLine": "亏损平仓线",
    "automaticRenewal": "自动续期",
    "understand": "我已经明白",
    "fundBelowWarning": "当总配资资金低于预警线以下时，只能平仓不能建仓",
    "agree": "我已阅读并同意",
    "yuan": "元",
    "month": "月",
    "allocate": "配资资金",
    "fundingInfo": "配资信息",
    "managementFee": "管理费",
    "closeLine": "平仓线",
    "readAgreement": "请先阅读协议书",
    "loginFirst": "请先登录",
    "deposit": "保证金",
    "monthlyIntrest": "月利率"
  },
  "tradingquery": {
    "profitLossAmount": "盈亏金额",
    "buyAmount": "买入额¥:",
    "sellingAmount": "卖出额¥:",
    "profitLossRatio": "盈亏比例"
  },
  "friendCouponTerms": {
    "friendCash": "好友现金券",
    "back": "返回"
  },
  "agentDepot": {
    "membershipAward": "会员管理奖",
    "commisionBalance": " 佣金余额",
    "totalDeferred": "递延费总额",
    "managementFee": "管理费",
    "profitSharing": "利润分成",
    "back": "返回",
    "commision": "佣金",
    "withdraw": "提现"
  },
  "capitalaAccount": {
    "tradingWeek": "元 / 周",
    "tradingDay": "元 / 交易日",
    "holdingTitle": "自动延期",
    "holdingTitleIntersetFree": "最长30天",
    "tradingMonth": "元 / 自然月"
  },
  "operatesuccess": {
    "totaltrading": "总操盘资金:",
    "lossclosingline": "亏损平仓线:",
    "losswarning": "亏损警戒线:",
    "allotmentamount": "配资金额:",
    "longTrading": "做多交易",
    "shortTrading": "做空交易",
    "effectiveimidely": "立即生效",
    "yuan": "元",
    "amountmanagmentfee": "账户管理费:",
    "realpayment": "实付款:",
    "alreadyknow": "我已知晓，去账户列表",
    "tradingDirection": "配资仓位方向:",
    "applicationsuccess": "配资申请成功",
    "starttradingtime": "开始交易时间:",
    "investmentprincipal": "投资本金:"
  },
  "system": {
    "cancel": "取 消",
    "exception": "系统异常",
    "MobileNumberRegistered": "手机号码已被注册",
    "clearingCache": "正在清除设置缓存并刷新，请稍后...",
    "upload": "上传",
    "otherOperation": "其他操作",
    "closeOthers": "关闭其它",
    "empty_string": "请输入金额",
    "MarginError": "保证金为100的倍数",
    "UserAlreadyUsed": "该用户已经被注册",
    "timebaoMoveOutSuccessfully": "系统提示：时时宝转出成功",
    "confirmOperation": "确认要操作吗？",
    "csvFileEmpty": "CSV文件内容为空！",
    "shortBuyPriceConfigMainBoardShouldBeTheRange": "做空科创/创业板下限价位应当是该范围",
    "confirmSubmit": "确认提交",
    "additionalAmountCannotBeLessThanZero": "追加金额不能小于0",
    "cancelFullScreen": "取消全屏",
    "optional": "(选填)",
    "fullScreen": "全屏",
    "dayStockLogSaveFailed": "当日库存日志保存失败",
    "ForgetPasswordUserNotExist": "该电话号码的用户不存在",
    "captchaExpired": "验证码已过期",
    "msgSendSuccess": "你的验证码发送成功,请注意查收",
    "customerService": "在线客服",
    "pressToClose": "点击此处退出",
    "alreadySignInToday": "今天您已签到,下一个交易日再来",
    "commissionedSuccessfully": "委托成功",
    "statusError": "请选择正确的行",
    "enterAdditionalAllocationAmount": "请输入追加配资金额",
    "IdentifierFundNotExist": "配资唯一标示不存在",
    "LoginSuccess": "登录成功",
    "pulldownRefresh": "下拉刷新",
    "MarginCallFailed": "追加保证金失败",
    "realNameFormatError": "真实姓名不能包含空格",
    "search": "搜索",
    "successfulPurchase": "购买成功",
    "minimumAdditionalAmount": "最低追加金额",
    "savingToLocal": "正在保存到本地，请稍后...",
    "submitOrder": "提交订单",
    "noMembersInGroup": "群组中没有成员",
    "pleaseInput": "请输入{title}",
    "EmptyAllocationMultiple": "请选择配资倍数",
    "close": "关闭",
    "siteService": "上门服务",
    "accountLocked": "此账号被禁用",
    "bomdMessage": "恭喜{user_name}发包中雷获得{loss_amount}{currency}",
    "balanceNotEnough": "您的账户余额不足",
    "yuan": "元",
    "recordNotExist": "记录不存在",
    "fractionalSharesCannotSplitAndSold": "零股部分（不足100股），不可拆分卖出",
    "resendError": "请在5分钟后再发送验证码",
    "redpacketMessage": "恭喜发财，大吉大利",
    "insufficientQuantity": "股票不足",
    "successfullyJoinSelfSelectedStock": "加入自选股成功",
    "language": "语言",
    "minimumBillingCycleTwoDays": "结算的周期最低为两天",
    "sendFail": "发送失败",
    "youHaveEntrustedOrdersThatNotProcessed": "你有委托订单未处理，暂时无法结算",
    "female": "女",
    "saveFailed": "保存数据失败",
    "buyStock": "该子账户资金不足",
    "FailedRevokeAnOrder": "一键撤销委托失败",
    "bonusMessage": "恭喜{user_name}获得红包奖励{bonus_amount}",
    "OrderHavePendingEntrust": "有未完成委托订单，请处理后再操作平仓。",
    "enterTheAdditionalAmount": "请输入追加金额",
    "insufficientTradableQuantityToday": "今日可交易数量不足",
    "yourfundbalanceisinsufficient": "你的资金余额不足",
    "wrongChoiceOfAllocationMultiple": "配资倍数选择错误",
    "shortBuyPriceConfigOthersShouldBeTheRange": "主板卖空交易（针对其他用户）的限价水平应处于该范围内。",
    "noRepeatSubmit": "请求已在处理中",
    "pleaseAddCategory": "必选信息类型",
    "success": "操作成功",
    "FriendCouponLogFailed": "好友优惠券登录失败",
    "minimumRiskMargin10万": "最少风险保证金10万",
    "existingRefCodeError": "参考代码已经存在",
    "SendVouchersInBatchFailed": "批处理送代金券失败！",
    "didNotPassTheUniqueIdOfTheFund": "没有传递配资唯一标示",
    "redpacketPickedBombMessage": "{user_name} get packet amount {amount}{currency} and you got bomb bonus of{loss_amount}{currency}",
    "FailedToModifyMobileNumber": "修改手机号码失败",
    "loadFail": "加载失败",
    "selectLanguage": "选择语言",
    "shopService": "到店服务",
    "phoneError": "手机格式不对",
    "notRegistered": "此账号未注册",
    "appName": "快乐人生",
    "toDate": "结束日期",
    "onePriceBoardShortOpenLocked": "一字板限制期间，暂不可做空开仓",
    "onePriceBoardLockDaysInvalid": "锁仓天数必须大于等于0",
    "sellingQuantityMustBeMultipleHundred": "出售数量须为100的倍数",
    "inputConfirm": "请输入确认{title}",
    "home": "首页",
    "recharge_overMinLimit": "充值额度不在允许范围内",
    "buyPriceConfigShouldBeTheRange": "做多上限价位应当是该范围",
    "rechargeConfirmation": "充值申请已提交",
    "BatchProcessingSuccessful": "首充活动批处理成功",
    "csvMissingShortColumn": "CSV文件缺少 short 列！",
    "emailCodeSent": "安全密码发送到邮箱",
    "pleaseSelect": "请选择",
    "notFound": "没有找到相关数据",
    "FriendCouponFailed": "好友优惠券失败",
    "buyPriceConfigValidNum": "输入长度为 个字符（不包括符号）的有效数量",
    "rechargeConfirmationOperationFailed": "充值确认操作失败",
    "select": "选择",
    "fileReadFailed": "无法读取文件！",
    "freezeQuantity": "冻结数量",
    "freezeStatusError": "该股票已被冻结，请联系客服处理",
    "captchaError": "验证码错误",
    "CreateUserAgentFailed": "创建用户代理失败",
    "theAccountOpeningNameInconsistentWithVerificationName": "开户姓名与认证姓名不一致",
    "payType": "支付方式",
    "orderSuccess": "下单成功",
    "registerProtocol": "注册协议",
    "EntrustedOrderNotExist": "委托订单标示不存在",
    "SuccessfullyModified": "修改成功",
    "releaseRefresh": "释放更新",
    "closeLeft": "关闭左侧",
    "IncorrectCapital": "此子账户已结算",
    "user_name_empty": "输入你的名字",
    "shortPoolUploadSuccess": "操作成功，共匹配更新 {updated} 条股票。",
    "loading": "加载中...",
    "uniqueIdentifierFundDoesNotExist": "配资唯一标示不存在",
    "noRecord": "~ 空空如也 ~",
    "insertSuccess": "添加成功",
    "noMatchedStockShortCodes": "上传的股票短语均不存在！",
    "allPendingOrdersProcessed": "所有待处理订单均已处理",
    "orderNow": "立即下单",
    "yourFundingAccountHasInsufficientFunds": "您的配资账户资金不足",
    "csvFileLabel": "CSV文件:",
    "tradingProhibitStockBelowLimit": "股票跌停板禁止交易",
    "deleteOptionalSuccess": "删除自选成功",
    "noUserFoundForThisIdAndGroupId": "找不到该 ID 和 GroupId 的用户",
    "purchaseQuantityMustBeGreaterThanOrEqualToHundred": "购买数量必须大于等于100",
    "parameterNameShouldBeUnique": "这个参数已存在的，参数名称一定要独一无二的",
    "use_different_approval_type": "使用其他提款审批类型",
    "confirmCalculateProfitLoss": "是否计算盈亏? ",
    "EnterAdditionalAmount": "请输入追加金额",
    "alreadyRealNameTriedThreeTimes": "请联系客服协助实名认证",
    "accountHasInsufficientFunds": "你的账户资金不足",
    "bankIsNotOpenYet": "此银行暂未开放",
    "fundingInformationDoesNotExist": "配资信息不存在",
    "privacyPolicy": "隐私政策",
    "failedToAddFunds": "追加配资失败",
    "onePriceBoardType0": "无",
    "SendCashInBatchFailed": "批处理送现金失败！",
    "onePriceBoardType2": "跌停一字板",
    "appUseRule": "使用守则",
    "onePriceBoardType1": "涨停一字板",
    "updateSuccess": "更新成功",
    "FundSettlementSuccessful": "配资结算成功",
    "OperationFailed": "手术失败",
    "Platform_ios": "苹果版",
    "purchasesScienceTechnologyGreaterEqualTwoHundred": "科创板购买数量必须大于等于200",
    "accountDisabled": "此帐号已停用",
    "bankNameCannotBeEmpty": "银行名称不能为空",
    "alreadyAuthenticated": "已经实名认证",
    "shortBuyPriceConfigOthersMainBoardShouldBeTheRange": "做空科创/创业板下限价位（其他用户）位应当是该范围",
    "timebaoAccountCreateFailed": "时光宝账户创建失败",
    "fundSettlementSuccessful": "配资结算成功",
    "failedPurchase": "购买失败",
    "alreadyAddedToThisGroup": "用户已添加到该组",
    "wrongNameIDFormat": "请联系客服",
    "stockNotOpenYet": "暂未开放此股票",
    "uniqueIdentifierOfTheFundDoesNotExist": "配资唯一标示不存在",
    "download": "下载",
    "CreateUserCouponFailed": "创建用户优惠券失败",
    "yuanVoucher": "元代金券",
    "interestCalculationFailed": "利息计算失败",
    "readAndAgree": "阅读并同意",
    "shortBuyPriceConfigOthersUpShouldBeTheRange": "做空主板上限价位（其他用户）的限价水平应处于该范围内。",
    "closeAll": "关闭全部",
    "refcodeNullError": "参考代码不能为空",
    "purchasePriceFormatError": "购买价位格式错误",
    "parameterError": "参数不正确",
    "itemValue": "选项值",
    "UserAccountAddLogFailed": "在用户帐户中添加日志失败",
    "FundTransferSuccessful": "资金划转成功",
    "reservedcontent": "保留内容",
    "MinimumBillingCycle": "结算的周期最低为两天",
    "ok": "确认",
    "SuccessfulMarginCall": "追加保证金成功",
    "changeLanguage": "切换语言",
    "notExists": "代码不存在",
    "AdditionalAmountFormatError": "追加金额格式错误",
    "selectAddress": "选择地址",
    "changePassword": "修改密码",
    "commissionFailed": "委托失败",
    "additionalFundsReceived": "追加配资收取",
    "AddFundsError": "追加配资失败",
    "successfulMarginCall": "追加保证金成功",
    "unauthorized": "没有授权，请重新登录",
    "shortPoolCsvTip": "注：CSV第一行需包含 short 列，下列每行填写一个股票短语（如 sh600036）。",
    "FailedtofindAgent": "找不到代理的用户 ID 不正确",
    "wrongPurchasePrice": "购买价格错误",
    "loadEnd": "-- 没有更多数据 --",
    "fundSettlementIsSuccessful": "配资结算成功",
    "EmptyRiskMargin": "请输入风险保证金",
    "minimumAdditionalAllocationAmountForOneTime": "次最低追加配资金额",
    "ForgetPasswordPhoneCodeFail": "手机验证码无效",
    "networkfail": "请切换线路后重试",
    "itemName": "选项名称",
    "deductedFromGiftVoucher": "从赠送代金券中扣除",
    "passwordNullError": "密码不能为空",
    "EnteringRiskMarginFailed": "请输入风险保证金",
    "loadSuccess": "加载成功",
    "notAllowForClosingThisCapital": "你有持仓订单未处理，暂时无法结算",
    "invalidEmail": "不合规邮箱",
    "addressOverMax": "已达到地址上限",
    "PositionInformationNotExist": "持仓信息不存在",
    "edit": "编辑",
    "accountNameCannotBeEmpty": "开户姓名不能为空",
    "maximumRiskMargin": "超过最大风险保证金",
    "additionalAllocationAmountLessThanZero": "追加配金额不能必须小于0",
    "TypeError": "类型错误",
    "FundingInformationNotExist": "配资信息不存在",
    "redpacketPickedMessage": "{user_name}抢得红包{amount}{currency}",
    "male": "男",
    "FriendCashCouponIssuedFailed": "该好友现金券已发放",
    "onePriceBoardType22": "跌停一字板(已检测)",
    "redPacketFinish": "红包完成",
    "getCurrentDataFailed": "当前数据不可用",
    "saveFail": "保存数据失败",
    "additionalAllocationAmountMultipleOfHundred": "追加配资金额必须为100的倍数",
    "firstOfAllTheRealNameAuthenticationCanBindTheBankCard": "首先实名认证才能绑定银行卡",
    "sendSuccess": "发送成功",
    "insufficientFunds": "你的账户资金不足",
    "accountAbnormalPleaseContactCustomerService": "此账户异常，请联系客服",
    "onePriceBoardType11": "涨停一字板(已检测)",
    "ForgotPasswordInvalidVerificationCode": "无效验证码",
    "LoginFailed": "登录失败",
    "closeDataFailed": "关闭数据功能失败",
    "mobile_code_sent": "安全密码发送到手机",
    "salePriceFormatError": "出售价位格式错误",
    "confirm": "确 认",
    "LoginUserNotExist": "您的账号或密码不正确，请重新输入",
    "managementFee": "管理费",
    "fundingApplicationFailed": "配资申请失败",
    "WithdrawalApplicationSuccessful": "提现申请成功",
    "to": "至",
    "googleAuthFail": "谷歌验证码错误",
    "operation": "操作",
    "understood": "我已了解《{title}》",
    "enterTheStockCode": "请输入股票代码",
    "rechargeHasBeenSuccessful": "充值申请已提交",
    "additionalFundingSuccessful": "追加配资成功",
    "captcha": "验证码",
    "FailedCancellingCommissionOrder": "撤销委托订单失败",
    "EntrustedOrderDoesNotExist": "委托订单标示不存在",
    "details": "查看详情",
    "recharge_overMaxLimit": "充值额度超过允许限制：{max_amount}",
    "IncorrectAmount": "您输入的金额有误",
    "MobileNumberIncorrect": "手机号码格式不正确",
    "insertError": "插入记录失败",
    "codeCannotBeEmpty": "代码不能为空",
    "LoginPasswordFailed": "密码为空",
    "repeatPickSamePacket": "您已经抢过这个红包",
    "CancelledOrderNotExist": "撤销委托订单不存在",
    "yourAccountHasInsufficientFunds": "你的账户资金不足",
    "areacodeMissing": "需要区域代码",
    "youHaveUnprocessedPositionOrders": "您有未处理的持仓订单，暂时无法结算",
    "selectDistributionOrder": "请选择配资订单",
    "deleteFailed": "删除失败",
    "MobileNumberNotRegistered": "手机号码尚未注册",
    "noSpacesAllowed": "参数不能包含空格",
    "reentry": "确认",
    "signSucessfully": "签到成功,恭喜您获得",
    "AmountNotMultipleOf100": "追加配资金额必须为100的倍数",
    "shortBuyPriceConfigShouldBeTheRange": "做空科创/创业板上限价位",
    "currencyDefaultError": "只能有一个默认货币",
    "bankCardNumberFormatError": "银行卡号格式错误",
    "updateFailed": "更新失败",
    "noBalance": "没有余额",
    "failedToTransferFundsOut": "资金转出失败",
    "passwordError": "账号密码错误",
    "switchOn": "开启",
    "addLanguage": "添加语言",
    "getAddress": "获取地址",
    "updateError": "更新失败",
    "summary": "合计",
    "confirmUpload": "确认上传",
    "agentDailyDepotSaveFailed": "代理每日仓库保存失败",
    "fundingApplicationSuccessful": "配资申请成功",
    "cancelAllPendingOrders": "取消全部未处理订单?",
    "stockStopError": "此股票今日限制交易",
    "deleteConfirm": "确认删除吗？",
    "thePurchaseQuantityIsMultipleOfHundred": "购买数量为100的倍数",
    "privacyProtocol": "隐私协议",
    "currentAgentOffline": "代理当前处于离线状态，是否要重新连接到另一个代理",
    "unprocessed_red_envelope_delivery_order": "请先处理该用户的未处理的派送现金红包订单之后再处理兑现订单。",
    "successfulWithVoucher": "登录成功，恭喜您获得优惠券",
    "NoPromotionCode": "没有推广码,请联系客服",
    "LoginNameFailed": "号码为空",
    "differentTransactionTimeStatus": "系统交易繁忙，请稍后再试",
    "ForgetPasswordPhoneNumberEmpty": "电话号码为空",
    "tradingOfThisStockIsSuspended": "此股票暂停交易",
    "initializeEffectivePrincipal": "初始化有效本金",
    "InsufficientFunds": "你的账户资金不足",
    "withdrawalpasswordenteredincorrectly": "提现密码输入错误",
    "chooseCsvFile": "Choose File",
    "selectCsvFile": "请选择CSV文件！",
    "noPermission": "没有权限",
    "successfulSell": "出售股票成功",
    "userInterestCalculationHasCalculated": "该用户利息计算已计算",
    "systemName": "WONDER后台管理系统",
    "noFileChosen": "No file chosen",
    "confirmUpdateCurrentStockPrice": "您想更新股票的当前价格吗？",
    "UserAccountAddCouponLogFailed": "无法将优惠券日志添加到用户帐户",
    "multiBombBonusMessage": "恭喜用户{user_name}获得多雷奖金{bonus_amount}{currency}",
    "pleaseEnterTheStockCode": "请输入股票代码",
    "fail": "操作失败",
    "ProfitShareFailed": "利润分享功能失败",
    "withdrawalpasswordexceeded": "由于您连续输入错误密码达到三次，系统已暂时锁定。请10分钟后再试",
    "enterCorrectAmount": "请输入正确的金额",
    "failedDeleteOptional": "删除自选成功",
    "reset": "重置",
    "submitting": "提 交 中...",
    "mapDataError": "获取地址信息不正确",
    "balanceLow": "余额不足",
    "AdditionalAmountLessThan0": "追加金额不能小于0",
    "updateApp": "新版本可用请更新",
    "min_with_amt": "最低提现金额是100元",
    "Platform_android": "安卓版",
    "interestCalculatedSuccessfully": "利息计算成功",
    "nameNullError": "姓名不能为空",
    "existingNameError": "名称已存在",
    "existingRecord": "Existing record",
    "deleteSuccess": "删除成功",
    "signSuccessfully": "登录成功，恭喜您获得",
    "yourAccountBalanceIsInsufficient": "你的账户余额不足！",
    "emptyCaptcha": "请输入图片验证码",
    "fundTransferFailed": "资金转入失败",
    "closeRight": "关闭右侧",
    "enterTheSaleQuantity": "请输入出售数量",
    "unfrozenQuantity": "解冻数量",
    "unprocessed_redemption_order": "请先处理该用户的未处理的兑现订单之后再操作派送现金红包。",
    "codeError": "操作失败",
    "shortBuyPriceConfigOthersMainBoardUpShouldBeTheRange": "做空科创/创业板上限价位（其他用户）位应当是该范围",
    "timebaoMoveInSuccessfully": "系统提示：时时宝转入成功",
    "shortBuyPriceConfigMainBoardUpShouldBeTheRange": "做空科创/创业板上限价位应当是该范围",
    "purchaseQuantityFormatError": "购买数量格式错误",
    "InsufficientBalance": "您的账户余额不足",
    "clearCache": "清除缓存",
    "shortBuyPriceConfigUpShouldBeTheRange": "做空主板上限价位应当是该范围",
    "NoEntrustmentInformationFound": "没有委托信息",
    "priceUpdateNotAllowedCurrentTime": "当前时间不允许更新价格",
    "stockIsTemporarilyUnavailableForTrading": "股票暂时无法交易",
    "withdrawPasswordNotset": "提现密码未设置",
    "marginCallFailed": "追加保证金失败",
    "from": "从",
    "buyPriceConfigFailed": "必填0-10，数字不允许超过一位小数。",
    "keepcontent": "是否保留内容",
    "App_download_title": "立即下载APP",
    "ThirdPartyUpdateFailed": "请确认是否有第三方已经做了更新！",
    "minimumRiskMargin": "低于最低风险保证金",
    "AlreadysubmittedOrderError": "已经提交订单",
    "additionalAmountFormatError": "追加金额格式错误",
    "failed": "失败的",
    "noUsersToDeleteForThisGroupID": "该组 ID 没有可删除的用户",
    "invalidCode": "兑换码无效",
    "fromDate": "开始日期",
    "bankCardNumberCannotBeEmpty ": "银行卡号不能为空",
    "LoginUserFailed": "登录用户被阻止",
    "addLanguageImage": "添加多语言图片",
    "failedAddSelfSelectedStocks": "加入自选股失败",
    "invitation_link": "邀请链接",
    "accountIsAbnormalPleaseContactCustomerService": "此账户异常，请联系客服",
    "nonTradingDay": "欢迎签到，今天是非交易日",
    "accountExpiresProhibitBuying": "此账户到期，禁止买入",
    "orderRule": "下单须知",
    "noValidStockShortCodes": "CSV文件中没有有效的股票短语！",
    "buyPriceConfigOthersShouldBeTheRange": "做多上限价位 （其他用户）应当是该范围",
    "withdrawAccountRequired": "to withdraw bank or wallet is required",
    "StockFrozenError": "该股票已被冻结",
    "alreadyDeleted": "用户已删除",
    "stock_suspended_for_trading": "当前停止收单",
    "UserAccountUpdateFriendCouponFailed": "无法更新用户帐户中的好友优惠券",
    "realNameVerified": "申请实名认证成功",
    "flowLogRemark": "从 {remark}",
    "DistributionOrderNotSelecte": "请选择配资订单",
    "FailedToPlaceAnOrder": "下单失败，大额定金请联系在线客服",
    "selectUploadCsvFile": "请选择要上传的CSV文件！",
    "switchOff": "关闭",
    "marketClosed": "休市时间,无法交易",
    "WithdrawalRequestFailed": "请输入代理提现金额",
    "deleteHint": "删除提示",
    "OperationSuccess": "操作成功"
  },
  "agentTransferWithdraw": {
    "cancel": "取消",
    "fundMembership": "资金到您的会员账号?",
    "sure": "确定",
    "isIt": "吗?",
    "confirmWithdraw": "确认提现",
    "back": "返回",
    "bindBank": "还未绑定银行卡,请前去绑定银行 卡才可提现",
    "withdrawPassword": "请输入提现密码",
    "withdrawOrTransfer": "提现/划转",
    "confirm": "确认划转",
    "areYouSure": "您是否确定划转",
    "transfer": "划转",
    "balance": "账户余额",
    "fundTransfer": "资金划转：资金从推广账户划 转到会员账户，即时到账。",
    "withdrawConfirm": "您是否确定提现",
    "withdrawOrTransferAmount": "提现/划转金额",
    "enterAmountLable": "请输入提现/划转金额",
    "withdraw": "提现",
    "amountIncorrect": "您输入的金额有误"
  },
  "operate": {
    "findByWeek": "按周配资",
    "intrestFree": "免息配资",
    "findByDay": "按天配资",
    "vipAllocation": "VIP配资",
    "fundBelowWarning": "当总配资资金低于预警线以下时，只能平仓不能建仓",
    "fundbelowLiquidation": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足",
    "monthlyAllocation": "按月配资"
  },
  "field": {
    "Job_cron_expression": "cron执行表达式",
    "Home_id": "编号",
    "Baseconfig_VCOTC_Pay_app_key": "VCOTC支付商户号",
    "Entrust_name": "证券名称",
    "AgencyDailyAccount_id": "编号",
    "Activity_bond": "风险保证金",
    "UserAccount_account": "账户资金",
    "RechargeType_message": "备注",
    "Activity_balance": "剩余",
    "ChatHistory_type": "类型",
    "DepotSimulate_type": "持仓类型 0:A仓 1:B仓",
    "User_token_time": "TOKEN时间",
    "UserCoupon_user_real_name": "姓名",
    "Entrust_order": "订单号码",
    "JobLog_invoke_target": "调用目标字符串",
    "Withdraw_agent": "代理ID",
    "Deal_com_cost": "佣金成本",
    "UserSimulate_encrypt_phone": "加密手机号",
    "Baseconfig_app_ios": "IOS下载链接",
    "VoucherCash_remark": "备注",
    "VoucherCash_user_real_name": "姓名",
    "Baseconfig_stock_price_times_short": "做空强制平仓倍数",
    "StockFeeLog_create_time": "委托时间",
    "AgentFinance_staff": "员工id",
    "Deal_number": "成交数量",
    "CapitalLog_capital": "配资id",
    "Baseconfig_withdraw_wake_sound": "提现提示声音",
    "EntrustSimulate_entrust_time": "委托时间",
    "Entrust_mold": "操作类型 1 买入 2市价买入",
    "DealSimulate_deal_time": "成交时间",
    "Home_Register_today ": "今日注册(实名)",
    "Activity_name": "活动名称",
    "Baseconfig_popup_mobile_content": "手机弹窗",
    "AgentDeferred_agent_phone": "代理电话",
    "ChatGroupMember_status": "地位",
    "AgentDailyDepot_partner_id": "合作伙伴ID",
    "Agentdailydepot_real_name": "代理商名称",
    "Entrust_stamp_cost": "印花税成本",
    "DepotSimulate_buy_total": "买入总价值",
    "TimebaoLog_id": "编号",
    "AgentManage_mother": "母账户",
    "TimebaoAccount_totalamount": "转入合计",
    "Depot_surplus": "剩余可用",
    "AgencyDailyAccount_agent": "上级id",
    "UserCoupon_id": "编号",
    "UserLevel_create_time": "创建时间",
    "StockFeeLog_name": "证券名称",
    "PowerInterest_jly_tb_zz": "净利润同比增长%",
    "CapitalLog_create_time": "创建时间",
    "News_type": "类型",
    "NewCapitalTest_agent": "代理id",
    "NewCapitalTest_trade_status": "交易状态",
    "Baseconfig_chat_socket_domain": "客服SOCKET",
    "UserAccount_first_trans_date": "最初交易日",
    "DealSimulate_status": "状态",
    "UserAccount_stamp_total": "印花税",
    "Capital_total": "可用金额",
    "Agent_agent": "上级代理",
    "UserCoupon_recharge_id": "充值编码",
    "AgentReserve_data": "模板信息",
    "Protocol_update_time": "更新时间",
    "CoreSet_manage_fee_cupon_ratio": "代金券可用百分比",
    "QuickReply_category": "类别",
    "User_agent": "代理ID",
    "User_agent_nick": "上级昵称",
    "Help_update_time": "修改时间",
    "CapitalType_multiple": "配资倍数",
    "AgencyDailyAccount_system_deferred_total": "总递延费",
    "UserCoupon_coupon_type": "现金券类型",
    "Baseconfig_withdraw_refresh_interval": "提现刷新间隔秒",
    "Entrust_plus_fee": "加收费用",
    "AgencyDailyAccount_name": "姓名",
    "lastMsgImage": "图像",
    "ChatGroupMessageLog_type": "类型",
    "ChatGroup_avatar": "头像",
    "FlowType_name": "流水类型",
    "ChatHistoryData_receiver": "接收者",
    "AgentFinance_upagent": "上级代理",
    "User_update_time": "修改时间",
    "Baseconfig_withdraw_fee_fixed": "提现手续费",
    "UserBank_status": "1正常2删除",
    "Baseconfig_huhui_comment1": "免息说明1",
    "Baseconfig_huhui_comment2": "免息说明2",
    "Baseconfig_withdraw_fee_rate": "提现手续费比例",
    "AgentAccount_finance_total": "财务利息",
    "UserSimulate_core_set": "用户费用模版",
    "Entrust_entrust_id": "委托单号",
    "UserAccount_user_name": "昵称",
    "NewCapitalTest_sms_num": "短信发送数量",
    "UserSimulate_user_account_account": "资金",
    "VoucherManagement_create_time": "创建时间",
    "NewCapitalTest_frozen": "冻结资金",
    "Baseconfig_huhui_comment_short2": "空头免息说明2",
    "Baseconfig_huhui_comment_short1": "空头免息说明1",
    "RechargeType_status": "状态",
    "CustomerAgent_md5_phone": "MD5加密",
    "VoucherCash_create_time": "创建时间",
    "Deal_user_phone": "电话",
    "InterestLog_type": "类型",
    "FriendCoupon_friend_uid": "使用好友ID",
    "UserAccount_rec_total": "累计充值",
    "UserSimulate_email": "用户邮箱",
    "DepotSimulate_cost_total": "剩余成本价值",
    "Baseconfig_smsplannet_secretkey": "smsplannet_secretkey",
    "Baseconfig_taiseiRecharge_secret": "大成密钥",
    "CoreSet_capital_interest_week_per": "按周配资利息",
    "PowerInterest_net_assets_per_share": "每股资产净值",
    "AgentAccount_trade_fee": "交易佣金",
    "Stock_region": "地区",
    "Baseconfig_company_name": "公司名",
    "mobileNumber": "手机号码",
    "selectable": "选填",
    "CoreSet_extra_fee3": "平台费",
    "CoreSet_extra_fee2": "结算费用",
    "CoreSet_extra_fee1": "产品处理费",
    "VoucherManagement_cid": "策略ID",
    "AgentDeferred_user_number": "编号",
    "Total_profit": "总盈亏",
    "AgentFinance_agent": "代理商id",
    "FriendCouponLog_balance": "当前余额",
    "AgentReserve_id": "编号",
    "InterestLog_cost": "成本金额",
    "Capital_frozen": "冻结资金",
    "Agentdailydepot_user_team": "用户数量",
    "NewCapitalTest_manage": "管理费",
    "Baseconfig_stock_price_times": "做多强制平仓倍数",
    "AgentAccount_trade_total": "交易金额",
    "UserAccount_voucher_management": "平台赠送管理费",
    "UserLevel_name": "说明",
    "News_title": "新闻标题",
    "UserBank_name": "银行名称",
    "Home_upload_replace": "覆盖原图",
    "Stock_pclose": "昨日收盘价",
    "AgentFee_staff": "员工id",
    "Baseconfig_copyright": "站点版权",
    "Minus_approved_by": "批准人",
    "AgentFlowLog_voucher": "代金券",
    "Depot_user_real_name": "姓名",
    "AgentDivide_upagent": "上级代理",
    "Deal_stamp_cost": "印花税成本",
    "TimebaoAccount_interestamount": "利息合计",
    "ActivityNotice_content": "内容",
    "ChatHistory_sender": "发件人",
    "Baseconfig_app_download_popup_show": "是否显示APP下载",
    "User_login_time": "登录时间",
    "LanguageField_id": "编号",
    "DepotSimulate_id": "编号",
    "ChatGroupMember_create_time": "创建时间",
    "Home_Total_Deposit": "保证金",
    "open_or_close_position": "仓位开平",
    "Agentdailydepot_encrypt_phone": "加密手机号",
    "Stock_short_close_prohibit_status": "做空买ST和*ST股",
    "DealSimulate_mold": "操作类型 1 买入 2市价买入",
    "AgentFee_id": "编号",
    "AgentDailyDepot_day": "日期",
    "Baseconfig_is_web_pc_coupon_popup": "is_coupon_popup",
    "Withdraw_currency": "提现货币",
    "Agentdailydepot_uid": "用户ID",
    "UserSimulate_is_trade_channel_agree": "代理通道",
    "EntrustSimulate_deal": "委托价位",
    "DealSimulate_name": "证券名称",
    "Recharge_to_address": "收款账户/地址",
    "ascending": "上升",
    "Stock_industry": "行业",
    "DepotStop_cost": "持仓成本",
    "userNewCard": "身份证号",
    "Baseconfig_sms_format": "短信发送格式",
    "FoundWinners_focus_price": "关注价",
    "Capital_depot": "持仓成本资金",
    "Baseconfig_home_profit_banner": "用户中心背景",
    "VoucherCash_user_caller": "客服专员",
    "ChatHistory_create_time": "创造时间",
    "ChatHistoryData_status": "是否撤回",
    "TimebaoAccount_interestyear": "本年利息",
    "EntrustSimulate_agent": "代理id",
    "Baseconfig_ip_white": "ip白名单",
    "UserAccount_mutual_capital": "互惠配资",
    "VoucherCash_admin": "操作员",
    "PowerInterest_id": "编号",
    "AgentFlowLog_type": "类型",
    "Agentdailydepot_day": "日期",
    "DepotSimulate_cost": "持仓成本",
    "AgentDailyDepot_uid": "用户ID",
    "NewCapitalTest_real_profit_loss": "实际盈亏",
    "Parameter_language": "使用语言",
    "UserAccount_trade_total": "交易总额",
    "VoucherManagement_id": "编号",
    "Trade_total": "总买入额",
    "Recharge_sure_time": "用户确认时间",
    "UserSimulate_last_time": "最后登录时间",
    "AgentDeferred_upagent": "上级代理",
    "UserBank_card": "银行卡号",
    "CustomerAgent_create_time": "创建时间",
    "DepotSimulate_cancel": "取消数量",
    "Baseconfig_ucpass_token": "云之讯鉴权token",
    "Agent_number": "代理商编号",
    "Stock_stock_value": "市值",
    "User_bank": "绑定银行",
    "AgencyDailyAccount_agent_name": "代理名称",
    "InterestLog_capital_capital_name": "产品类型",
    "CoreSet_popup_status": "是否显示弹窗",
    "PowerInterest_mg_gjj": "每股公积金",
    "Deal_mother": "母账户id",
    "direction_capital": "配资仓位方向",
    "UserAccount_update_time": "更新时间",
    "Recharge_pay_time": "回调时间",
    "Home_Number_of_positions ": "持仓人数",
    "FoundWinners_changepercent": "最大涨幅",
    "User_real_name": "真实名称",
    "AgentDailyDepot_phone": "手机号",
    "FoundWinners_focus_time": "关注价时间",
    "AgentManage_number": "交易数量",
    "DepotSimulate_user_real_name": "姓名",
    "VoucherCash_agent": "代理ID",
    "direction": "仓位方向",
    "CompanyBank_bank_name": "银行名",
    "Withdraw_to_amount": "提现数量",
    "Baseconfig_short_buy_price_config_main_board": "做空科创/创业板下限价位",
    "DealSimulate_create_time": "交易时间",
    "ChatGroup_type": "类型",
    "FlowLog_user_caller": "客服专员",
    "Baseconfig_is_real_name_popup": "未实名弹窗开关",
    "Baseconfig_is_short_trading_enable": "是否开启做空交易",
    "Entrust_remark": "备注信息",
    "Sameday_delivery_margin": "当天交割保证金",
    "UserSimulate_card": "身份证号",
    "Baseconfig_pc_winner_logo_2_inactive": "牛人牛股 logo 未选",
    "AgentFinance_vouchers": "代金券",
    "CoreSet_regular": "多头规费",
    "Language_name": "语言名称",
    "ChatGroup_status": "状态",
    "AgentAccount_manage_total": "管理费",
    "FirstVoucher_status": "地位",
    "Home_Unfinished_recharge_amount ": "未完成充值数量",
    "CoreSet_min_capital": "最少追加配资",
    "AgentAccount_user_real_name": "姓名",
    "RechargeType_max_amount": "最高限额",
    "EntrustSimulate_order": "订单号码",
    "Transaction_return_investment_ratio": "交易投资回报比",
    "VoucherCash_type": "类型",
    "Baseconfig_ucpass_url": "云之讯请求URL",
    "CapitalLog_order": "订单编号",
    "QuickReplyCategory_status": "姓名",
    "PlusMinusType_name": "类型",
    "AgencyDailyAccount_fee_total": "手续费",
    "Closed_explain": "说明",
    "VoucherCash_activity_id": "活动",
    "AgentFee_agent": "代理id",
    "Minus_type": "类型",
    "NewCapitalTest_capital_type": "类型 ",
    "Closed_id": "编号",
    "AgentWithdraw_status": "状态",
    "Home_Profit_real_new_on_day": "当天实际交割盈亏",
    "CapitalType_warning": "预警线%",
    "TimebaoLog_starttime": "利息开始时间",
    "AgencyDailyAccount_partner_ref_code": "合作伙伴参考代码",
    "EntrustSimulate_change_cost": "过户费、成本",
    "Code": "代码",
    "AgentAccount_version": "Version",
    "Baseconfig_timebao_rate": "时时宝利率",
    "ChatHistoryData_create_time": "创建时间",
    "Stock_buy_prohibit_status": "做多买ST和*ST股",
    "Capital_display_profit_loss": "盈亏*",
    "Home_frozen_total": "冻结总量",
    "DepotSimulate_update_time": "修改时间",
    "withdraw_approved": "提现成功",
    "Baseconfig_short_buy_price3": "卖三",
    "Baseconfig_short_buy_price1": "卖一",
    "Baseconfig_short_buy_price2": "卖二",
    "Language_remark": "备注",
    "Stock_short_code": "数字代码",
    "NewCapitalTest_increase_bond": "追加保证金",
    "Recharge_type": "接口类型",
    "UserSimulate_reid": "推荐人",
    "UserSimulate_name": "昵称",
    "User_activity1": "活动1",
    "ChatHistory_receiver": "接收者",
    "User_alipay": "支付宝",
    "AgentAccount_month_capital": "月配资",
    "Language_is_default": "是否默认",
    "CompanyBank_account_name": "账户名",
    "Entrust_mother": "母账户",
    "VoucherCash_approved_time": "批准时间",
    "User_login_ip_location": "IP归属地",
    "ChatHistoryData_id": "序列号",
    "CoreSet_profit_divide_ratio": "免息分成",
    "FeeLog_capital_order": "策略合约",
    "UserSimulate_token_time": "TOKEN时间",
    "AgentAccount_free_trade_total": "免息交易金额",
    "FoundWinners_id": "编号",
    "VoucherManagement_user_caller": "客服专员",
    "Normal": "普通模式",
    "Plus_exchange": "汇率",
    "Depot_order": "订单编号",
    "Home_Number_of_first_depositors_day ": "当天首存人数",
    "UserVip_id": "编号",
    "UserAccount_first_voucher": "最高满足那一档",
    "CapitalLog_balance": "剩余",
    "DepotSimulate_order": "订单编号",
    "DealSimulate_com_cost": "佣金成本",
    "Capital_increase_bond": "追加保证金",
    "Divide_total": "免息分成",
    "Baseconfig_chat_domain": "客服域名",
    "Baseconfig_app_versionupdate": "APP更新提示",
    "CustomerAgent_encrypt_phone": "加密手机号",
    "Baseconfig_smsbao_account": "短信包用户",
    "AgentDeferred_deferred": "递延费",
    "Baseconfig_banner4": "APP轮播图4",
    "CapitalType_explain2": "说明2",
    "Baseconfig_banner5": "APP轮播图5",
    "Baseconfig_banner6": "APP轮播图6",
    "Baseconfig_banner1": "APP轮播图1",
    "Baseconfig_banner2": "APP轮播图2",
    "Baseconfig_banner3": "APP轮播图3",
    "TimebaoLog_create_time": "时间",
    "CapitalType_explain1": "说明1",
    "CapitalLog_user_phone": "电话",
    "CapitalLog_agent": "代理id",
    "ActivityNotice_create_time": "创建时间",
    "StockFeeLog_status": "状态",
    "lastvolumn_short": "做空昨日成交量",
    "PowerInterest_total_equity": "总股本",
    "Agent_month": "月配提出",
    "Deal_agent_name": "证券名称",
    "UserBank_withdraw_type": "0 银行卡 1 数字货币",
    "AgencyDailyAccount_manage_total": "管理费",
    "Baseconfig_old_own_chat_link": "老版本专属客服API",
    "Baseconfig_trongrid_url": "Tongrid_Url",
    "Partners_name": "姓名",
    "UserAccount_concern": "我的关注自选",
    "UserControl_id": "编号",
    "Agentdailydepot_total": "日小计",
    "UserAccount_friend_coupon": "好友现金券总额",
    "FeeLog_type": "类型",
    "CompanyBank_id": "编号",
    "SysConfigLog_previous_data": "之前的数据",
    "DepotStop_type": "持仓类型 0:A仓 1:B仓",
    "FriendCoupon_coupon_type": "现金券类型",
    "Job_create_time": "创建时间",
    "CoreSet_capital_interest_free_per": "免息配资利息",
    "UserAccount_buy_fee_total": "购买股票佣金",
    "RechargeType_notice1": "注意事项1",
    "RechargeType_notice2": "注意事项2",
    "RechargeType_notice3": "注意事项3",
    "Baseconfig_recharge_explain": "充值到账说明",
    "TimebaoAccount_uid": "账户ID",
    "DealSimulate_capital": "配资id",
    "Entrust_deal": "委托价位",
    "Entrust_source": "来源 0 手机web 1web端 2补入",
    "AgentFlowLog_order": "订单编号",
    "SMS_phone": "手机号码",
    "User_md5_phone": "MD5加密",
    "News_aid": "管理员信息",
    "EntrustSimulate_cancel": "取消数量",
    "UserAccount_manage_total": "管理费",
    "AgentDivide_agent_real_name": "代理名称",
    "AgentWithdraw_balance": "余额",
    "News_count": "阅读次数",
    "Baseconfig_stock_image_app": "活动横幅Mobile",
    "VoucherManagement_activity_id": "活动",
    "EntrustSimulate_mold": "操作类型 1 买入 2市价买入",
    "DepotStop_code": "证券代码",
    "ChatGroup_create_time": "创建时间",
    "AgentManage_id": "编号",
    "plus_fee_short": "加收费用short",
    "CapitalType_id": "编号",
    "Capital_plus_fee": "加收费用",
    "Deal_user_number": "成交数量",
    "Baseconfig_app_homegif": "APP首页GIF",
    "FlowLog_mother": "母账户id",
    "RechargeType_is_default": "是默认的",
    "Baseconfig_pc_winner_logo_1_inactive": "短线宝 logo 未选",
    "FlowLog_balance": "剩余",
    "User_build_type": "前端类型",
    "CoreSet_recharge_fee_min": "最低充值手续费",
    "withdraw_pending": "等待审核",
    "Withdraw_staff": "员工id",
    "DepotStop_delivery": "配送数量",
    "Depot_id": "编号",
    "NewCapitalTest_times": "自动续费次数",
    "EntrustSimulate_name": "证券名称",
    "AgentAccount_capital_total": "配资金额",
    "UserSimulate_login_time": "登录时间",
    "AgentDeferred_create_time": "交易时间",
    "UserAccount_divide_total": "互惠分成",
    "PowerInterest_ya_ggr_hsr_zf": "预案公告日后10日涨幅%",
    "AgentManage_customer_service": "客服专员",
    "WeekVoucherManagement_ref": "参考",
    "DealSimulate_profit_loss": "盈亏",
    "AgentFee_agent_fee": "代理佣金",
    "CoreSet_stamp_cost": "印花税成本",
    "DealSimulate_plus_fee": "加收费用",
    "VoucherManagement_capital_order": "策略ID",
    "Latest_withdraw": "最新提现",
    "DepotSimulate_day_number": "今日持仓",
    "Stock_trade_short": "是否开启做空交易",
    "AgentFlowLog_agent_real_name": "代理名称",
    "UserBank_province": "省份",
    "RiskControl_create_time": "风控时间",
    "News_img": "图片信息",
    "UserAccount_first_gift": "首充礼包",
    "Recharge_uid": "用户",
    "Baseconfig_own_chat_link_admin": "专属客服 ADMIN",
    "JobLog_id": "编号",
    "NewCapitalTest_order": "单号",
    "CoreSet_sell": "出售交易佣金",
    "Baseconfig_chat_link1": "客服链接1",
    "CapitalLog_entrust": "委托编号",
    "TimebaoLog_user_phone": "电话",
    "AgentDivide_divide": "互惠",
    "UserSimulate_status": "用户状态",
    "Baseconfig_app_android": "安卓APP链接",
    "Baseconfig_buy_price_config": "做多上限价位",
    "Baseconfig_smsplannet_url": "smsplannet_url",
    "Depot_cost_total": "剩余成本价值",
    "DepotSimulate_frozen": "冻结数量",
    "UserControl_lastamount": "昨日成交额",
    "NewCapitalTest_profit_loss": "结算盈亏",
    "Home_title": "配置名称",
    "AgentDeferred_number": "交易数量",
    "Baseconfig_changhongRecharge_url": "长虹支付网关",
    "UserSimulate_token": "token",
    "LanguageField_content": "内容",
    "User_staff": "员工",
    "Baseconfig_taiseiRecharge_callbackurl": "大成回调网关",
    "News_content": "内容",
    "Capital_multiple": "配资倍数",
    "DepotSimulate_code": "证券代码",
    "Manage_total": "管理费",
    "AgentDailyDepot_grade": "代理等级",
    "UserSimulate_md5_phone": "MD5加密",
    "CoreSet_capital_interest_day_per": "按天配资利息",
    "UserBank_city": "城市",
    "FriendCouponLog_friend_uid": "使用好友ID",
    "FlowLog_remark": "备注",
    "Baseconfig_short_buy_price_config": "做空主板下限价位",
    "Plus_create_time": "充值时间",
    "AgencyDailyAccount_divide_total": "互惠分成",
    "Partners_create_time": "创建时间",
    "DepotSimulate_version": "Version",
    "QuickReply_id": "编号",
    "NewCapitalTest_uid": "用户id",
    "UserAccount_user_phone": "电话",
    "AgentManage_upagent": "上级代理",
    "CapitalLog_user_real_name": "姓名",
    "User_safety_password": "安全密码",
    "Baseconfig_third_party_sms_available": "可用第三方短信",
    "Market_profit": "操盘中盈亏",
    "Capital_code": "代码",
    "JobLog_job_group": "任务组名",
    "FeeLog_mother": "母账户id",
    "Agent_id": "编号",
    "Baseconfig_stock_limit_volumn": "限制买卖数量",
    "FlowLog_uid": "用户ID",
    "Baseconfig_android_app_link": "安卓下载链接",
    "TimebaoAccount_real_name": "姓名",
    "AgentManage_create_time": "交易时间",
    "Baseconfig_short_buy_price_config_others_up": "做空主板上限价位（其他用户）",
    "PowerInterest_zg_rate": "转股比例",
    "Agent_update_time": "修改时间",
    "Protocol_count": "阅读次数",
    "DepotStop_transfer": "转送数量",
    "User_agent_number": "上级ID",
    "Deal_shareholder": "股东信息",
    "NewCapitalTest_warning": "预警线",
    "Baseconfig_sms_url": "SMS_URL",
    "Entrust_real_name": "姓名",
    "FeeLog_uid": "用户id",
    "AgentWithdraw_remark": "备注信息",
    "Baseconfig_short_stock_prohibit_message": "禁止做空开仓卖出信息",
    "FriendCoupon_uid": "用户ID",
    "CustomerAgent_password": "密码",
    "PowerInterest_time": "更新时间",
    "Recharge_channel": "充值通道",
    "EntrustSimulate_capital": "配资id",
    "AgentDivide_remark": "备注信息",
    "Baseconfig_pc_winner_logo_3_active": "问财神 logo 已选",
    "InterestLog_agent_fee": "员工返佣",
    "Minus_user_caller": "客服",
    "CoreSet_with_fee": "提现手续费",
    "Entrust_cancel": "取消数量",
    "Baseconfig_company_phone2": "联系电话2",
    "Baseconfig_company_phone1": "联系电话1",
    "Depot_update_time": "修改时间",
    "Baseconfig_app_home_bottom_image_1": "手机底部认证单位 1",
    "EntrustSimulate_source": "来源 0 手机web 1web端 2补入",
    "Deal_change": "过户税",
    "Language_afterfix": "对应字段后缀",
    "Baseconfig_short_buy_price_config_main_board_up": "做空科创/创业板上限价位",
    "Plus_user_real_name": "姓名",
    "Baseconfig_recharge_coupon_web_mobile": "提示好友领现金券手机网页端",
    "Baseconfig_app_home_bottom_image_6": "手机底部认证单位 6",
    "UserSimulate_alipay": "支付宝",
    "FirstVoucher_voucher_management": "送管理费金额",
    "DealSimulate_cost": "卖出价格",
    "Home_Unfinished_withdrawal_amount ": "未完成提现数量",
    "InterestLog_remark": "备注信息",
    "Baseconfig_app_home_bottom_image_2": "手机底部认证单位 2",
    "FlowLog_user_name": "昵称",
    "Baseconfig_app_home_bottom_image_3": "手机底部认证单位 3",
    "Baseconfig_app_home_bottom_image_4": "手机底部认证单位 4",
    "Baseconfig_app_home_bottom_image_5": "手机底部认证单位 5",
    "Plus_remark": "充值备注",
    "Recharge_exchange": "汇率",
    "Agentdailydepot_name": "代理商昵称",
    "AgentDailyDepot_agent_team": "上级姓名",
    "Capital_divided": "利润分成比例",
    "PowerInterest_notice_date": "最新公告日",
    "Minus_approve_time": "批准时间",
    "Depot_day": "停牌天数",
    "FriendCouponLog_friend_coupon_log_type_id": "日志类型",
    "FlowLog_type": "类型",
    "FeeLog_plus_fee": "加收费用",
    "User_we_chat": "微信",
    "FriendCoupon_status": "地位",
    "Baseconfig_email_smtp_host": "SMTP服务器",
    "Recharge_create_time": "充值时间",
    "AgentWithdraw_fee": "手续费",
    "AgentFinance_capital": "配资id",
    "NewCapitalTest_cash": "分红金额",
    "DepotStop_sell_total": "卖出总价值",
    "PowerInterest_reporting_period": "报告日",
    "Stock_type": "股票类型",
    "TimebaoAccount_comment": "备注",
    "CapitalLog_uid": "用户id",
    "UserBank_account": "开户人",
    "AgentFlowLog_upagent": "代理id",
    "Capital_profit": "子户总盈亏",
    "CustomerAgent_number": "帐户",
    "UserSuspect_partner_id": "合作伙伴ID",
    "UserBank_create_time": "时间",
    "Baseconfig_smsbao_api_key": "短信包API_KEY",
    "ActivityNotice_aid": "管理员信息",
    "Baseconfig_timebao_annualized_interest_rate": "时时宝年利率",
    "StockFeeLog_fee": "交易佣金",
    "Stock_concept": "概念",
    "CapitalType_close": "平仓线%",
    "FlowLog_id": "编号",
    "Depot_stock_current_last_close_price": "现价/昨收",
    "DepotStop_cq_cxr": "除权派息日",
    "Capital_buy_fee": "购买股票佣金",
    "Stock_sell": "做多卖",
    "UserLevel_status": "状态",
    "UserControl_stocks": "禁止买入股票列表",
    "Depot_delivery": "配送数量",
    "CoreSet_stamp": "印花税",
    "AgentFinance_type": "0-时时宝 1-定期宝  2-节日宝",
    "oldPhone": "旧手机",
    "UserSimulate_peizi_auth": "配资授权",
    "NewCapitalTest_name": "配资名称",
    "Deal_commission": "交易佣金",
    "HomeConfig_header_prompt_content": "应用程序下载内容",
    "ChatHistoryData_time": "时间",
    "Baseconfig_pc_web_header_description": "网站顶部描述内容",
    "Activity_id": "编号",
    "Parameter_content": "参数字典数据",
    "Job_job_group": "任务组名",
    "Capital_win": "子户赢数",
    "Baseconfig_is_withdraw_popup": "是否开启提现弹窗",
    "Entrust_finish": "完成数量",
    "AgentWithdraw_order": "订单",
    "Withdrawal_risk_control": "出款风控",
    "Entrust_commission": "佣金",
    "DealSimulate_short": "证券短语",
    "UserAccount_voucher_cash": "平台赠送现金",
    "Capital_version": "Version",
    "Partners_id": "编号",
    "AgencyDailyAccount_day": "日期",
    "PowerInterest_short": "证券短语",
    "AgentAccount_divide_total": "互惠分成",
    "Capital_quantity": "数量",
    "CoreSet_regular_short": "空头规费",
    "StockFeeLog_contract": "合约号码",
    "Parameter_module": "模块",
    "Entrust_agent": "代理id",
    "DailyReport_manage_fee": "实际管理费",
    "UserCoupon_create_time": "现金券获取时间",
    "Help_create_time": "创建时间",
    "UserAccount_first_total": "首充金额",
    "DealSimulate_contract": "合同配资编号",
    "User_p_id": "合伙人ID",
    "DealSimulate_entrust": "委托id",
    "AgentWithdraw_id": "编号",
    "Baseconfig_default_chat": "默认聊天",
    "Baseconfig_short_sell_price3": "买三",
    "Stock_stock_value_market": "流通市值",
    "User_status": "用户状态",
    "AgentFlowLog_staff": "员工id",
    "Baseconfig_short_sell_price1": "买一",
    "Baseconfig_short_sell_price2": "买二",
    "extra_fee3_short": "空头平台费",
    "Capital_close": "平仓线",
    "DealSimulate_type": "类型 0买入 1卖出",
    "SMS_content": "内容",
    "UserAccount_agent": "代理id",
    "User_certified_synced": "聊天同步",
    "Baseconfig_coupon": "用户现金券app",
    "UserSuspect_user_id": "用户名",
    "RedEnvelopManagement_user_caller": "客服专员",
    "Entrust_depot_mold": "持仓模式 0:A仓 1:B仓",
    "Entrust_stamp": "印花税",
    "NewCapitalTest_bond": "保证金",
    "InterestLog_user_real_name": "姓名",
    "AgentWithdraw_pay_time": "支付日期",
    "WeekVoucherManagement_create_time": "创建时间",
    "Deal_create_time": "交易时间",
    "DepotSimulate_interest": "税后配息金额",
    "Capital_sms_num": "短信发送数量",
    "Depot_capital_order": "策略合约",
    "QuickReply_status": "状态",
    "Minus_id": "编号",
    "InterestLog_mother": "母账户id",
    "Entrust_change_cost": "过户费、成本",
    "AgentFlowLog_balance": "剩余",
    "Entrust_fee": "费用总计",
    "Activity_title": "图片标题",
    "Capital_create_time": "创建时间",
    "Minus_user_name": "昵称",
    "Capital_fee": "费用",
    "Deal_deal_time": "成交时间",
    "DealSimulate_agent": "代理id",
    "Depot_status": "地位",
    "Capital_trade_status": "交易状态",
    "Home_thumb_type": "缩放类型",
    "Current_total": "当前总资产",
    "Depot_uid": "用户id",
    "Stock_sell_prohibit_status": "做多卖ST和*ST股",
    "DealSimulate_uid": "用户id",
    "Baseconfig_taiseiRecharge_pay_memberid": "大成商户号",
    "CapitalType_time_max": "最大时间",
    "Depot_cost_new": "卖出成本均价",
    "EntrustSimulate_uid": "用户id",
    "Help_img": "图片信息",
    "Deal_change_cost": "过户费、成本",
    "Capital_user_real_name": "姓名",
    "Entrust_short": "证券简码",
    "FriendCoupon_amount": "金额",
    "VoucherManagement_admin": "操作员",
    "I118_name": "名称",
    "RiskControl_type": "风控类型 ",
    "Withdraw_pay_time": "支付日期",
    "User_card": "身份证号",
    "Depot_buy_total": "买入总价值",
    "AgentDailyDepot_user_team": "用户数量",
    "Job_invoke_target": "调用目标字符串",
    "AgentAccount_user_server_total": "服务费",
    "CapitalType_number_max": "最大配资",
    "NewCapitalTest_deferred": "递延费",
    "UserAccount_profit_multiple": "利润倍数",
    "AgentFee_times": "次数",
    "lastamount_short": "做空昨日成交额",
    "PowerInterest_szz_rate": "送转股分总比例",
    "AgentDivide_mother": "母账户",
    "Information_id": "编号",
    "UserSimulate_safety_password": "安全密码",
    "StockFeeLog_total": "交易价值",
    "Agent_user_team": "用户数量",
    "AgentAccount_push_total": "推广费",
    "Baseconfig_red_envelop_cashout_mp3": "红包兑现提醒声音",
    "Baseconfig_app_tab1": "APP菜单1",
    "QuickReply_create_time": "创建时间",
    "Baseconfig_app_tab2": "APP菜单2",
    "Agentdailydepot_agent": "上级代理",
    "UserSimulate_activity1": "活动1",
    "Partners_status": "状态",
    "Baseconfig_app_tab3": "APP菜单3",
    "Withdraw_version": "Version",
    "NewCapitalTest_trade_fee": "交易手续费",
    "EntrustSimulate_change": "过户税",
    "RechargeType_front_show": "前台显示设置",
    "UserSimulate_certified_time": "实名时间",
    "Capital_clear_time": "结算时间",
    "Minus_caller": "客服",
    "VoucherManagement_uid": "用户ID",
    "UserAccount_mother": "母账户id",
    "Baseconfig_aboutus_banner": "关于我们首图",
    "FriendCouponLog_id": "编号",
    "FirstVoucher_amount": "充值金额",
    "JobLog_job_execution_time": "消耗时间 (ms)",
    "AgentFlowLog_number": "数量",
    "FriendCoupon_approve_time": "平台发放时间",
    "DealSimulate_finish": "完成数量",
    "Baseconfig_app_version": "APP版本号",
    "FlowLog_number": "金额",
    "Job_job_name": "任务名称",
    "Baseconfig_short_buy_price_config_main_board_up_des": "注意： 注意必填0到20数字，18表示当日涨幅0%到18%范围内可开仓（问题用户级别>全体用户级别）",
    "AgentDailyDepot_name": "代理商昵称",
    "pleaseAddTheValidCategory": "必选信息类型",
    "DepotSimulate_profit_loss": "当前盈亏",
    "AgentDailyDepot_level2": "下二级持仓",
    "AgentDailyDepot_level1": "下一级持仓",
    "AgentDeferred_remark": "备注信息",
    "AgentDailyDepot_level3": "下三级持仓",
    "Plus_total": "实际金额",
    "Home_thumb_status": "生成缩略图",
    "UserAccount_staff": "员工信息",
    "User_certified_time": "实名时间",
    "Baseconfig_yunma_sms_password": "商务通密码",
    "AgentFee_number": "数量",
    "shortRiskControl": "做空风控",
    "Depot_user_phone": "电话",
    "AgentAccount_mutual_capital": "互惠配资",
    "UserAccount_account_type": "账户类型",
    "Agent_domain": "域名信息",
    "AgencyDailyAccount_account": "帐户",
    "Baseconfig_ios_app_link": "IOS下载链接",
    "User_remark": "备注",
    "UserSimulate_vip": "VIP级别",
    "Baseconfig_short_buy_price_config_others_main_board_up": "做空科创/创业板上限价位（其他用户）",
    "PowerInterest_results_by_date": "股权登记日",
    "EntrustSimulate_depot_mold": "持仓模式 0:A仓 1:B仓",
    "UserSimulate_push_team": "直推团队",
    "AgencyDailyAccount_uid": "uid",
    "DealSimulate_surplus": "剩余数量",
    "RechargeType_sortid": "排序",
    "Agentdailydepot_remark": "备注",
    "User_reid": "推荐人",
    "Depot_short": "证券简码",
    "Recharge_staff": "员工id",
    "availableAmount": "可用余额",
    "Plus_type": "充值类型",
    "User_is_trade_channel_agree": "同意交易通道",
    "AgentFlowLog_agent": "代理id",
    "Capital_increase_capital": "追加配资",
    "Baseconfig_buy_price_config_others": "做多上限价位",
    "LanguageField_table_name": "表名",
    "Parameter_type": "参数类型",
    "FoundWinners_stock_status": "股票状态",
    "Depot_name": "证券名称",
    "DepotStop_capital": "配资id",
    "Withdraw_callback": "回调URL",
    "User_name": "昵称",
    "Stock_control_amount": "额度",
    "Deal_staff": "员工id",
    "UserAccount_fee_total": "手续费",
    "Help_id": "编号",
    "Baseconfig_company_address": "公司地址",
    "Baseconfig_cxlnk_sms_url": "灿星云网关",
    "CompanyBank_number_to": "最大充值金额",
    "Entrust_price": "成交价格",
    "Total_account_balance": "总账户余额",
    "Recharge_user_caller": "客服",
    "Plus_status": "状态",
    "real_name_middleware_url": "实名认证API网址",
    "RechargeMethod_name": "名称",
    "Home_Transaction_fee_income_day ": "当天交易费收入",
    "QuickReplyCategory_name": "姓名",
    "TimebaoAccount_withdrawamount": "提取合计",
    "DealSimulate_code": "证券代码",
    "Baseconfig_sys_agent_voucher": "多头代理分成代金券",
    "CapitalType_status": "状态",
    "Finance_amount": "定期宝",
    "DepotStop_give": "赠送数量",
    "AgentFee_remark": "备注",
    "DealSimulate_shareholder": "股东信息",
    "AgentFlowLog_mold": "模具",
    "Capital_price": "价格",
    "Minus_create_time": "充值时间",
    "UserSimulate_photo": "认证图片",
    "LanguageField_code": "使用语言",
    "FlowType_id": "编号",
    "Depot_cancel": "取消数量",
    "FoundWinners_high_time": "最高价时间",
    "UserAccount_profit_total": "结算盈亏",
    "AgentAccount_wit_total": "提现金额",
    "EntrustSimulate_create_time": "委托时间",
    "Baseconfig_sys_agenturl": "系统代理网址",
    "Baseconfig_app_app": "苹果/安卓下载",
    "RechargeType_method_show": "充值方式",
    "Baseconfig_gx_withdraw_callback_url": "GXPay回调网址",
    "RechargeType_view_type": "类型",
    "Baseconfig_VCOTC_Pay_API": "VCOTC支付网关",
    "Recharge_agent": "代理ID",
    "TimebaoBatchLog_comment": "备注",
    "Stock_create_time": "添加修改时间",
    "TimebaoAccount_isautoinout": "1自动转入转出 0手动",
    "NewCapitalTest_change": "过户费",
    "Baseconfig_short_buy_price_config_up": "做空主板上限价位",
    "Baseconfig_recharge_popup_image_pc": "未充值提示详情图PC",
    "PowerInterest_yag_gr": "预案公告日",
    "Stock_close": "是否退市",
    "InterestLog_capital_order": "策略合约",
    "FriendCouponLog_user_phone": "电话",
    "AgentDailyDepot_agent": "上级代理",
    "Depot_cash": "分红派息",
    "VoucherManagement_amount": "金额",
    "CapitalType_multiple_short": "空头配资倍数及管理费",
    "Capital_buy_stock": "买股票",
    "DepotSimulate_agent": "代理id",
    "Baseconfig_tron_trx_amount": "TRC20交易TRX数量",
    "Plus_from_amount": "原始金额",
    "User_mother": "母账户id",
    "News_status": "新闻状态",
    "Baseconfig_logo": "站点logo",
    "EntrustSimulate_type": "类型 0买入 1卖出",
    "CapitalLog_id": "编号",
    "RechargeType_name": "名称",
    "Stock_id": "编号",
    "extra_fee2_short": "空头结算费用",
    "DealSimulate_staff": "员工id",
    "Depot_give": "赠送数量",
    "UserControl_stock_value_market": "流通市值",
    "RiskControl_id": "编号",
    "Capital_update_time": "更新时间",
    "ChatGroupMessageLog_groupId": "组ID",
    "UserCoupon_cashed_date": "兑现日期",
    "NewCapitalTest_close": "平仓线",
    "DepotStop_version": "Version",
    "CoreSet_popup_content_2": "弹窗内容2",
    "CoreSet_popup_content_1": "弹窗内容1",
    "Home_today_total_borrowing_fee": "借券费",
    "Help_status": "状态",
    "profit_real_new": "实际结算盈亏",
    "Baseconfig_pay_ali_isactive": "支付宝收款",
    "Baseconfig_chat_token": "客服TOKEN",
    "UserControl_lastvolumn": "昨日成交量",
    "CapitalType_name": "配资名称",
    "ChatGroup_name": "姓名",
    "AgentDivide_agent_phone": "代理电话",
    "Stock_lastvolumn": "昨日成交量",
    "CoreSet_create_time": "创建时间",
    "UserSimulate_bank": "是否绑定银行",
    "UserSimulate_caller": "客服专员",
    "Language_simple_code": "语言简码",
    "InterestLog_times": "收费次数",
    "Stock_buy_up": "可以买涨",
    "Agentdailydepot_agent_team": "上级姓名",
    "AgentFee_create_time": "时间",
    "FeeLog_number": "交易数量",
    "InterestLog_uid": "用户id",
    "FriendCoupon_create_time": "创建时间",
    "AgentWithdraw_number": "金额",
    "Job_remark": "备注信息",
    "Parameter_extend": "参数扩展属性",
    "Baseconfig_sms_gateway": "默认短信",
    "DealSimulate_extra_fee2": "结算费用",
    "DealSimulate_extra_fee3": "平台费用",
    "DealSimulate_extra_fee1": "产品处理费",
    "Plus_number": "充值金额",
    "DepotStop_cash": "分红派息",
    "Baseconfig_short_buy_price_config_others_main_board": "做空科创/创业板下限价位（其他用户）",
    "UserBank_id": "ID",
    "Deal_stamp": "印花税",
    "RiskControl_agent": "代理id",
    "AgentFlowLog_create_time": "时间",
    "TimebaoLog_endtime": "利息结束时间",
    "VoucherManagement_user_real_name": "姓名",
    "DepotSimulate_short": "证券简码",
    "fetch_ip_location_middleware_url": "获取IP归属地址API",
    "RechargeType_show": "显示",
    "FriendCoupon_user_user_friend_name": "好友名称",
    "AgentFlowLog_agent_number": "代理账户",
    "Stock_enable_time": "开始交易日期",
    "WeekVoucherManagement_type": "代金券类型",
    "Deal_commision": "交易佣金",
    "TimebaoBatchLog_endtime": "利息结束时间",
    "Depot_number": "股票数量",
    "Baseconfig_mail_username": "邮箱用户名",
    "UserCoupon_user_phone": "电话",
    "AgentDeferred_mother": "母账户",
    "DepotStop_profit_loss": "当前盈亏",
    "UserSimulate_qq": "QQ信息",
    "AgentFee_type": "剩余类型",
    "PowerInterest_gq_djr_qsr_zf": "股权登记日前10日涨幅%",
    "User_agent_phone": "上级电话",
    "UserControl_create_time": "时间",
    "pleaseAddTheValidmessage": "必填信息内容",
    "gameRoomName": "游戏室名称",
    "PowerInterest_project_progress": "方案进度",
    "DepotStop_interest": "税后配息金额",
    "QuickReply_message": "信息",
    "Agent_staff_team": "员工团队",
    "Baseconfig_sys_aboutus": "关于我们",
    "VoucherManagement_user_phone": "电话",
    "Baseconfig_all_user_settings": "全体用户设置",
    "AgentManage_balance": "余额",
    "Agent_encrypt_phone": "加密手机号",
    "FeeLog_contract": "合约号码",
    "AgentFee_capital": "配资id",
    "UserSimulate_update_time": "修改时间",
    "First_Trans_red_total": "交易红包",
    "InterestLog_create_time": "创建时间",
    "RechargeMethod_id": "编号",
    "Deal_fee": "交易佣金",
    "EntrustSimulate_finish": "完成数量",
    "AgentFlowLog_mother": "母账户id",
    "CoreSet_change": "过户费",
    "DealSimulate_sell_total": "出售总价值",
    "MobileUCenter_menu_red_envelope": "红包功能",
    "Withdraw_bank_address": "支行",
    "AgentManage_uid": "用户id",
    "Partners_token": "通证",
    "FirstVoucher_peizi_amount": "配资金额",
    "TimebaoLog_comment": "备注",
    "ChatHistoryData_type": "类型",
    "Baseconfig_ucpass_template": "云之讯单发模板",
    "AgentFee_mother": "母账户id",
    "User_build_number": "包号",
    "News_banner": "默认bander设置",
    "AgentFlowLog_remake": "备注",
    "stamp_short": "空头印花税",
    "FlowLog_user_phone": "电话",
    "DepotSimulate_staff": "员工id",
    "Capital_sell_fee": "出售股票佣金",
    "VoucherManagement_remark": "备注",
    "RechargeMethod_disabled": "关闭",
    "AgentAccount_trade_plus": "交易附加税",
    "CapitalType_short_name": "简称",
    "DepotSimulate_mother": "母仓id",
    "AgentManage_vouchers": "代金券",
    "Withdraw_uid": "用户ID",
    "Depot_fee_total": "总费用",
    "NewCapitalTest_total": "可用金额",
    "TimebaoLog_amount": "金额",
    "DealSimulate_stamp": "印花税",
    "DepotStop_user_real_name": "姓名",
    "UserSimulate_phone": "手机号码",
    "TimebaoAccount_nextinitialcapital": "下次有效资本",
    "Depot_agent": "代理id",
    "PowerInterest_gq_djr": "股权登记日",
    "Agent_create_time": "注册时间",
    "Baseconfig_google_captcha_des": "** 注意 : 必填实时谷歌验证码才能保存 **",
    "DealSimulate_change_cost": "过户费、成本",
    "UserSimulate_app_version": "APP版本",
    "Baseconfig_pc_winner_logo_3_inactive": "问财神 logo 未选",
    "SysConfigLog_operator": "操作员",
    "Home_First_deposit_amount_day ": "当天首存金额",
    "TimebaoBatchLog_create_time": "时间",
    "voice": "语音",
    "SMS_name": "短信名称",
    "Baseconfig_sys_agent_voucher_short": "空头代理分成代金券",
    "HomeConfig_app_download_logo": "应用程序下载logo",
    "stock_type_short": "做空禁止买入股票类型",
    "UserAccount_wit_fee": "提现手续费",
    "Depot_profit_loss": "当前盈亏",
    "Capital_page_profit": "持仓盈亏",
    "RiskControl_staff": "员工id",
    "descending": "降序",
    "AgentDivide_vouchers": "代金券",
    "NewCapitalTest_multiple": "配资倍数",
    "DealSimulate_deal": "买入价格",
    "CompanyBank_create_time": "创建时间",
    "Activity_type": "活动类型",
    "Deal_Turnover": "周转",
    "Capital_ratio": "递延费比例",
    "Deal_short": "证券短语",
    "User_bindwechat": "是否绑定公众号",
    "Baseconfig_sms_merchant": "短信商",
    "DepotStop_name": "证券名称",
    "DepotSimulate_sell_total": "卖出总价值",
    "NewCapitalTest_renew_time": "续费时间",
    "I118_language_03": "其他3",
    "I118_language_04": "其他4",
    "I118_language_01": "其他1",
    "I118_language_02": "其他2",
    "Depot_staff": "员工id",
    "Entrust_staff": "员工id",
    "NewCapitalTest_divided": "利润分成比例",
    "Withdraw_type": "类型",
    "I118_language_05": "其他5",
    "I118_language_06": "其他6",
    "AgentAccount_activity_capital": "活动配资",
    "Deal_finish": "完成数量",
    "TimebaoLog_capitalamount": "计息金额",
    "DealSimulate_change": "过户税",
    "Baseconfig_VCOTC_Pay_secret_key": "VCOTC支付密钥",
    "FriendCoupon_register_date": "好友使用日期",
    "Deal_agent_real_name": "姓名",
    "FeeLog_total": "交易价值",
    "InterestLog_balance": "账号剩余",
    "Net_recharge": "净充值",
    "ChatGroupMessageLog_id": "编号",
    "AgentDailyDepot_encrypt_phone": "加密手机号",
    "Entrust_number": "委托数量",
    "UserSimulate_password": "密码",
    "Baseconfig_keyword": "站点关键词",
    "Baseconfig_stock_price_times_des": "默认数是 0，意味着没有限制。 1.2意味着限制了到买入价的20%。 2意味着限制了到买入价的100%",
    "UserVip_amount": "充值额度",
    "Capital_interest": "递延费数量",
    "UserSimulate_ip": "注册IP",
    "EntrustSimulate_code": "证券代码",
    "DepotStop_cost_total": "剩余成本价值",
    "Stock_code": "股票代码",
    "ChatHistoryData_sender": "发件人",
    "Baseconfig_timebao_time_point": "时时宝执行时间",
    "User_user_account_rec_total": "充值总额",
    "Agent_name": "代理商昵称",
    "CoreSet_buy": "购买交易佣金",
    "DepotSimulate_status": "股票状态",
    "User_user_account_account": "账户余额",
    "Stock_category": "股票类型",
    "UserSimulate_id": "编号",
    "Help_content": "内容",
    "NewCapitalTest_plus_fee": "加收费用",
    "Activity_time": "创建日期",
    "FriendCouponLog_uid": "用户ID",
    "UserVip_average": "月平均额度",
    "Job_job_id": "编号",
    "VoucherManagement_type": "类型",
    "Agentdailydepot_number": "代理商编号",
    "WeekVoucherManagement_approved_by": "批准人",
    "Baseconfig_short_stock_limit_message": "限制做空开仓卖出信息",
    "Agent_agent_team": "代理团队",
    "extra_fee1_short": "空头产品处理费",
    "AgentManage_agent_agent_name": "代理名称",
    "Baseconfig_problem_user_settings": "问题用户设置",
    "Baseconfig_stock_image": "活动横幅PC",
    "target_rolloverMin": "滚下",
    "AgentDivide_id": "编号",
    "Baseconfig_password_attempt_time": "密码尝试时间",
    "AgentFinance_mother": "母账户",
    "Baseconfig_short_buy_price_config_others_up_des": "注意： 注意必填0到10数字，9表示当日涨幅0%到9%范围内可开仓（问题用户级别>全体用户级别）",
    "Baseconfig_foundwinner_banner_app": "牛股横幅Mobile",
    "RiskControl_mother": "母账户id",
    "WeekVoucherManagement_balance": "余额",
    "WeekVoucherManagement_status": "地位",
    "DepotStop_uid": "用户id",
    "CapitalLog_mother": "母账户信息",
    "Agent_password": "登录密码",
    "Baseconfig_tron_api_key": "Tron_Api_key",
    "Capital_change": "过户费",
    "Baseconfig_recharge_popup_image_mob": "未充值提示详情图APP",
    "Baseconfig_email_smtp_auth_starttls_enable": "支持STARTTLS",
    "Partners_password": "密码",
    "CoreSet_with_fee_min": "最低提现手续费",
    "EntrustSimulate_stamp_cost": "印花税成本",
    "UserAccount_sms_time": "短信发送时间",
    "Withdraw_user_real_name": "姓名",
    "User_caller": "客服专员",
    "UserAccount_my_coupon": "我的现金券总额",
    "Agent_bank_address": "开户分行",
    "Depot_price": "成本价位",
    "Withdraw_wallet_address": "钱包地址",
    "Depot_mother": "母仓id",
    "WeekVoucherManagement_approved_time": "批准日期",
    "ActivityNotice_id": "编号",
    "Baseconfig_timebao_status": "是否使用时时宝",
    "UserAccount_reid": "推荐人id",
    "TimebaoAccount_interestthis": "当月利息",
    "Capital_status": "配资状态",
    "Agentdailydepot_grade": "代理等级",
    "Admin_recharge": "后台充值",
    "oldVersion": "旧版 ",
    "Information_name": "标题",
    "I118_message_id": "消息ID",
    "Agentdailydepot_caller": "客服专员",
    "Capital_sms_time": "短信",
    "CompanyBank_status": "状态",
    "Capital_market": "持仓市值",
    "AgentDivide_staff": "员工id",
    "DepotSimulate_price": "成本价位",
    "AgentManage_agent": "代理商id",
    "Capital_serve": "服务费（交易费用总计）",
    "Agent_bank_name": "银行名称",
    "newPhone ": "新手机",
    "UserAccount_version": "Version",
    "AgencyDailyAccount_total": "当日分成总额",
    "FriendCoupon_coupon": "现金券编码-9位无重复数字码",
    "AgentDivide_uid": "用户id",
    "RiskControl_capital": "配资id",
    "CustomerAgent_status": "状态",
    "EntrustSimulate_plus_fee": "加收费用",
    "TimebaoAccount_amount": "当前资产",
    "Activity_num": "领取数量",
    "approved_withdraw_numberid": "财务撮合Gxpay ID",
    "Minus_user_phone": "电话",
    "No_depot_days": "未持仓天数",
    "Baseconfig_file_size": "上传文件大小\t",
    "UserSuspect_Telephone": "电话",
    "CustomerAgent_avatar": "头像路径",
    "UserSimulate_remark": "备注",
    "AgentDailyDepot_number": "代理商编号",
    "Baseconfig_yunma_sms_account": "商务通账号",
    "Baseconfig_withdraw_fee_way": "提现手续费模式",
    "User_type": "用户类型",
    "Popular_broker_fee": "空头热门股票借券费",
    "Sys_name": "客服专员",
    "Baseconfig_short_sell_price": "做空开仓成交价",
    "News_id": "编号",
    "PowerInterest_cq_cxr": "除权除息日",
    "LanguageField_extend": "扩展属性",
    "TimebaoAccount_lasttime": "上一次计息时间",
    "Stock_name": "股票名称",
    "FlowLog_mold": "类型",
    "Baseconfig_id": "编号",
    "AgentFinance_remark": "备注信息",
    "Baseconfig_short_buy_price_config_main_board_des": "注意： 注意必填-20到0数字，-18表示当日跌幅-18%到0%范围内可开仓（问题用户级别>全体用户级别）",
    "Stock_trade": "是否交易",
    "Entrust_change": "过户税",
    "AgentFlowLog_user_number": "编号",
    "DepotStop_update_time": "修改时间",
    "Capital_staff": "员工id",
    "VoucherCash_user_phone": "电话",
    "Agent_bank_account": "开户人账号",
    "status_short": "做空状态",
    "SMS_type": "状态",
    "DepotSimulate_number": "股票数量",
    "TimebaoAccount_id": "编号",
    "withdraw_3rdparty": "等待第三方",
    "CapitalType_fee": "佣金比例",
    "AgentFee_uid": "编号",
    "Max_net_recharge": "客户本金",
    "UserControl_user_real_name": "昵称",
    "UserCoupon_status": "状态（0未兑现 1已兑现）",
    "Baseconfig_company_copyright": "版权信息",
    "UserControl_stock_type": "禁止买入股票类型",
    "I118_original_id": "模块ID",
    "FlowLog_order": "订单编号",
    "ChatHistory_sender_name": "发件人名称",
    "Baseconfig_login_ip_gateway_des": "正确的格式： 网关,传IP的参数 例如 https://ifconfig.me/all.json,ip_addr",
    "Recharge_status": "充值状态",
    "DepotStop_day": "停牌天数",
    "Capital_trade_fee": "交易手续费",
    "AgentAccount_mother": "母账户id",
    "UserAccount_month_capital": "按月配资",
    "Stock_buy_short": "做空买",
    "stock_value_short": "做空市值",
    "StockFeeLog_partner_id": "合伙人ID",
    "FriendCoupon_user_user_real_name": "姓名",
    "DepotSimulate_delivery": "配送数量",
    "TimebaoLog_uid": "账户ID",
    "AgentDailyDepot_caller": "客服专员",
    "Withdraw_mother": "母账户信息",
    "Depot_code": "证券代码",
    "Home_thumb_width": "缩略图宽",
    "Mode_selection": "模式选择",
    "Baseconfig_pc_banner3": "PC轮播图3",
    "Home_Total_Current_Profit_Loss": "操盘盈亏*",
    "Baseconfig_pc_banner2": "PC轮播图2",
    "Baseconfig_pc_banner1": "PC轮播图1",
    "RechargeType_type": "充值通道",
    "Baseconfig_pc_winner_logo_4_active": "尾盘追击 logo 已选",
    "Capital_agent_real_name": "代理名称",
    "Baseconfig_pc_banner6": "PC轮播图6",
    "Baseconfig_pc_banner5": "PC轮播图5",
    "Baseconfig_pc_banner4": "PC轮播图4",
    "Agent_withdraw": "代理提现",
    "Baseconfig_sys_isdefaultcreateagent": "是否创建代理",
    "AgentDivide_agent": "代理商id",
    "Stock_pinyin": "拼音",
    "DepotSimulate_finish": "完成数量",
    "RechargeType_channel_show": "充值通道",
    "AgentAccount_day_capital": "天配资",
    "AgentDivide_balance": "余额",
    "handle": "经手费",
    "Capital_warning": "预警线",
    "Depot_create_time": "开仓时间",
    "DepotSimulate_surplus_total": "剩余价值",
    "PowerInterest_code": "证券代码",
    "AgentWithdraw_user_real_name": "姓名",
    "ChatGroupMessageLog_host": "主持人",
    "VoucherManagement_ref": "参考",
    "Baseconfig_short_stock_limit_volumn": "限制做空开仓卖出数量",
    "Agentdailydepot_create_time": "生成时间",
    "InterestLog_staff": "员工id",
    "PlusMinusType_activity_type": "活动类型",
    "MobileUCenter_menu_gxpay": "Gxpay",
    "AgentFlowLog_capital": "子账户ID",
    "Withdraw_bank_id": "银行ID",
    "NewCapitalTest_buy_fee": "购买佣金",
    "Agent_day": "天配提出",
    "VoucherCash_amount": "金额",
    "Deal_cost": "卖出价格",
    "Recharge_order": "订单号",
    "AgentDeferred_capital": "配资id",
    "User_app_version": "APP版本",
    "RechargeMethod_status": "状态",
    "WeekVoucherManagement_amount": "金额",
    "ChatGroupMember_id": "编号",
    "I118_language_en": "英文",
    "User_is_simulate": "是模拟",
    "Baseconfig_agent_default_reserve": "会员代理模版",
    "PowerInterest_cash_dividend": "现金分红比例",
    "AgencyDailyAccount_agent_phone": "代理电话",
    "Baseconfig_system_datasource_des": "API和后台数据源tecent,shuhai",
    "lastMsgFile": "文件",
    "FoundWinners_classify": "分类",
    "LanguageField_type": "类型",
    "CompanyBank_account": "账户",
    "Job_status": "状态",
    "EntrustSimulate_number": "委托数量",
    "JobLog_exception_info": "异常信息",
    "Baseconfig_activity_title": "充值活动标题",
    "Baseconfig_yunma_sms_url": "商务通网关",
    "UserVip_discount": "VIP折扣",
    "User_login_name": "用户登陆名",
    "UserAccount_push_total": "用户推广费",
    "Baseconfig_short_buy_price_config_others_main_board_des": "注意： 注意必填-20到0数字，-18表示当日跌幅-18%到0%范围内可开仓（问题用户级别>全体用户级别）",
    "CapitalType_profit_short": "空头盈利分成",
    "Help_count": "阅读次数",
    "FirstVoucher_comment": "说明",
    "Job_module": "执行模块",
    "Job_update_time": "更新时间",
    "PowerInterest_ycq_ts": "已除权天数(天)（倒计时）",
    "AgentAccount_fee_total": "手续费",
    "Baseconfig_timebao_agent_rate": "代理时时宝利率",
    "CapitalLog_code": "股票代码",
    "Baseconfig_ucpass_appid": "云之讯应用ID",
    "Baseconfig_site_logo\t": "站点LOGO",
    "UserBank_user_real_name": "帐户持有人",
    "withdraw_reject": "已拒绝",
    "AgentAccount_trade_stamp": "交易印花税",
    "Baseconfig_timebao_image": "时时宝图片",
    "Capital_agent": "代理id",
    "AgentDeferred_balance": "余额",
    "FoundWinners_high_price": "最高价",
    "UserCoupon_amount": "金额",
    "DepotSimulate_transfer": "转送数量",
    "Minus_status": "状态",
    "AgentAccount_free_capital_total": "免息配资",
    "CapitalLog_number": "数量",
    "Deal_order": "订单号",
    "Protocol_content": "内容",
    "TimebaoLog_type": "操作类型",
    "Agent_phone": "手机号",
    "NewCapitalTest_depot": "非配资保证金",
    "Baseconfig_smsplannet_appKey": "smsplannet_appKey",
    "AgentDeferred_agent_real_name": "代理名称",
    "CoreSet_handle": "多头经手费",
    "ChatGroupMember_account": "帐户",
    "InterestLog_user_phone": "电话",
    "AgentAccount_create_time": "时间",
    "AgencyDailyAccount_create_time": "生成时间",
    "Stock_stop_time": "停牌时间",
    "Activity_create_time": "创建日期",
    "Depot_surplus_total": "剩余价值",
    "TimebaoAccount_phone": "电话",
    "Entrust_complete_time": "完成时间",
    "CustomerAgent_name": "姓名",
    "PowerInterest_allocation_plan": "分配计划",
    "Capital_user_status": "用户状态",
    "Baseconfig_file_type": "文件类型",
    "Activity_content": "规则",
    "UserAccount_max_net_recharge": "最大净充值",
    "TimebaoBatchLog_id": "编号",
    "Closed_closed_time": "休市日期",
    "Plus_approved_by": "批准人",
    "UserBank_uid": "用户编码",
    "Agent_uid": "用户ID",
    "AgentDivide_user_phone": "代理电话",
    "DepotStop_id": "编号",
    "Plus_currency": "充值货币",
    "Deal_type": "业务类型",
    "sell_short": "空头出售交易佣金",
    "Baseconfig_changhongRecharge_mchId": "长虹商户号",
    "JobLog_job_name": "任务名称",
    "UserControl_uid": "用户ID",
    "SMS_create_time": "时间",
    "NewCapitalTest_number": "配资金额",
    "UserSimulate_create_time": "注册时间",
    "DealSimulate_depot_mold": "持仓模式 0 A仓 1：B 仓",
    "Baseconfig_pc_winner_logo_1_active": "短线宝 logo 已选",
    "JobLog_status": "执行状态",
    "Withdraw_id": "编号",
    "FeeLog_capital": "配资id",
    "Deal_agent": "代理id",
    "Depot_profit_new": "动态盈亏#",
    "FeeLog_price": "交易",
    "Language_id": "编号",
    "ChatHistoryData_receiver_name": "收件者姓名",
    "CapitalType_time_min": "最小时间",
    "EntrustSimulate_fee": "费用总计",
    "Withdraw_name": "姓名",
    "Activity_number": "配资金额",
    "InterestLog_charge_time": "收费时间",
    "PowerInterest_earnings_perShare": "每股收益",
    "RiskControl_user_real_name": "真正的名字",
    "Plus_fee": "手续费",
    "VoucherCash_status": "状态",
    "DepotStop_agent": "代理id",
    "VoucherCash_ref": "参考",
    "PowerInterest_time2": "除权除息日",
    "UserVip_comment": "备注",
    "Recharge_balance": "账户余额",
    "User_vip": "VIP级别",
    "DailyReport_defered_fee": "实际递延费",
    "AgencyDailyAccount_deferred_total": "递延费",
    "AgentFinance_create_time": "交易时间",
    "lastMsgVideo": "视频",
    "AgentReserve_create_time": "添加时间",
    "InterestLog_status": "状态",
    "Baseconfig_recommend_stock": "发现牛股",
    "Withdraw_remark": "备注",
    "Baseconfig_sys_give_voucher_amount": "注册送代金券金额",
    "Protocol_status": "状态",
    "Plus_approve_time": "批准时间",
    "Deal_purchase_price": "购买价格",
    "FriendCoupon_remark": "备注",
    "UserLevel_recharge_total_to": "合计充值到",
    "UserSimulate_login_ip": "登录IP",
    "Parameter_name": "参数名称",
    "Agentdailydepot_level2": "下二级持仓",
    "Agentdailydepot_level1": "下一级持仓",
    "AgentDailyDepot_id": "编号",
    "Agentdailydepot_level3": "下三级持仓",
    "Entrust_surplus": "剩余数量",
    "AgentWithdraw_user_number": "帐户",
    "Recharge_id": "编号",
    "DepotStop_order": "订单编号",
    "popular": "流行",
    "Baseconfig_system_datasource": "系统数据源",
    "User_code": "推广码",
    "Baseconfig_cxlnk_access_key": "灿星云键",
    "Entrust_phone": "电话",
    "Baseconfig_buy_price_config_others_des": "注意： 注意必填0到10数字，9表示当日涨幅0%到9%范围内可开仓（问题用户级别>全体用户级别）",
    "AgentDeferred_vouchers": "代金券",
    "InterestLog_number": "金额",
    "RiskControl_uid": "用户id",
    "AgentDivide_capital": "配资id",
    "UserAccount_first_trans_red_total": "已领红包总额",
    "Home_thumb_height": "缩略图高",
    "CapitalType_number_min": "最小配资",
    "JobLog_job_message": "日志信息",
    "Entrust_com_cost": "佣金成本",
    "NewCapitalTest_fee": "费用",
    "Withdraw_user_phone": "电话",
    "AgentFinance_number": "代理利息",
    "Activity_start_date": "开始日期",
    "Baseconfig_pc_winner_logo_4_inactive": "尾盘追击 logo 未选",
    "NewCapitalTest_sms_time": "短信时间",
    "User_token": "token",
    "Capital_real_profit_loss": "实际盈亏",
    "Baseconfig_borrow_fee_tooltip": "借券费前端说明",
    "AgencyDailyAccount_real_deferred_total": "实收递延费",
    "CoreSet_min_bond": "最少保证金",
    "RechargeMethod_enabled": "开启",
    "Deal_id": "编号",
    "EntrustSimulate_complete_time": "完成时间",
    "Partners_refCode": "推荐码",
    "direction_fee": "空头资金费率",
    "Withdraw_exchange": "汇率",
    "AgencyDailyAccount_partner_name": "合伙人姓名",
    "Stock_buy": "做多买",
    "UserVip_name": "说明",
    "UserSimulate_team": "团队总人数",
    "AgentAccount_uid": "编号",
    "Depot_type": "类型",
    "TimebaoLog_balance": "余额",
    "Withdraw_create_time": "创建时间",
    "UserAccount_rec_fee": "充值手续费",
    "UserAccount_last_trans_date": "最后交易日",
    "Stock_status": "状态",
    "Baseconfig_short_buy_price": "做空平仓成交价",
    "Entrust_capital_account": "账户",
    "AgentAccount_total": "总额",
    "Agentdailydepot_id": "编号",
    "Deal_deal": "买入价格",
    "AgentDivide_user_number": "编号",
    "ChatHistory_message": "信息",
    "FriendCouponLog_user_real_name": "姓名",
    "Recharge_currency": "币种",
    "CompanyBank_bank_branch": "支行",
    "FirstVoucher_operate_amount": "买入金额",
    "CapitalLog_name": "股票名称",
    "Baseconfig_before_recharge": "未充值提示弹窗",
    "Depot_interest": "税后配息金额",
    "Holographic": "全息模式",
    "StockFeeLog_mother": "母账户ID",
    "Baseconfig_coupon_web": "用户现金券PC",
    "Baseconfig_is_before_trading": "未交易弹窗开关",
    "Activity_voucher_type": "代金卷|1,管理费|2",
    "Capital_loss": "子户亏数",
    "ChatHistory_order_id": "订单号",
    "UserAccount_wit_total": "累计提现",
    "UserSimulate_staff": "员工",
    "AgencyDailyAccount_real_manage_total": "实收管理费",
    "AgentFlowLog_user_real_name": "姓名",
    "DepotStop_frozen": "冻结数量",
    "ChatGroupMessageLog_message": "信息",
    "UserSimulate_certified": "是否认证",
    "Activity_sortid": "分类号",
    "AgentDeferred_uid": "用户id",
    "UserAccount_first_date": "首充日期",
    "Entrust_status": "状态  0申请提交 1已成功  2 已撤销 3部分撤销 4撤单申请 5 已报待撤",
    "DepotStop_finish": "完成数量",
    "EntrustSimulate_mother": "母账户",
    "AgentFlowLog_user_phone": "电话",
    "Baseconfig_email_smtp_port": "SMTP端口",
    "FriendCoupon_id": "编号",
    "Avg_total": "日均买入额",
    "NewCapitalTest_version": "版本号",
    "Deal_surplus": "剩余数量",
    "Depot_day_number": "今日持仓",
    "AgentFinance_balance": "余额",
    "Entrust_entrust_time": "委托时间",
    "Agent_total": "代理收入",
    "User_email": "用户邮箱",
    "SysConfigLog_create_time": "创建时间",
    "Agent_bank_card": "银行卡号",
    "StockFeeLog_type": "类型",
    "AgentDivide_agent_number": "代理账户",
    "Refer_a_friend": "推荐好友",
    "Agentdailydepot_phone": "手机号",
    "Activity_end_date": "结束日期",
    "Agent_reserve": "代理分成模板",
    "Plus_id": "编号",
    "FeeLog_status": "状态",
    "User_login_ip_query": "查询",
    "newPassword": "新密码",
    "RechargeType_hide": "不显示",
    "Closed_create_time": "创建时间",
    "Depot_cost": "持仓成本",
    "NewCapitalTest_sell_fee": "出售佣金",
    "AgentAccount_server_total": "服务费总计",
    "Baseconfig_login_register_logo": "注册登录页logo",
    "Deal_code": "证券代码",
    "Baseconfig_stock_prohibit_message": "禁止买卖信息",
    "ChatGroup_id": "编号",
    "CapitalLog_deal": "成交编号",
    "EntrustSimulate_entrust_id": "委托单号",
    "Baseconfig_taiseiRecharge_url": "大成支付网关",
    "card": "身份证号",
    "AgentDeferred_agent_number": "代理账户",
    "AgentAccount_week_capital": "周配资",
    "FriendCouponLog_coupon": "现金券编码-9位无重复数字码",
    "Agent_code": "我的推荐吗",
    "Total_return_investment_ratio": "总投资回报比",
    "Plus_user_phone": "电话",
    "AgentDailyDepot_create_time": "生成时间",
    "Agent_divided": "互惠分成",
    "Withdraw_total": "实际金额",
    "User_core_set": "用户费用模版",
    "Agent_real_day": "真实比例",
    "Capital_profit_loss": "实际结算盈亏",
    "AgentDeferred_id": "编号",
    "UserAccount_plus_fee_total": "加收费用",
    "FeeLog_change": "过户税",
    "Baseconfig_ucpass_sid": "云之讯用户sid",
    "Withdraw_refer_to": "链接",
    "Baseconfig_is_trade_time_enabled": "交易时间启用",
    "Capital_extra": "提取利润",
    "Baseconfig_domain": "绑定域名",
    "Baseconfig_home_logo": "首页logo",
    "HomeConfig_app_download_subtitle": "小标题",
    "SMS_code": "代码",
    "Baseconfig_recharge_hint": "充值温馨提示",
    "DealSimulate_order": "订单号",
    "Withdraw_number": "金额",
    "Agent_md5_phone": "MD5加密",
    "ChatGroup_founder": "创建人",
    "Home_active_number": "活跃人数",
    "UserAccount_change_total": "过户费",
    "Withdraw_card": "卡号",
    "AgentManage_user_member_account": "编号",
    "Stock_lastamount": "昨日成交额",
    "Recharge_fee": "手续费",
    "TimebaoAccount_create_time": "时间",
    "RiskControl_number": "帐户",
    "Depot_finish": "完成数量",
    "Parameter_id": "编号",
    "CompanyBank_level": "用户级别",
    "AgentDivide_number": "交易数量",
    "UserControl_status": "状态",
    "RechargeType_exchange_name": "兑换名称",
    "CoreSet_change_cost": "过户费成本",
    "AgentManage_agent_phone": "高级电话",
    "LanguageField_remark": "备注",
    "UserSimulate_mother": "母账户id",
    "EntrustSimulate_remark": "备注信息",
    "Baseconfig_pc_winner_logo_4": "尾盘追击 logo",
    "UserAccount_increase_bond": "追加保证金",
    "Baseconfig_risk_notice_mp3": "客户警告语音提示",
    "UserSimulate_agent": "代理",
    "CoreSet_id": "编号",
    "FirstVoucher_agent_cash": "代理奖励",
    "FlowLog_agent": "代理ID",
    "FoundWinners_stock_name": "股票名称",
    "UserSuspect_user_Name": "姓名",
    "DepotSimulate_cq_cxr": "除权派息日",
    "UserAccount_week_capital": "按周配资",
    "Agent_wit_pwd": "提现密码",
    "UserAccount_voucher_managetotal": "送的管理费总额",
    "FlowLog_amount": "金额",
    "Recharge_number": "金额",
    "NewCapitalTest_interest": "递延费数量",
    "CustomerAgent_phone": "手机号码",
    "User_number": "编号",
    "SMS_id": "编号",
    "Capital_stamp": "印花税",
    "AgentReserve_name": "模板名称",
    "SMS_ip": "客户端ip",
    "Baseconfig_pc_winner_logo_2": "牛人牛股 logo",
    "Baseconfig_pc_winner_logo_3": "问财神 logo",
    "UserSimulate_certified_synced": "客服同步",
    "Baseconfig_pc_winner_logo_1": "短信包 logo",
    "Agentdailydepot_partner_id": "合作伙伴ID",
    "User_certified": "是否认证",
    "Agent_type": "代理商类型",
    "NewCapitalTest_increase_capital": "追加配资",
    "Stock_state": "股票状态",
    "EntrustSimulate_id": "编号",
    "CustomerAgent_id": "编号",
    "Agent_capital": "默认提出",
    "frozenAmount ": "冻结金额",
    "UserAccount_uid": "编号",
    "buy_short": "空头购买交易佣金",
    "FirstVoucher_name": "档次",
    "Baseconfig_team_all_data_level": "代理团队层级",
    "Depot_frozen": "冻结数量",
    "Baseconfig_short_stock_limit_price": "限制做空开仓卖出价格",
    "Capital_number": "配资金额",
    "VoucherCash_approved_by": "批准人",
    "Baseconfig_before_trading": "未交易提示弹窗",
    "DealSimulate_number": "成交数量",
    "Baseconfig_recharge_coupon": "提示好友领现金券pc",
    "Capital_uid": "用户id",
    "Agent_login_time": "登录时间",
    "stocks_short": "做空禁止买入股票列表",
    "UserAccount_create_time": "创建时间",
    "UserLevel_id": "编号",
    "FlowLog_staff": "员工id",
    "DepotSimulate_day": "停牌天数",
    "CapitalType_times": "整倍数",
    "Capital_order": "单号",
    "FeeLog_stamp": "印花税",
    "TimebaoBatchLog_starttime": "利息开始时间",
    "Baseconfig_hangqing_banner": "行情页首图",
    "FirstVoucher_voucher_cache": "代金卷金额",
    "DepotSimulate_fee_total": "总费用",
    "FeeLog_deal": "成交记录id",
    "InterestLog_voucher": "代金券",
    "PowerInterest_name": "证券名称",
    "DepotSimulate_give": "赠送数量",
    "Job_concurrent": "是否并发执行",
    "Stock_sell_short": "做空卖",
    "Withdraw_status": "状态",
    "DepotStop_create_time": "开仓时间",
    "Agent_grade": "代理等级",
    "NewCapitalTest_ratio": "递延费比例",
    "Capital_agent_phone": "代理手机",
    "Baseconfig_email_smtp_auth": "SMTP授权",
    "Deal_uid": "用户id",
    "Agent_remark": "备注",
    "Baseconfig_gx_approve_uid": "财务撮合Gxpay ID",
    "CompanyBank_number": "充值金额",
    "AgentWithdraw_create_time": "时间",
    "VoucherCash_user_name": "昵称",
    "AgentDeferred_user_real_name": "姓名",
    "VoucherCash_id": "编号",
    "Capital_times": "自动续费次数",
    "Stock_first_acquisition_time": "首次获取时间",
    "Minus_user_real_name": "姓名",
    "JobLog_create_time": "创建时间",
    "AgentManage_agent_id": "优越的身份",
    "Baseconfig_popup_mobile_switch": "手机弹窗开关",
    "TimebaoAccount_interestlast": "上月利息",
    "DepotStop_price": "成本价位",
    "HomeConfig_enter_app_download_title": "输入标题",
    "CapitalLog_price": "成交价格",
    "Language_status": "状态",
    "AgentFinance_id": "编号",
    "HomeConfig_stock_search_label": "股票搜索",
    "FoundWinners_stock_code": "股票代码",
    "Baseconfig_agent_default_type": "会员代理类别",
    "PowerInterest_gx_rate": "股息率(%)",
    "Agent_ratio": "佣金比例",
    "UserSuspect_Partner_Name": "上级姓名",
    "CompanyBank_comment": "说明",
    "LanguageField_tip": "描述",
    "AgentAccount_agent": "上级id",
    "AgentManage_manage": "管理费",
    "NewCapitalTest_remark": "备注",
    "Baseconfig_live_Chat_URL": "实时聊天网址",
    "RechargeMethod_create_time": "时间",
    "DepotSimulate_cash": "分红派息",
    "PlusMinusType_id": "编号",
    "PowerInterest_mg_wfp_ly": "每股未分配利益(润)",
    "Baseconfig_email_smtp_ssl_protocols": "SMTP_SSL协议",
    "AgentAccount_rec_total": "累计充值",
    "UserAccount_server_total": "用户服务费",
    "FeeLog_agent": "代理id",
    "User_qq": "QQ信息",
    "UserSuspect_uid": "客户编号",
    "Deal_profit_loss": "盈亏",
    "AgentAccount_deferred_total": "递延费",
    "Parameter_title": "参数标题",
    "DepotStop_cancel": "取消数量",
    "NewCapitalTest_mother": "主账户id",
    "ChatHistoryData_message": "信息",
    "Agent_real_name": "代理商名称",
    "Closed_status": "状态",
    "Deal_mold": "操作类型 1 买入 2市价买入",
    "UserBank_bank": "银行id",
    "ChatHistory_time": "时间",
    "User_login_ip": "登录IP",
    "Deal_name": "证券名称",
    "Baseconfig_short_buy_price_config_up_des": "注意： 注意必填0到10数字，9表示当日涨幅0%到9%范围内可开仓（问题用户级别>全体用户级别）",
    "AgencyDailyAccount_partner_id": "合作伙伴ID",
    "AgentFee_user_number": "帐户",
    "AgentAccount_agent_real_name": "代理名称",
    "stock_value_market_short": "做空流通市值",
    "DepotStop_surplus": "剩余可用",
    "EntrustSimulate_com_cost": "佣金成本",
    "DepotSimulate_capital": "配资id",
    "EntrustSimulate_status": "状态  0申请提交 1已成功  2 已撤销 3部分撤销 4撤单申请 5 已报待撤",
    "AgentFlowLog_uid": "用户id",
    "AgentFee_user_real_name": "代理名称",
    "AgentFlowLog_id": "编号",
    "Home_Recharge_amount_of_the_day ": "当天充值金额",
    "ChatHistoryData_order_id": "订单号",
    "Plus_user_name": "昵称",
    "UserAccount_user_real_name": "姓名",
    "FriendCoupon_effect_date": "有效期",
    "Capital_deferred": "递延费",
    "Recharge_from_amount": "充值金额",
    "SysConfigLog_sys_config_name": "系统配置名称",
    "UserSimulate_real_name": "真实名称",
    "QuickReplyCategory_id": "编号",
    "multipleRiskControl": "多头风控",
    "AgentDivide_create_time": "交易时间",
    "Home_Fundraisers_count_day ": "当天新开配资人数",
    "Recharge_user_name": "用户昵称",
    "DepotSimulate_name": "证券名称",
    "AgentFinance_uid": "用户id",
    "User_encrypt_phone": "加密手机号",
    "UserBank_address": "开户支行",
    "DepotSimulate_uid": "用户id",
    "EntrustSimulate_price": "成交价格",
    "InterestLog_user_fee": "用户返佣",
    "CoreSet_plus_fee": "加收费用",
    "Baseconfig_login_ip_get_gateway": "注册登录IP获取网关",
    "NewCapitalTest_create_time": "创建时间",
    "I118_language_zh": "简体中文",
    "AgentDailyDepot_real_name": "代理商名称",
    "UserCoupon_from_uid": "使用好友ID",
    "UserLevel_recharge_times": "充值次数",
    "Home_Time_treasure ": "时时宝",
    "CapitalType_create_time": "时间",
    "Baseconfig_mail_password": "邮箱密码",
    "Withdraw_pay_order": "支付订单号码",
    "Deal_depot_mold": "持仓模式 0 A仓 1：B 仓",
    "DealSimulate_id": "编号",
    "Friend_coupon": "已收的好友现金券",
    "User_user_account_wit_total": "提现总额",
    "Last_trans_date": "最后交易日",
    "Baseconfig_cxlnk_sign_code": "灿星云签名",
    "User_peizi_auth": "授权码",
    "Deal_plus_fee": "加收费用",
    "ChatHistory_receiver_name": "收件者姓名",
    "DepotStop_staff": "员工id",
    "Stock_control_remaining": "剩余额度",
    "UserSimulate_bindwechat": "是否绑定公众号",
    "UserAccount_total": "资金总额",
    "Minus_number": "充值金额",
    "Holiday_amount": "节日宝",
    "NewCapitalTest_fee_rate": "交易佣金比例",
    "Baseconfig_timebao_time_interval": "时时宝时间间隔",
    "Recharge_mother": "母账户id",
    "AgentWithdraw_uid": "用户ID",
    "User_photo": "认证图片",
    "UserControl_user_phone": "电话",
    "Capital_capital_type": "类型 ",
    "Timebao_amount": "时时宝",
    "PowerInterest_sg_rate": "送股比例",
    "Stock_stop": "是否停牌",
    "Baseconfig_stock_limit_message": "限制买卖信息",
    "Stock_short_open_prohibit_status": "做空卖ST和*ST股",
    "RechargeType_create_time": "创建时间",
    "Baseconfig_popup_pc_content": "PC弹窗",
    "Baseconfig_short_buy_price_config_des": "注意： 注意必填-10到0数字，-9表示当日跌幅-9%到0%范围内可开仓（问题用户级别>全体用户级别）",
    "Depot_transfer": "转送数量",
    "AgentDivide_user_real_name": "姓名",
    "LanguageField_controller_name": "模块",
    "UserAccount_deferred_total": "递延费",
    "Language_code": "语言编码",
    "Recharge_pay_type": "支付类型",
    "Deal_entrust": "委托id",
    "SysConfigLog_new_data": "新数据",
    "Voucher_cash": "送现金",
    "Information_create_time": "创建时间",
    "Entrust_code": "证券代码",
    "StockFeeLog_number": "交易数量",
    "PowerInterest_status": "状态",
    "CoreSet_capital_interest_vip_per": "VIP配资利息",
    "AgentFee_user_fee": "员工返佣",
    "ChatHistory_id": "序列号",
    "Baseconfig_own_chat_link": "专属客服 API",
    "UserCoupon_coupon": "现金券编码-9位无重复数字码",
    "Entrust_create_time": "委托时间",
    "ChatHistory_is_read": "已读",
    "VoucherManagement_user_name": "昵称",
    "Baseconfig_changhongRecharge_merchantKey": "长虹密钥",
    "User_simulate_uid": "模拟账户",
    "Deal_total": "总交易费",
    "InterestLog_staff_fee": "员工返佣",
    "Recharge_coupon_amount": "现金券编金额",
    "DepotStop_number": "股票数量",
    "Plus_user_caller": "客服",
    "UserControl_stock_value": "市值",
    "Information_content": "内容",
    "Baseconfig_cxlnk_access_secret": "灿星云密钥",
    "StockFeeLog_staff": "员工ID",
    "DepotStop_fee_total": "总费用",
    "AgentDailyDepot_agent_real_name": "上级代理名称",
    "Recharge_coupon": "好友现金券编号",
    "UserSimulate_type": "用户类型",
    "DealSimulate_stamp_cost": "印花税成本",
    "InterestLog_agent": "代理id",
    "CoreSet_recharge_fee": "充值手续费",
    "AgentAccount_account": "可用余额",
    "CustomerAgent_email": "电子邮件",
    "User_team": "团队总人数",
    "UserAccount_day_capital": "按天配资",
    "CoreSet_update_time": "更新时间",
    "AgencyDailyAccount_system_divide_total": "总分成",
    "VoucherCash_balance": "余额",
    "MyTeam_tradetotal": "总买入额",
    "Information_aid": "管理员信息",
    "Capital_mother": "母账户id",
    "Home_Profit_loss_on_day ": "当天交割盈亏",
    "Entrust_uid": "用户id",
    "Baseconfig_short_stock_prohibit_price": "禁止做空开仓卖出价格",
    "CapitalLog_staff": "员工id",
    "Depot_cq_cxr": "除权派息日",
    "FeeLog_code": "股票代码",
    "FeeLog_user_real_name": "姓名",
    "Agent_core_set": "用户费用模版",
    "RechargeType_exchange_rate": "汇率",
    "Deal_status": "状态",
    "VoucherManagement_mold": "加减",
    "Plus_uid": "用户ID",
    "UserCoupon_remark": "备注",
    "Recharge_remark": "备注",
    "VoucherCash_uid": "用户ID",
    "User_phone": "手机号码",
    "StockFeeLog_code": "证券代码",
    "Job_misfire_policy": "错误执行策略",
    "UserSimulate_extension_type": "推广方式",
    "Depot_version": "Version",
    "Protocol_title": "协议名称",
    "Job_create_by": "创建者",
    "Capital_bond": "保证金",
    "WeekVoucherManagement_remark": "备注",
    "Withdraw_fee": "手续费",
    "Baseconfig_password_attempt": "密码尝试次数",
    "Withdraw_withdraw_type": "提现类型",
    "RechargeType_min_amount": "最低限额",
    "Baseconfig_app_download_image": "下载页背景(手机)",
    "FoundWinners_status": "状态",
    "I118_create_time": "创建时间",
    "Baseconfig_tron_api_key1": "Tron_Api_key1",
    "AgencyDailyAccount_phone": "电话",
    "Help_source": "来源",
    "Agent_commision_voucher": "代理分成代金券",
    "AgentAccount_trade_change": "过户费",
    "Baseconfig_sys_give_voucher": "注册送代金券",
    "Parameter_rule": "验证规则",
    "LanguageField_table_key": "记录ID",
    "UserAccount_increase_capital": "追加配资",
    "User_last_time": "最后登录时间",
    "CoreSet_with_max": "单次最大提现",
    "EntrustSimulate_surplus": "剩余数量",
    "InterestLog_loan": "本金",
    "User_last_token_time": "最后TOKEN时间",
    "StockFeeLog_popular_broker_fee": "空头热门股票借券费",
    "EntrustSimulate_stamp": "印花税",
    "Language_create_time": "时间日期",
    "UserAccount_capital_total": "配资总额",
    "I118_id": "编号",
    "RiskControl_capital_order": "命令",
    "Baseconfig_cxlnk_template_code": "灿星云模板码",
    "Baseconfig_short_buy_price_config_others_main_board_up_des": "注意： 注意必填0到20数字，18表示当日涨幅0%到18%范围内可开仓（问题用户级别>全体用户级别）",
    "Stock_bourse": "所属交易所",
    "UserSimulate_number": "编号",
    "Deal_contract": "合同配资编号",
    "Withdraw_balance": "余额",
    "FlowLog_net_recharge": "净充值",
    "UserAccount_sell_fee_total": "出售股票佣金",
    "Agent_status": "代理商状态",
    "UserLevel_recharge_total_from": "合计充值从",
    "FeeLog_name": "股票名称",
    "DepotStop_day_number": "今日持仓",
    "UserSimulate_we_chat": "微信",
    "RechargeType_app_version": "APP版本",
    "Baseconfig_foundwinner_banner": "牛股横幅PC",
    "ActivityNotice_status": "地位",
    "DealSimulate_commission": "交易佣金",
    "Language_country_code": "国家码",
    "CapitalLog_type": "类型",
    "Baseconfig_description": "站点描述",
    "CapitalType_limit_delay": "延期限制",
    "Capital_remark": "备注",
    "AgentFlowLog_agent_phone": "代理电话",
    "Capital_name": "配资名称",
    "Baseconfig_is_direction_capital_enable": "是否开启单向配资",
    "NewCapitalTest_status": "配资状态",
    "NewCapitalTest_clear_time": "结算时间",
    "CoreSet_other_parameters": "其他参数",
    "News_source": "新闻来源",
    "Depot_capital": "配资id",
    "ActivityNotice_name": "标题",
    "NewCapitalTest_update_time": "更新时间",
    "StockFeeLog_deal": "成交记录ID",
    "SMS_uid": "用户id",
    "User_create_time": "注册时间",
    "CoreSet_handle_short": "空头经手费",
    "Distance_time": "未登天数",
    "FeeLog_commission": "佣金",
    "Baseconfig_site_title": "站点名称",
    "InterestLog_id": "编号",
    "FeeLog_create_time": "委托时间",
    "TimebaoAccount_update_time": "更新时间",
    "UserCoupon_uid": "用户ID",
    "Capital_cash": "分红金额",
    "WeekVoucherManagement_uid": "用户ID",
    "RiskControl_user_phone": "电话",
    "DepotStop_status": "股票状态",
    "First_total": "首充金额",
    "News_create_time": "创建时间",
    "DepotStop_surplus_total": "剩余价值",
    "AgentManage_capital": "配资id",
    "Withdraw_bank": "银行名",
    "Deal_sell_total": "出售总价值",
    "DealSimulate_mother": "母账户id",
    "UserAccount_user_caller": "客服专员",
    "AgentDeferred_agent": "代理商id",
    "StockFeeLog_agent": "代理ID",
    "News_udpate_time": "修改时间",
    "AgentAccount_agent_server_total": "服务费",
    "NewCapitalTest_staff": "员工id",
    "AgentDailyDepot_remark": "备注",
    "Minus_remark": "备注",
    "CoreSet_with_min": "最低提现",
    "PlusMinusType_type": "类型",
    "User_extension_type": "推广方式",
    "Sell_win": "卖出赢数",
    "User_push_team": "直推团队",
    "display_remark": "成交类型",
    "TimebaoAccount_lastcapital": "上一次计息金额",
    "No_holding_days": "未买入天数",
    "LanguageField_table_column": "字段名",
    "EntrustSimulate_staff": "员工id",
    "StockFeeLog_capital": "配资ID",
    "Baseconfig_google_captcha": "谷歌验证码",
    "AgentManage_agent_real_name": "上级名称",
    "RechargeType_comment": "备注",
    "RechargeType_recharge_method": "充值方式",
    "Recharge_md5info": "加密",
    "Baseconfig_short_buy_price_config_others_des ": "注意：必填-10到0数字，-9表示当日跌幅-9%到0%范围内可开仓（问题用户级别>全体用户级别）",
    "I118_language_ja": "日文",
    "Capital_fee_rate": "交易佣金比例",
    "Regular_broker_fee": "空头普通股票借券费",
    "I118_type": "消息类型",
    "Capital_id": "编号",
    "RechargeType_channel": "通道",
    "Minus_uid": "用户ID",
    "VoucherManagement_balance": "余额",
    "DepotStop_mother": "母仓id",
    "AgentFinance_finance": "总利息",
    "DealSimulate_fee": "交易佣金",
    "RiskControl_detail": "详细描述",
    "Protocol_id": "编号",
    "RiskControl_status": "是否已读",
    "UserCoupon_effect_date": "有效日期",
    "Account": "总户余额",
    "Deal_extra_fee3": "平台费用",
    "JobLog_module": "执行模块",
    "Deal_extra_fee2": "结算费用",
    "Deal_extra_fee1": "产品处理费",
    "AgentFlowLog_total": "总额",
    "TimebaoLog_user_real_name": "真正的名字",
    "EntrustSimulate_short": "证券简码",
    "I118_use_way": "使用场所",
    "WeekVoucherManagement_agent": "代理",
    "StockFeeLog_price": "成交价格",
    "ChatHistoryData_sender_name": "发件人名称",
    "AgentManage_remark": "备注信息",
    "Baseconfig_sys_checkinamount": "签到送代金卷",
    "FriendCouponLog_remark": "备注",
    "Agent_mother": "母账户id",
    "Bond_total": "操盘中保证金",
    "Baseconfig_pc_winner_logo_2_active": "牛人牛股 logo 已选",
    "SMS_status": "状态",
    "Baseconfig_buy_price_config_des": "注意： 注意必填0到10数字，9表示当日涨幅0%到9%范围内可开仓（问题用户级别>全体用户级别）",
    "DepotSimulate_create_time": "开仓时间",
    "Deal_capital": "配资id",
    "Capital_user_phone": "电话",
    "ChatGroupMember_groupId": "组ID",
    "NewCapitalTest_id": "编号",
    "Baseconfig_smsbao_url": "短信包URL",
    "UserSimulate_code": "推广码",
    "Baseconfig_default_agent_reserve": "默认代理模版",
    "Sell_loss": "卖出亏数",
    "Baseconfig_sms_password": "SMS密码",
    "UserSimulate_last_token_time": "最后TOKEN时间",
    "different_transaction_time_status": "是否不同交易时间用户",
    "FriendCouponLog_create_time": "创建时间",
    "Baseconfig_sms_account": "SMS账号",
    "AgencyDailyAccount_system_manage_total": "总管理费",
    "Baseconfig_downgrade_image": "下载页背景(电脑)",
    "FeeLog_fee": "交易佣金",
    "User_password": "密码",
    "Baseconfig_trade_time": "交易时间",
    "StockFeeLog_uid": "用户编号",
    "Partners_logo": "标识",
    "Stock_control_ratio": "风控比例",
    "FlowLog_user_real_name": "姓名",
    "Baseconfig_trading_popup_image_mob": "未交易提示详情图APP",
    "Capital_manage": "管理费",
    "Agentdailydepot_agent_real_name": "上级代理名称",
    "Baseconfig_company_qq1": "QQ客服1",
    "CoreSet_quota": "额度",
    "FeeLog_staff": "员工id",
    "ChatHistoryData_is_read": "已读",
    "Baseconfig_company_qq2": "QQ客服2",
    "regular": "规费",
    "WeekVoucherManagement_admin": "操作员",
    "Capital_total_userpage": "子户总资产",
    "Login_freeTrial": "免费体验",
    "StockFeeLog_regular_broker_fee": "空头普通股票借券费",
    "SysConfigLog_id": "编号",
    "WeekVoucherManagement_id": "编号",
    "NewCapitalTest_serve": "服务费（交易费用总计）",
    "First_trans_date": "首买日期",
    "Depot_sell_total": "卖出总价值",
    "Agent_login_ip": "登录ip",
    "Entrust_capital_order": "策略合约",
    "I118_controller": "来源模块",
    "newVersion": "新版本 ",
    "Recharge_user_real_name": "姓名",
    "CapitalType_profit": "盈利分成%",
    "data": "数据",
    "User_ip": "注册IP",
    "DepotStop_buy_total": "买入总价值",
    "AgentFee_balance": "平衡",
    "Withdraw_order": "订单号码",
    "Capital_renew_time": "续费时间",
    "PowerInterest_cq_cxr_h_ssr_zf": "除权除息日后30日涨幅%",
    "Activity_day_limit": "限购数量",
    "FriendCouponLog_amount": "金额",
    "AgentDeferred_staff": "员工id",
    "Baseconfig_stock_limit_price": "限制买卖价格",
    "AgentDailyDepot_total": "日小计",
    "CoreSet_commission_cost": "佣金成本",
    "FlowLog_create_time": "创建时间",
    "User_id": "编号",
    "Protocol_create_time": "创建时间",
    "DepotStop_short": "证券简码",
    "NewCapitalTest_extra": "提取利润",
    "FeeLog_id": "编号",
    "CapitalLog_num": "成交数量",
    "Baseconfig_short_buy_price_config_others": "做空主板下限价位（其他用户）",
    "Baseconfig_popup_pc_switch": "PC弹窗开关",
    "Recharge_from_address": "客户账户/地址",
    "freeze_status": "卖出限制状态",
    "Baseconfig_stock_price_times_short_des": "默认数是 0，意味着没有限制。1.2意味着限制了到卖出价的-20%。2意味着限制了到卖出价的-100%。",
    "Parameter_remark": "备注",
    "Entrust_capital": "配资id",
    "CoreSet_name": "模版名称",
    "Recharge_user_phone": "电话",
    "FirstVoucher_id": "编号",
    "Baseconfig_is_before_recharge": "未充值弹窗开关",
    "AgentManage_staff": "员工id",
    "AgentFee_staff_fee": "员工返佣",
    "AgentManage_user_real_name": "姓名",
    "here": "这里",
    "Stock_buy_down": "可以买跌",
    "RechargeType_id": "编号",
    "Baseconfig_pointed_user_diff_trade_time": "指定用户交易时间",
    "CoreSet_capital_interest_month_per": "按月配资利息",
    "CoreSet_status": "状态",
    "UserSuspect_id": "编号",
    "Baseconfig_stock_prohibit_price": "禁止买卖价格",
    "EntrustSimulate_commission": "佣金",
    "UserAccount_first_voucher_done": "是否已送",
    "NewCapitalTest_stamp": "印花税",
    "InterestLog_capital": "配资id",
    "Entrust_id": "编号",
    "DepotSimulate_surplus": "剩余可用",
    "Home_Management_fee_income_day ": "当天管理费收入",
    "Parameter_tip": "参数描述",
    "CapitalLog_remark": "备注",
    "Entrust_type": "业务类型",
    "Help_title": "标题",
    "Activity_status": "状态|1有效,无效|0",
    "Job_update_by": "更新者",
    "HomeConfig_app_download": "应用程序下载提示",
    "Activity_total": "总份数",
    "Stock_short": "短语",
    "Parameter_value": "参数键值"
  },
  "trc20": {
    "sameAddress": "接收和发送同一地址",
    "collectWalletNotSetting": "归集钱包没有设定",
    "lessThanMinAmount": "余额少于最小充值金额",
    "privateKeyError": "密钥设置出错"
  },
  "forgotLogin": {
    "loginNumber": "推荐码",
    "submitButton": "确定",
    "sure": "确定",
    "loginName": "登陆名",
    "newUsername": "新用户登陆名",
    "usernames": "登陆名",
    "title": "找回账号",
    "smsCodePlaceholder": "请输入短信验证码",
    "verificationCodePlaceholder": "请输入正确答案"
  },
  "modifyBank": {
    "sure": "确定",
    "canNotEmpty": "不能为空",
    "name": "开户人姓名",
    "back": "返回",
    "bindCard": "绑定银行卡",
    "bankName": "开户行全称",
    "cardNo": "银行卡卡号",
    "bankAddress": "开户行地址"
  },
  "entrustInquiry": {
    "inquire": "查询",
    "buySell": "买卖",
    "code": "代码",
    "commissionPrice": "委托价格",
    "back": "返回",
    "dealPrice": "成交价格",
    "transactionTime": "成交时间",
    "title": "委托查询",
    "orderQuantity": "委托数量",
    "commissionedDate": "委托日期",
    "commissionTime": "委托时间",
    "end": "没有更多了",
    "state": "状态",
    "transactionCount": "成交数量",
    "stock": "股票",
    "direction": "仓位方向"
  },
  "strategyNow": {
    "noMoreData": "没有更多了",
    "TotAssets": "当前总资产(元)",
    "maxProfitWithdrawn": "最高可提利润",
    "available": "可用",
    "profitWithdrawal": "利润提取",
    "profitAndLossWithoutMeas": "盈亏额",
    "type": "类型",
    "confirmSettlement": "结算确认",
    "balance": "余额",
    "statement": "对账单",
    "byDay": "按天",
    "funds": "资金",
    "details": "[明细]",
    "confirmSettlementQ": "确认结算当前子账号？",
    "strategyAccBalance": "子账户余额",
    "all": "全部",
    "proAndLoss": "盈亏",
    "funding": "配资中",
    "enterWithdrawalAmount": "请输入提取金额",
    "cost": "成本",
    "profitDistribution": "利益分配",
    "byWeek": "按周",
    "currentProfit": "当前盈利",
    "byMonth": "按月",
    "currentPrice": "现价",
    "marketValue": "市值",
    "completed": "已完成",
    "newAccount": "申请新配资账号",
    "profitAndLoss": "当前盈亏(元)",
    "profitAndLossMargin": "盈亏幅",
    "stopLoss": "触发止损",
    "triggerAlert": "触发警戒",
    "freezeFunds": "冻结资金",
    "time": "时间"
  },
  "foundWinner": {
    "smspackage": "短线宝",
    "highestPrice": "最高价",
    "signToRead": "注册可免费阅读",
    "code": "代码",
    "yuanYear": "元/年",
    "godofwealth": "问财神",
    "more": "更多",
    "recentFifteenDayIncreaseList": "近15日涨幅排行榜",
    "attentionToPrice": "关注价",
    "biggestIncrease": "最大涨幅",
    "registerLoginReadable": "注册登陆可读",
    "notLoggedIn": "您还未登录,前去登录",
    "pickOfDay": "每日精选 狙击尾盘",
    "bullstock": "牛人牛股",
    "stockName": "股票名",
    "latestStockPool": "最新股票池",
    "attentionTime": "关注时间",
    "lastchasing": "尾盘追击",
    "bigDataStock": "大数据选股 追踪实盘牛人",
    "dailySelectionPotentialStock": "每日精选3-5只潜力股",
    "name": "名称",
    "highestTime": "最高时间",
    "goldInvestHotStock": "金牌投顾每日推荐热点股"
  },
  "trading": {
    "cancel": "取消",
    "etrustClose": "委托/成交",
    "buy": "买入",
    "businessName": "业务名称",
    "buyQuantity": "买卖/数量",
    "dealPrice": "成交价格",
    "transactionTime": "成交时间",
    "noFundingContract": "还没有有配资合约，请先完成配资",
    "brokerageCommission": "券商佣金",
    "enterStockCode": "请输入交易股票代码",
    "enterTransactionPrice": "请输入股票交易价格",
    "commissionStatus": "委托/状态",
    "borrowingFee": "借券费",
    "balance": "余额 : ",
    "shortClose": "做空平仓",
    "tradeCancleTab": "撤单",
    "sureCancelStock": "您将要撤销该股票，是否继续",
    "numberOfSharesAvail": "可卖股数",
    "retrun_to_previous_page": "返回上一页,请重新尝试进入",
    "shortCloseSure": "您是否确定做空平仓?",
    "buyStockSure": "您是否确定买入该股票?",
    "sure": "确定",
    "settlementFee": "结算费用",
    "handle": "经手费",
    "quarterWarehouse": "1/3仓",
    "stockCode": "股票代码",
    "cancellation": "取消",
    "nameCode": "名称代码",
    "shortOpenSure": "您是否确定做空开仓?",
    "confTransaction": "确认交易",
    "position": "持仓",
    "longOpen": "做多开仓",
    "dateTime": "日期时间",
    "goToConfigureFunds": "前去配置配资",
    "openAvail": "持仓/可用",
    "downLimit": "跌停 : ",
    "marketPrice": "市价",
    "deal": "成交",
    "lumpSum": "总金额",
    "handlingFee": "手续费",
    "cancellationText": "撤单",
    "longClose": "做多平仓",
    "priceLimit": "限价",
    "numberOfTransactions": "成交数量",
    "fullPosition": "全仓",
    "longTrade": "做多交易",
    "openAvailSale": "持仓/可卖",
    "priceTotal": "价格/总额",
    "dailyLimit": "涨停 : ",
    "transferFee": "过户费",
    "sellMarketPrice": "市价",
    "turnover": "成交金额",
    "availableShares": "可买股数",
    "stockCodeDosntMatch": "请输入正确的股票代码或名称",
    "regular": "规费",
    "sell": "卖出",
    "sellStockSure": "您是否确认卖出该股票?",
    "marketValue": "持仓市值",
    "floatingProfitLoss": "浮动盈亏",
    "entrust": "委托",
    "confirm": "确认",
    "openPosition": "开仓",
    "closePosition": "平仓",
    "productHandlingFee": "产品处理费",
    "commissionTime": "委托时间",
    "shortTrade": "做空交易",
    "stampDuty": "印花税",
    "currentCostPrice": "现价/成本",
    "applyCapital": "申请配资",
    "returnToCapital": "请先申请配资获取子账号后再进行交易",
    "halfWarehouse": "半仓",
    "shortOpen": "做空开仓",
    "enterTransactionQuantity": "请输入股票交易数量",
    "marketBuy": "市价",
    "platformFees": "平台费用"
  },
  "agencyLink": {
    "copyPromo": "复制推广码",
    "enterPromotion": "方法三：注册页面输入推广码",
    "scan": "方法一：扫描二维码",
    "back": "返回",
    "copy": "复制链接",
    "copySuccess": "复制成功",
    "promotion": "我的推广链接",
    "register": "方法二：点击链接注册"
  },
  "activity": {
    "inActive": "已结束",
    "back": "返回",
    "active": "进行中",
    "title": "活动专区"
  },
  "operateDay": {
    "alertM": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足"
  },
  "login": {
    "Greeting": "您好，欢迎来到{company_name}交易平台！",
    "registerkey": "马上注册",
    "forgetPassword": "忘记密码？",
    "passwordPlaceholder": "请输入密码",
    "loginkey": "登录",
    "login": "登录",
    "title": "登录",
    "signUp": "立即注册",
    "enterUsername": "请输入登陆名",
    "password": "密码",
    "logout": "退出登录",
    "forgotPassword": "忘记密码?",
    "enterCaptcha": "请输入正确答案",
    "passwordError": "请输入您的登录密码",
    "onlineService": "在线客服",
    "resendVerifyCode": "{title}秒后重新发送",
    "sendVerifyCode": "发送验证码",
    "pleaseLogin": "您好请登录",
    "lineThree": "线路三",
    "captchaIncorrect": "图片验证码不正确",
    "forgotPass": "忘记密码?",
    "usernameError ": "请输入您的用户登陆名",
    "isSimulate": "免费体验",
    "submitButton": "登录",
    "verifyCode": "验证码",
    "verifyCodeLogin": "验证码登录",
    "enterPhone": "请输入手机号",
    "passwordTip": "密码由6-15位字母或数字组成",
    "dontHaveAccount": "没有账户？",
    "enterPassword": "请输入登录密码",
    "userLogin": "用户登录",
    "phoneNumber": "用户登陆名",
    "success": "登录成功",
    "resend": "重新发送",
    "phonePlaceholder": "请输入登陆名",
    "phoneFormatIncorrect": "手机号格式不正确",
    "loginError": "账号或密码错误",
    "account": "账户",
    "forgotLoginName": "忘记登陆名",
    "register": "注册",
    "confirmLogout": "您确认要退出登录吗？",
    "logoutSuccess": "退出成功"
  },
  "riskControl": {
    "noMore": "没有更多了",
    "back": "返回",
    "ignoreNotice": "忽略",
    "notice": "风控通知",
    "readNotice": "检查风控通知"
  },
  "capitalAccountDetails": {
    "cancel": "取消",
    "riskMargin": "风险保证金",
    "moreOperations": "更多操作",
    "update": "点击更新",
    "title": "账户详情",
    "marketPositionValue": "持仓市值({currency})",
    "applicationQuota": "申请额度",
    "additionalAllocation": "追加配资",
    "lossWarningLine": "亏损警戒线 (亏损比)",
    "fundingDetails": "资金明细",
    "marginCall": "追加保证金",
    "lossClosingLineWithoutRatio": "亏损平仓线",
    "settleConfirmation": "您是否确定结算该合约?",
    "currentTotalBond": "当前总保证金",
    "availableQuota": "可用额度({currency})",
    "sure": "确定",
    "revenueShare": "收益分成",
    "lossWarningLineWithoutRatio": "亏损警戒线",
    "lossClosingLine": "亏损平仓线 （亏损比）",
    "operationDays": "已操盘天数",
    "profitLoss": "当前盈亏({currency})",
    "longTrading": "做多交易",
    "curentTotalAsset": "当前实际总资产",
    "shortTrading": "做空交易",
    "positionRatio": "持仓比例",
    "entrustment": "交易委托",
    "confirm": "确认",
    "currentTotalProfitLoss": "当前总盈亏",
    "managementFee": "账户管理费",
    "applySettlement": "申请结算",
    "currentTotalAssets": "当前总资产({currency})",
    "totalFunds": "总配资资金"
  },
  "forgotPassword": {
    "smsVerificationCode": "短信验证码",
    "getVerificationCode": "获取验证码",
    "submitButton": "完成",
    "newPasswordPlaceholder": "请输入新密码",
    "confirmPasswordPlaceholder": "在次输入新密码",
    "back": "返回",
    "newPassword": "新密码",
    "title": "忘记密码",
    "verificationCode": "验证码",
    "verificationCodePlaceholder": "请输入正确答案",
    "phoneFormatError": "手机号格式不正确",
    "phone": "手机号",
    "phonePlaceholder": "请输入手机号",
    "confirmPassword": "再次新密码",
    "newUsernamePlaceholder": "请输入您的新用户登陆名",
    "smsCodePlaceholder": "请输入短信验证码",
    "usernamePlaceholder": "请输入登陆名"
  },
  "agencyPc": {
    "cancel": "取 消",
    "date": "日期",
    "membershipLevel": "会员等级",
    "withdrawTotal": "提取总额",
    "nextLevelPeopleNoThree": "下三级持仓人数",
    "firstChargeAmount": "首充金额",
    "transferAmount": "划转金额",
    "myCommission": "我的佣金",
    "commisionWithdrawal": "佣金提现",
    "inviteFriendsScanQr": "方法一：邀请好友扫描二维码注册",
    "bankCardManagement": "银行卡管理",
    "type": "类型",
    "withdrawHundred": "提现100元起",
    "totalRecharge": "充值总额",
    "agentLevel": "代理级别",
    "withdrawPassword": "提现密码",
    "deferredFee": "递延费佣金",
    "noofpeopleholdingtwo": "下二级持仓人数",
    "levelThreeMember": "三级会员",
    "balance": "余额",
    "withdrawalAmount": "提现金额",
    "commissionShare": "佣金分成",
    "bankCardWithdrawalInName": "名字的银行卡提款",
    "day": "天数",
    "selectmonth": "选择月份",
    "nextLevelPeopleNoTwo": "下二级持仓人数",
    "methodThree": "方法三:注册时填入推荐代码",
    "methodTwo": "方法二:点链接注册",
    "fromProxyAmount": "从代理账户",
    "memberToday": "今日会员",
    "withdrawnCurrency": "元即可提现",
    "managementFeeDetails": "管理费明细",
    "friendGift": "好友单次充值满 {couponAmountMultiplied} 元送 {amount}",
    "deferredFeeDetails": "递延费明细",
    "memberNo": "会员号",
    "agencyAccount": "代理账户",
    "myPromotion": "我的推广",
    "operate": "操作",
    "selectMonth": "选择月份",
    "phoneNumber": "手机号",
    "transfer": "划转",
    "month": "月份",
    "enterCorrectAmount": "请输入正确金额",
    "nextLevelPeopleNo": "下一级持仓人数",
    "cardNumber": "卡号",
    "myMember": "我的会员",
    "status": "状态",
    "allMembers": "所有会员",
    "bankCardNumber": "银行卡号",
    "noOfSubordinates": "下级持仓人数",
    "accountName": "开户姓名",
    "scanToRegister": "方法一:扫二维码注册",
    "noofpeopleholding": "下一级持仓人数",
    "secondaryMember": "二级会员",
    "afterAllocationFunds": "配资后买入额达到",
    "dailyAveragePositions": "日均持仓人数",
    "noRechargeMember": "无充值会员",
    "memberName": "会员名",
    "bankName": "银行名称",
    "dailysubtotal": "日小计人数",
    "noOfDays": "天数",
    "managementCommission": "管理费佣金",
    "toPrincipalAccount": "到本金账户",
    "commissionBalance": "佣金余额",
    "couponNumberPerPerson": "编号: {number}（只限一人使用）",
    "friendCashCoupon": "好友现金券",
    "enterWithdrawalPassword": "请输入提现密码",
    "rechargeMember": "充值会员",
    "member": "会员",
    "firstClassMember": "一级会员",
    "copySuccess": "复制成功",
    "copyLink": "复制链接",
    "noofdailyholders": "每日持仓人数总和",
    "fillTransferAmount": "请填写划转金额",
    "fillWithdrawalAmount": "请填写提现金额",
    "accountOpeningBranch": "开户支行",
    "amount": "金额",
    "subordinatePositions": "下级持仓人数",
    "profitSharing": "利润分成",
    "memberRechargeRewardDetails": "会员充值奖励明细",
    "fundingAccount": "配资账户",
    "inviteFriendsToRegister": "通过以下三种方法邀请好友注册",
    "dailyPositionNo": "每日持仓人数总和",
    "noofpositionsperday": "日均持仓人数",
    "profitSharingDetails": "利润分成明细",
    "useYourOwn": "请务必用本人",
    "myMemberSub": "无充值会员",
    "dailySubTotal": "日小计人数",
    "noofpeopleholdingthree": "下三级持仓人数",
    "time": "时间",
    "accountBalance": "账户金额",
    "withdrawAndTransfer": "提现划转",
    "withdraw": "提现"
  },
  "recharge": {
    "contToRecharge": "继续新充值",
    "show": "显示",
    "back": "返回",
    "rechargeName": "充值名称",
    "title": "充值",
    "rechargeChannel": "充值通道",
    "amountGreater": "充值金额必须为大于100元",
    "enterAmount": "请输入正确的充值金额",
    "contactCustomerService": "请联系客服",
    "rechargeType": "选择您的充值方式",
    "rechargeMethod": "充值方式",
    "all": "全部",
    "amount": "充值金额",
    "rechargeInstructions": "获取实时入款卡，请自行通过手机/电脑/银行转账",
    "currentBalance": "当前余额",
    "understand": "我已经明白",
    "lastSelected": "上次选择",
    "submitAgain": "您已提交一笔同金额的充值正在审核处理中\\n若非新充值请勿重复提交?'",
    "selectRechargeType": "请选择充值类型",
    "yuan": "元",
    "activityArea": "活动专区",
    "hide": "隐藏",
    "maxIs2Mil": "人工入款金额最大金额为200万",
    "nextStep": "下一步",
    "noNewRecharge": "非新充值"
  },
  "opeartehuhui": {
    "minMax": "最少100,最多200万,1百整倍数",
    "agree": "我已阅读并同意"
  },
  "rechargeau": {
    "cancel": "取 消",
    "capitalAllocation": "立即配资交易",
    "totalAssets": "资产总计",
    "voucherBalance": "代金券",
    "friendCoupons": "前往好友现金券",
    "enterYourPhoneNumber": "请输入手机号",
    "firstChargeGiftList": "首充礼品清单",
    "enterYourRealName": "请输入真实姓名",
    "balance": "账户余额",
    "recharge": "充值",
    "PromotionAccount": "推广账户",
    "remindInThisWeek": "关闭并本周不提醒",
    "signin": "签到",
    "details": "明细",
    "CurrentTotalAsset": "当前总资产",
    "viewDetails": "查看明细",
    "enterYourID": "请输入身份证号",
    "sure": "确 定",
    "totalFreezeMargin": "总冻结保证金",
    "mainAccountBalance": "主账户",
    "setPhone": "手机是您找回登陆名和密码的重要依据!",
    "cashBonus": "现金红包",
    "availableFunds": "可用资金",
    "newMemberTrade": "新会员交易红包清单",
    "capitalAccountBalance": "配资账户",
    "agencyCommission": "代理佣金",
    "enterYourId": "请输入身份证号",
    "myAccount": "我的账户",
    "withdraw": "提现"
  },
  "announcementDetails": {
    "back": "返回",
    "title": "平台公告"
  },
  "validate": {
    "Amount_not_set": "请输入有效额度",
    "EnterValidPhoneNumber": "输入长度为 6-12 个字符（不包括符号）的有效数量",
    "EmptyPhoneNumber": "电话号码为空",
    "phoneRegistered": "电话号码已被使用请换一个",
    "bankAlreadyBind": "Bank Account already bound",
    "EmptyUsername": "您的登陆名或手机号码不正确，请重新输入",
    "emailFormatError": "邮箱格式有误",
    "CustomerService_offline": "暂客服离线，请稍后联系",
    "pleaseInputCorrect": "请输入正确的{title}",
    "required": "必要",
    "invalidRefCode": "请正确填写参考码",
    "EnterValidReferral": "请输入正确的推荐码（必填）",
    "formatError": "{title}格式错误",
    "refRequired": "注册需要参考码",
    "EnterValidPassword": "输入长度为 6-12 的有效密码（不包括符号）",
    "Chatgrp_founder_required": "必填群组创建客服",
    "PhoneRegistered": "电话号码已注册 尝试另一个电话号码",
    "notBlank": "{title}不能为空",
    "safetyPasswordNotSet": "未设置安全密码",
    "emailRegistered": "电子邮件已被使用请使用另一个",
    "PasswordAndConfirmPasswordNotMatching": "密码与确认密码不匹配",
    "verifyCodeError": "验证码错误",
    "walletAlreadyBind": "Wallet you are trying to bind, already have been bound.",
    "verifyCodeExpire": "验证码过期",
    "passwordNotBlank": "密码不能为空",
    "reentryError": "两次{title}输入不一致",
    "passwordNoMatch": "密码错误",
    "Chatgrp_type_required": "必填群组类型",
    "EmptyPassword": "密码为空",
    "phoneNotTheSameUser": "请确认电话和登录用户电话一致",
    "EnterRecommendCode": "请输入正确的推荐码 (必填)",
    "nameIsExisted": "昵称已经存在",
    "UsernameRegistered": "该登陆名已被注册过",
    "Chatgrp_name_required": "必填群组名称",
    "walletAddressFormatError": "钱包格式无效",
    "pleaseSelect": "请选择{title}",
    "phoneIsExisted": "该电话已经被注册",
    "NameRegistered": "名称已被使用请使用另一个"
  },
  "stockTrading": {
    "quantity": "数量",
    "limitPrice": "跌停价",
    "longClose": "做多平仓",
    "stockCode": "股票代码",
    "openingPrice": "开仓价格",
    "openPosition": "开仓",
    "closePosition": "平仓",
    "feeLogId": "费用记录ID",
    "borrowingFee": "借券费",
    "availableSharesForSale": "可卖股数",
    "shortClose": "做空平仓",
    "shortOpen": "做空开仓",
    "position": "持仓",
    "availableShares": "可买股数",
    "longOpen": "做多开仓"
  },
  "stockUnactivity": {
    "over": "已结束",
    "pleaseTryLater": "请稍后尝试",
    "sure": "确定",
    "inProgress": "进行中",
    "joinNow": "马上参加",
    "hint": "提示",
    "viewActivity": "查看活动",
    "newYearEnvelope": "新年开市红包等你拿",
    "time": "时间",
    "specialPriceArea": "优惠专区"
  },
  "backupAPISettings": {
    "submitBtn": "确认",
    "subTitle": "您的网络延迟已切换至最优线路",
    "title": "线路切换"
  },
  "agency": {
    "promotionAccount": "推广账户",
    "transfer": "资金提现划转",
    "balance": "佣金余额",
    "depot": "下级持仓人数",
    "link": "推广链接",
    "back": "返回",
    "team": "我的团队",
    "commissionTransfer": "佣金划转"
  },
  "modifyNickName": {
    "sure": "确定",
    "canNotEmpty": "不能为空",
    "nickname": "昵称",
    "back": "返回",
    "title": "修改昵称"
  },
  "stockRise": {
    "stockExchange": "上证",
    "latestPrice": "最新价",
    "theCode": "代码",
    "quoteChange": "涨跌幅",
    "sell": "卖出",
    "buy": "买入",
    "changeAmount": "涨跌额",
    "lowest": "最低",
    "pleaseTryLater": "请稍后尝试",
    "bigData": "大数据100",
    "highest": "最高",
    "hint": "提示",
    "name": "名称",
    "millionYuan": "亿元",
    "openToday": "今开",
    "receivedYesterday": "昨收",
    "deepInto": "深成"
  },
  "menu": {
    "CoreSet": "收费标准",
    "AgentDivide": "利润分成",
    "FoundWinners": "发现牛股",
    "UserFolder": "用户管理",
    "Store": "商家管理",
    "RechargeType": "充值设置",
    "Activity": "推广活动",
    "AgentFee": "分成日志",
    "Recharge": "充值管理",
    "AgentManage": "管理费分成",
    "ChatGroupMessageLog": "群组记录管理",
    "I118": "语言消息",
    "TimebaoBatchLog": "时时宝结算日志",
    "Components": "用户管理",
    "UserSimulate": "模拟用户管理",
    "FinanceFolder": "闲钱管家",
    "Complain": "投诉管理",
    "Currency": "货币管理",
    "CapitalTest": "资本测试",
    "OperLog": "操作日志",
    "AgentAccount": "代理账户",
    "Operations": "操作",
    "FinancialStatistics": "财务统计",
    "Agent": "代理管理",
    "ChatGroupMember": "群组 会员管理",
    "MassageFolder": "养生服务",
    "UserBank": "用户银行",
    "WalletFolder": "钱包管理",
    "CompanyBank": "收款账户",
    "TradeChannalLog": "TradeChannalLog",
    "QuickReply": "预制答复",
    "HomeCapital": "用户管理",
    "Secrect": "应用秘钥",
    "AgentReserve": "佣金模板",
    "CapitalLogType": "资本日志类型",
    "Sms": "短信管理",
    "SMS": "短信",
    "Application": "应用管理",
    "Minus": "后台扣除",
    "Stock": "股票管理",
    "UserVip": "用户VIP等级",
    "QuickReplyCategory": "快速回复类别",
    "RiskControl": "风控日志",
    "Help": "操盘助手",
    "Discount": "折扣",
    "Bank": "银行",
    "RoomMessage": "聊天信息",
    "ChatGroup": "群组管理",
    "UserNotice": "信息通知",
    "HomeProblem": "用户管理",
    "Pcconfiguration": "电脑首页管理",
    "Promotion": "晋升",
    "CapitalLog": "资金流水",
    "CapitalType": "配资类型",
    "Mother": "证券账户",
    "FinanceAccount": "财务账户",
    "AgentWithdraw": "代理提现",
    "Chat": "聊天",
    "SysConfigLog": "系统配置日志",
    "PlusMinusType": "后台充值类型",
    "CoinChainType": "币链类型 ",
    "Menu": "菜单管理",
    "Protocol": "协议管理",
    "SystemChat": "发送广播",
    "Sysconfig": "系统配置",
    "FriendCoupon": "好友现金券",
    "CapList": "列表",
    "Baseconfig": "基本配置",
    "Capital": "擦盘配资",
    "RsaKey": "密钥管理",
    "Partners": "合伙人",
    "PeiziFolder": "配资管理",
    "Entrust": "委托管理",
    "WalletCollectHistory": "钱包归集日志",
    "Parameter": "参数配置",
    "FlowType": "流水类型",
    "VoucherManagement": "用户代金券",
    "CustomerService": "客服服务",
    "PragmaticGames": "实用游戏",
    "DepotStop": "持仓停牌",
    "UserSuspect": "用户怀疑",
    "FlowLog": "资金流水",
    "CompanyAliPay": "公司支付宝",
    "DepotSimulate": "模拟持仓",
    "AgentPeriodDepot": "代理管理周期持仓人数",
    "UserAddress": "用户地址",
    "AgentFlowLog": "代理费日志",
    "CustomerAgent": "客服管理",
    "HomeConfig": "手机首页管理",
    "AgentDailyDepot": "代理管理每日持仓人数",
    "Uploadconfig": "缩略图配置",
    "Formula": "公式管理",
    "InterestLog": "配资付息 ",
    "Notice": "内部通知",
    "Test": "测试模块",
    "UserBankType": "账户类型",
    "ComplainType": "举报类型",
    "WithdrawMethod": "提现方式",
    "Job": "批处理管理",
    "Plus": "后台充值",
    "ActivityNotice": "公告管理",
    "FriendCouponLog": "好友现金券日志",
    "Tool": "工具管理",
    "Order": "订单管理",
    "Evaluation": "用户评价",
    "AgencyDailyAccount": "代理日帐",
    "EMS": "电子邮件管理",
    "SendSms": "SendSms",
    "DailyReport": "每日报表",
    "Deal": "成交管理",
    "StockBorrowDeal": "借券费成交管理",
    "AgentCommission": "佣金明细",
    "ActivityFolder": "公告活动",
    "VoucherCash": "赠送现金",
    "Role": "分组管理",
    "TimebaoAccount": "时时宝账户",
    "Cap": "测试",
    "Adminuser": "用户管理",
    "RechargeMethod": "充值方式",
    "CoinRechargeAddr": "用户充值地址",
    "Bankaccountnumber": "银行帐号",
    "PowerInterest": "除权除息",
    "OrderService": "服务明细",
    "NewCapitalTest": "新资本测试",
    "TimebaoLogType": "时间宝_日志类型",
    "Agentdailydepot": "代理管理每日持仓人数",
    "AgentFolder": "代理管理",
    "Action": "方法管理",
    "ExchangeRate": "汇率管理",
    "FirstVoucher": "首冲活动",
    "User": "用户管理",
    "DepotFolder": "操盘管理",
    "LanguageField": "字段多语言",
    "UserLevel": "用户充值级别",
    "Config": "配置管理",
    "MonitoredUser": "问题用户",
    "WeekVoucherManagement": "代金券审批",
    "Information": "其他内容",
    "System": "系统管理",
    "ChatHistoryData": "消息管理",
    "FeeLog": "交易佣金",
    "UserControl": "用户风控 ",
    "AgentFinance": "代理金融",
    "Field": "字段管理",
    "Language": "语言管理",
    "UserCoupon": "我的现金券",
    "CommentLabel": "评论标签",
    "AgentFlowType": "代理流类型",
    "News": "新闻管理",
    "PragmaticGamesList": "实用游戏列表",
    "Banksetting": "银行设置",
    "Home": "首页",
    "Room": "房间设置",
    "RechargeBankLog": "充值银行日志",
    "HolidayAccount": " 假日帐户",
    "HomeConfig_pc_title": "电脑首页管理",
    "DealSimulate": "模拟成交",
    "AgentVoucher": "代理凭证",
    "Coupon": "折扣劵",
    "ChatHistory": "聊天记录",
    "TimebaoLog": "时时宝日志",
    "Withdraw": "提现管理",
    "DeferLog": "延迟日志",
    "Wallet": "平台钱包",
    "AgentDeferred": "递延费分成",
    "AboutUs": "关于我们",
    "ParameterFolder": "参数管理",
    "Logininfor": "登录日志",
    "StockFeeLog": "借券费管理",
    "CoinWithdrawAddr": "用户提现钱包",
    "Closed": "节假日",
    "JobLog": "批处理日志",
    "EntrustSimulate": "模拟委托",
    "Depot": "持仓管理",
    "Api": "API接口",
    "UserAccount": "账户管理"
  },
  "entrust": {
    "minimumAdditional": "最低追加",
    "additionalStrategy": "股票账户追加策略，您支付的追加金额必须为100的整数！",
    "totalStrategicFunding": "总操作资金",
    "totalContractAssets": "合约总资产(元)",
    "appendStrategy": "追加配资",
    "withdrawProfits": "提取利润",
    "numberOfSharesHeld": "持有股数",
    "daysOfStrategy": "已策略天数：",
    "transactionEntrustment": "交易委托",
    "currentMarketValue": "当前市值",
    "tradingDay": "交易日",
    "positionDetails": "持仓详情",
    "indivual": "个",
    "additionalPerformance": "股票账户追加保证金，您支付的追加金额必须为100的整数！",
    "riskPerformanceFee": "保证金",
    "policyDetails": "策略详情",
    "tradingMonth": "交易月",
    "additionalPerformancePayment": "追加保证金"
  },
  "stockData": {
    "enterCode": "请输入股票代码或简拼"
  },
  " stockrise": {
    "previous": "上一页"
  },
  "help": {
    "helpCenter": "帮助中心"
  },
  "friendCoupon": {
    "qr": "推广二维码/链接",
    "yuan": "元",
    "amount": "金额",
    "balance": "余额 :",
    "terms": "使用须知",
    "giftDate": "赠送日期",
    "back": "返回",
    "details": "详情",
    "state": "状态",
    "expiry": "到期日期",
    "termsAndCondition": "使用须知",
    "cash": "好友现金券"
  },
  "rechargeHeader": {
    "lastLoginTime": "上次登录时间",
    "totalProfitLoss": "总浮动盈亏",
    "accountName": "帐户名",
    "signIn": "签到",
    "totalSecurityMarketValue": "总证券市值",
    "authenticateInfo": "信息认证",
    "totalFrozenFunds": "总冻结资金"
  },
  "chat": {
    "messageEmpty": "空消息",
    "system": "系统消息",
    "messageFailed": "请求超时",
    "onlineService": "在线客服",
    "exclusiveCust": "专属客服"
  },
  "information": {
    "cancel": "取消",
    "getVerificationCode": "获取验证码",
    "enterIdNumber": "请输入身份证号",
    "unbound": "未绑定",
    "changeUsername": "修改昵称",
    "enterNewPass": "请输入新密码",
    "notSet": "未设置",
    "enterAccountName": "请输入开户人姓名",
    "bindPhone": "绑定手机号码",
    "title": "安全设置",
    "enterCaptchaCode": "请输入正确答案",
    "enterPass": "请输入密码",
    "withdrawPass": "提款密码",
    "bindBankCard": "绑定银行卡",
    "bind": "绑定",
    "enterConfPass": "请输入确认密码",
    "loginPass": "登录密码",
    "certified": "认证",
    "enterNickName": "请输入昵称",
    "enterBankAddress": "请输入开户行地址",
    "notCertified": "未认证",
    "enterEmail": "请输入邮箱",
    "enterBranchName": "请输入开户行支行",
    "enterBranch": "请输入开户行支行",
    "nickName": "昵称",
    "securitySettings": "安全设置",
    "bindMail": "绑定邮箱",
    "verified": "实名认证",
    "firstChargeGift": "首充礼品清单",
    "enterPhone": "请输入手机号码",
    "enterRealName": "请输入真实姓名",
    "hasSet": "已设置",
    "mobilePhoneBind": "手机绑定",
    "bankCardBind": "银行卡绑定",
    "confirm": "确认",
    "revise": "修改",
    "enterVerCode": "请输入验证码",
    "phoneFormatIncorrect": "手机号格式不正确",
    "setup": "设置",
    "enterBankCard": "请输入银行卡号",
    "topUpNow": "立即充值",
    "passwordMismatch": "两次密码输入不一致",
    "numberFormatError": "手机号码格式不正确"
  },
  "stockrise": {
    "next": "下一页",
    "latestPrice": "最新价",
    "sure": "确定",
    "code": "代码",
    "bigdata": "大数据100",
    "quoteChange": "涨跌幅",
    "settled": "已结算",
    "sell": "卖出",
    "buy": "买入",
    "tryAgain": "请稍后尝试",
    "milYuan": "亿元",
    "changeAmount": "涨跌额",
    "deepinto": "深成",
    "settlement": "昨收",
    "bigData": "大数据100",
    "high": "最高",
    "low": "最低",
    "previoustxt": "上一页",
    "hint": "提示",
    "name": "名称",
    "exchange": "上证",
    "deepInto": "深成",
    "open": "今开"
  },
  "registerPc": {
    "cancel": "取消",
    "gift": "豪礼一：新用户注册送",
    "getVerificationCode": "获取验证码",
    "pleaseEnterPassword": "请输入登录密码",
    "newUserRegistration": "新用户注册",
    "loginToClaim": "请登录领取",
    "loginImmediately": "立即登录",
    "createNow": "立即创建",
    "registerToSend": "注册送",
    "userRegister": "用户注册",
    "pleaseEnterPhoneNumber": "请输入手机号",
    "registerSuccess": "您已注册成功",
    "pleaseEnterSmsVerificationCode": "请输入短信验证码",
    "firstCharge": "首充",
    "pleaseEnterUsername": "请输入登陆名",
    "agree": "我同意",
    "whiteSpaceErrorMessage": "请使用中文，字母或数字进行注册",
    "riskDisclosureStatement": "《风险揭示书》",
    "registerAgreement": "《注册协议》",
    "giftMoney": "元礼金",
    "highestExclusiveGift": "新会员最高专享礼",
    "agreeRegistrationAgreement": "请同意注册协议",
    "phoneFormatIncorrect": "手机号格式不正确",
    "pleaseEnterGraphicCode": "请输入正确答案",
    "pleaseEnterReferralCode": "请输入推荐码（必填）"
  },
  "appdownload": {
    "iostf": "苹果TF下载",
    "subtitle": "实力券商品牌 百万股民信赖",
    "android": "安卓下载",
    "title": "凤凰证券",
    "microsoft": "电脑版下载",
    "iphone": "苹果下载"
  },
  "forgotLoginName": {
    "phonePlaceholder": "请输入手机号",
    "title": "找回登陆名"
  },
  "register": {
    "smsVerificationCode": "短信验证码",
    "getVerificationCode": "获取验证码",
    "submitButton": "注册",
    "smsCodeError": "请输入短信验证码",
    "passwordPlaceholder": "请输入密码",
    "back": "返回",
    "recommenderPlaceholder": "请输入推荐码（必填）",
    "firstCharge": "首充送",
    "title": "注册",
    "verificationCode": "验证码",
    "verificationCodePlaceholder": "请输入正确答案",
    "smsVerificationCodePlaceholder": "请输入短信验证码",
    "phoneFormatError": "手机号格式不正确",
    "highestExclusive": "新会员最高专享礼",
    "RegisterAnAccount": "账号注册",
    "password": "设置密码",
    "phone": "手机号码",
    "toSend": "注册送",
    "phonePlaceholder": "请输入登陆名",
    "onlineService": "在线客服",
    "newUserVoucherNotice": "注册送 {voucher} 元 + 首充送 {initialAmount} 元",
    "recommender": "推荐码"
  },
  "userCoupon": {
    "recharged": "现金券: 充值满",
    "requirements": "要求 配资后买入额达到",
    "canWithdraw": "元后可提现",
    "use": "去使用",
    "withdrawnCurrency": "元后可提现",
    "noRecords": "暂无记录",
    "deliver": "送",
    "back": "返回",
    "validityRecharge": "有效期",
    "myCash": "我的现金券",
    "cashCouponRecharge": "现金券 : 充值满{itemAmountMultiplied}元送{itemAmount}元",
    "yaun": "元",
    "validityRechargekey": "有效期",
    "validity": "有效期:",
    "noCoupon": "暂无我的现金券",
    "myCashCoupon": "我的现金券"
  },
  "capital": {
    "rechargeFull": "充值满",
    "enterConfirmationPw": "请输入确认密码",
    "enterRechargeAmount": "请输入充值金额",
    "selectWithdrawalAmount": "请选择提现账号",
    "totalOnly": "账户余额",
    "accNameOther": "账户名称",
    "rechargeName": "充值名称",
    "successRechargeApp": "充值申请成功,尽快完成后续操作,联系客服吧",
    "fillCorrectAmount": "请填写正确金额",
    "contactCustomerService": "请联系客服",
    "rechargeMethod": "充值方式",
    "all": "全部",
    "lastSelected": "上次选择",
    "confirmPaid": "请确认您已付款！重复提交会影响到账时间",
    "bankAddress": "银行地址",
    "enterBankCardNum": "请输入银行卡号",
    "operate": "操作",
    "inconsistentPw": "两次密码输入不一致",
    "rechargeAmount": "充值金额",
    "enterCorrectAmount": "请输入正确金额",
    "hint": "提示",
    "pleaseAt": "请在",
    "withdrawlBaseFee": "提现手续费按提现金额的",
    "cardNumber": "卡号",
    "priceTicket": "代金券",
    "msgTransferEarn": "转入时时宝, 每8小时收益",
    "bankCardNumber": "银行卡号",
    "rechargeObtainCard": "获取实时入款卡,请自行通过手机/电脑/银行转账",
    "show": "显示",
    "paymentAmount": "付款金额",
    "fillWithdrawalPw": "请填写提现密码",
    "yuanFrom": "元起",
    "rechargeChannel": "充值通道",
    "paidBefore": "之前付款",
    "nameInBankCrdWithdrwal": "名字的银行卡提款!",
    "chooseRechargeMethod": "请选择充值方式",
    "rechargeAmountBottom": "充值方式",
    "openPaymentChannel": "正在打开支付通道",
    "fillRechargeAmount": "请填写充值金额",
    "paymentTime": "付款时间",
    "nameAccHolder": "请输入开户人姓名",
    "stockTradMsg": "%\\n开市炒股，休市理财， 时时赚钱\\n随进随出， 实时到账，年化收益率",
    "enterBankAddress": "请输入开户行地址",
    "charge": "收取,",
    "enterBranchName": "请输入开户行支行",
    "bankBranch": "银行支行",
    "withdrawl100RMB": "提现100元起",
    "contToWithdraw": "继续提现",
    "accName": "开户姓名",
    "fillWithdrwalAmount": "请填写提现金额",
    "unDeleted": "已取消删除",
    "selectRechargeType": "请选择充值类型",
    "confirmYourOwn": "请务必用本人",
    "contactOnlineCustomerSer": "在线客服",
    "submitWithdrawlMsg": "您已提交一笔同金额的提现正在审核处理中，若非新提现请勿重复提交",
    "bankCardMang": "银行卡管理",
    "hide": "隐藏",
    "accBalance": "账户金额",
    "rechargeSubmitMsg": "您已提交一笔同金额的充值正在审核处理中，若非新充值请勿重复提交",
    "myAccount": "我的账户",
    "msgAboutAmount": "(须带小数与系统显示金额一致）"
  },
  "positionInquiry": {
    "availableQuantity": "可卖数量",
    "openPositions": "总持仓数",
    "costPrice": "成本价",
    "currentPrice": "当前价",
    "back": "返回",
    "title": "持仓查询",
    "floatingProfitLoss": "浮动盈亏",
    "positionMarketValue": "持仓市值",
    "frozenQuantity": "冻结数量",
    "nameCode": "名称代码",
    "contractId": "合约号",
    "end": "没有更多了",
    "openingDate": "开仓日",
    "direction": "仓位方向"
  },
  "modifyEmail": {
    "enterEmail": "请输入邮箱",
    "enterEmailLable": "请输入您要更改的邮箱",
    "mail": "邮箱",
    "submit": "提交",
    "smsVerification": "短信验证码",
    "back": "返回",
    "smsVerificationLable": "请输入您新邮箱收到的验证码",
    "getVerification": "获取验证码"
  },
  "allNews": {
    "back": "返回",
    "end": "没有更多了",
    "title": "新闻资讯"
  },
  "sysetem": {
    "captchaExpire": "验证码过期",
    "captchaError": "验证码错误"
  },
  "capitalHistory": {
    "noMoreData": "没有更多了",
    "riskMargin": "风险保证金",
    "lossClosingLine": "亏损平仓线（亏损比）",
    "floatingProfit": "浮动盈亏",
    "riskBond": "风险保证金:{bond}",
    "currentAllocation": "当前配资",
    "historyAllocation": "历史配资",
    "accumilatedProfit": "累计盈亏:",
    "longTrading": "做多交易",
    "shortTrading": "做空交易",
    "availableBalance": "可用余额",
    "accountInformation": "账户信息",
    "lossRatio": "亏损警戒线 (亏损比)",
    "currentTotal": "当前总资产",
    "totalFunds": "总配资资金:{total}",
    "tradingStocks": "交易股票"
  },
  "protocol": {
    "back": "返回",
    "goBackLastPage": "返回上一页",
    "riskDisclosure": "风险揭示书",
    "title": "协议",
    "instructionsUseFCC": "好友现金券使用须知"
  },
  "download": {
    "windowsDesktop": "Windows桌面端",
    "downloadImmediately": "立即下载",
    "desktopVersion": "桌面版",
    "macDesktop": "MAC桌面端",
    "clickAfterQRScan": "扫描二维码后点击“在",
    "android": "安卓手机版",
    "microsoftVersion": "电脑版下载",
    "explanation": "说明：TF全称是testflight，是一种苹果官方的分发模式。",
    "appleTestFlight": "苹果TF",
    "stockAndroidVersion": "港股安卓版",
    "tfVersionForIPhone": "苹果手机TF版(防封)",
    "stockAppleVersion": "港股苹果版",
    "appleversion": " 苹果手机版",
    "macversion": "苹果电脑Mac 版",
    "appleClassic": "苹果经典版",
    "clickStartTestStockIcon": "点“开始测试”-“接受”-“安装”按钮",
    "viewInstallAndOpen": "中查看”，安装并打开",
    "againScanQRCode": "再次扫描二维码",
    "iPhoneUpgradeVersion": "苹果免升级版",
    "iosTfVersion": "苹果TF版",
    "androidClassic": "安卓经典版",
    "androidPro": "安卓专业版",
    "readyToUse": "即可使用",
    "windowsversion": "Window电脑桌面版",
    "appletfversion": "苹果手机TF版",
    "androidUpgradeVersion": "安卓免升级版",
    "clickStartTest": "点“开始测试”-“接受”-“安装”按钮"
  },
  "androidVersionUpdate": {
    "updateNoticeSure": "确定",
    "forceUpdateSure": "确定",
    "forceUpdateTitle": "注意",
    "forceUpdateContent": "请更新您的APP版本",
    "updateNoticeTitle": "发现新版本",
    "updateNoticeCancle": "取消",
    "forceUpdateCancle": "取消"
  },
  "quoteDetails": {
    "latestPrice": "最新价",
    "code": "代码/名称",
    "gainListTitle": "涨幅榜",
    "quoteChange": "涨跌幅",
    "turnOverRateTitle": "换手率",
    "timedSpeed": "5分钟涨速",
    "back": "返回",
    "lowest": "最低",
    "speedList": "涨速榜",
    "highest": "最高",
    "dropListTitle": "跌幅榜",
    "turnoverTitle": "成交额",
    "speedListAlt": "跌速榜",
    "turnoverPerValue": "成交额/万"
  },
  "capitalAccount": {
    "riskMargin": "风险保证金",
    "title": "配资交易",
    "lossWarning": "亏损警戒线",
    "applicationQuota": "申请额度",
    "dailyRate": "日利率",
    "total": "账户余额:{cash} 代金券:{voucher}元",
    "allocationFundMarginLabel": "配资资金+保证金",
    "times": "倍",
    "allocationDailyInterset": "配资额×日利率×2",
    "totalPayble": "共应支付:",
    "vip": "VIP配资",
    "tradeType": "操盘类型",
    "readAggrementMessage": "请先阅读协议书",
    "aggrement": "《香港大牛证券有限公司服务协议》",
    "voucherLabel": "代金券",
    "applicationConsent": "申请即默认同意",
    "contractValidity": "每个合约至少交易2个交易日",
    "agreement": "《服务协议》",
    "apply": "立即申请",
    "capitalDirectionLong": "做多交易",
    "lossClosingLine": "亏损平仓线",
    "refresh": "刷新",
    "allocationFundMargin": "配资资金+保证金x{amount}",
    "contractValiditySecond": "首次申请将扣取2个交易日的管理费",
    "weeklyInterest": "周利息",
    "monthlyInterest": "月利息",
    "fundByMonth": "按月配资",
    "capitalDirectionShort": "做空交易",
    "allocationMonthlyInterset": "配资额x月利率",
    "tradeDirection": "配资仓位方向",
    "trade": "交易",
    "loginFirstMessage": "请先登录",
    "interestFree": "免息",
    "intrestFree": "免息配资",
    "fundingByDay": "按天配资",
    "allocationWeeklyInterset": "配资额x周利率",
    "fundAllocation": "配资",
    "holdingTime": "持仓时间",
    "fundByWeek": "按周配资",
    "totalFunds": "总配资资金"
  },
  "stock": {
    "cancel": "取消自选",
    "unselect": "取消自选",
    "youHaveNotLogged": "您还未登录,请先去登录后在操作购买",
    "sellQuantityNotSet": "您未选择卖出数量",
    "commisionedQuery": "委托查询",
    "confTrans": "确认交易",
    "numOfTrans": "成交数量",
    "quotes": "行情",
    "buyingPrice": "买入价",
    "nameMarketCap": "名称/市值",
    "balance": "余额",
    "codeNameShort": "代码/名称/简拼",
    "price": "价格",
    "addOptional": "加入自选",
    "buyingVolume": "买入量",
    "regularFee": "规费",
    "highPrice": "涨停价",
    "amountBal": "金额/余额",
    "recent": "最近",
    "inquire": "查询",
    "sure": "确定",
    "nameMarketPrice": "名称/市值",
    "optional": "自选",
    "limitPriceNew": "涨停价",
    "lowest": "最 低",
    "iUnderstand": "我已经明白",
    "sysClose": "系统平仓",
    "operate": "操作",
    "highest": "最 高",
    "sureYouWantToBuy": "您是否确定买入该股票?",
    "buyStatus": "买卖/状态",
    "lumpSee": "总金额",
    "timeDate": "日期时间",
    "brokeCom": "券商佣金",
    "notSelectedStock": "您未选择股票",
    "dateTime": "日期/时间",
    "openAvail": "持仓/可用",
    "transactionRecord": "成交记录",
    "marketPrice": "市价",
    "totProfitLoss": "总盈亏",
    "priceLimit": "限价",
    "tenThousandYuan": "万手",
    "setllementFee": "结算费用",
    "fullPosition": "全仓",
    "sellAtMarketPrice": "市价卖出",
    "sellingPrice": "卖出价",
    "amplitude": "振 幅",
    "sureSellStock": "您是否确认卖出该股票?",
    "currentPriceAvgPrice": "现价/均价",
    "codeName": "代码/名称",
    "share": "股",
    "sellCancelled": "已取消卖出入",
    "recievedYesterday": "昨 收",
    "beijingTime": "北京时间",
    "sell": "卖出",
    "businessStatus": "业务/状态",
    "marketCenter": "行情中心",
    "stockNotPurchased": "还未购买此股票,请进入购买页面购买此股票",
    "buyCancel": "已取消买入",
    "orderTradeVol": "委托/成交量",
    "turnoverNew": "成交金额",
    "notLoggedin": "您还未登录,请前去登录",
    "hundredMilYuan": "亿元",
    "stampDuty": "印花税",
    "entrustTransactionPrice": "委托/成交价",
    "date": "日期",
    "salesVolume": "卖出量",
    "totMarketCapitalize": "总市值",
    "buy": "买入",
    "businessName": "业务名称",
    "gainList": "涨幅榜",
    "loginToSell": "您还未登录,请先去登录后在操作卖出",
    "buyQuantity": "买卖/数量",
    "dealPrice": "成交价格",
    "platformFee": "平台费用",
    "stockTime": "股票/时间",
    "openToday": "今 开",
    "commisionPrice": "委托价",
    "limitPrice": "跌停价",
    "stockCode": "股票代码",
    "entrustClose": "委托/成交",
    "volume": "成交量",
    "qouteChange": "涨跌幅",
    "nameCode": "名称/代码",
    "hint": "提示",
    "name": "名称",
    "position": "持仓/可用",
    "availableForSale": "可卖",
    "pleaseSelectAccount": "请选择账户",
    "circulationValue": "流通值",
    "nameType": "名称/类型",
    "pleaseTryLater": "请稍后尝试",
    "cancelation": "撤单",
    "statement": "对账单",
    "transferFee": "过户费",
    "turnover": "成交额",
    "notSelectedQuantity": "您未选择购买数量",
    "unitPriceTotPrice": "单价/总价",
    "stockNotSelected": "您未选择股票",
    "handleFee": "经手费",
    "canBuy": "可买",
    "productHandlingFee": "产品处理费",
    "tryLater": "请稍后尝试",
    "turnoverRate": "换手率",
    "marketBuy": "市价买入",
    "pleaseSignIn": "请登录"
  },
  "modifyLoginPassword": {
    "sure": "确定",
    "passwordNotMatch": "密码不匹配",
    "back": "返回",
    "enterPassword": "输入密码",
    "phoneNo": "手机号码",
    "changePassword": "修改登录密码",
    "verficationCode": "验证码",
    "verficationCodeLable": "请输入正确答案",
    "phoneNoLable": "请输入手机号",
    "getVerfication": "获取验证码",
    "enterData": "请输入数据",
    "smsVerification": "短信验证码",
    "getVerficationCode": "获取验证码",
    "smsVerificationLable": "请输入短信验证码",
    "confirmPassword": "确认密码",
    "enterPasswordLable": "请输入密码"
  },
  "logs": {
    "amount": "金额",
    "voucher": "代金券",
    "fullDetails": "全部明细",
    "type": "类型",
    "balance": "余额",
    "mgtCosts": "管理费用",
    "loadDetails": "借款明细",
    "recharge": "充值",
    "fundingDetails": "资金明细",
    "state": "状态",
    "time": "时间",
    "cashBack": "赠返现金",
    "withdraw": "提现"
  },
  "operateday": {
    "allocateFunds": "我要配资",
    "allocationAmount": "总配资金额",
    "allocation": "配资资金",
    "agreement": "《服务协议》",
    "ticketPrice": "代金券",
    "lossClosing": "亏损平仓线",
    "longTradingLabel": "做多交易",
    "fundBelowWarning": "当总配资资金低于预警线以下时，只能平仓不能建仓",
    "agree": "我已阅读并同意",
    "fundbelowLiquidation": "当总配资资金低于平仓线以下时，我们将有权把您 的股票进行平仓，为避免平仓发生，请时刻关注本金是否充足",
    "availableBalance": "可用余额",
    "lossWarning": "亏损预警线",
    "dailyRate": "日利率",
    "yuan": "元",
    "times": "倍",
    "managementFee": "管理费",
    "fundInfo": "配资信息",
    "deposit": "保证金",
    "realPayment": "实付款",
    "renew": "2日起,自动续期",
    "directionCapital": "配资仓位方向",
    "day": "日",
    "shortTradingLabel": "做空交易"
  },
  "historyOperate": {
    "over": "已结束"
  },
  "withdrawalData": {
    "gxpay_id": "请输入Gxpay ID"
  },
  "newsDetails": {
    "back": "返回",
    "title": "新闻资讯",
    "announcement": "发布者"
  },
  "diagnosis": {
    "reduce": "减持",
    "wait": "观望",
    "sure": "确 定",
    "technicalsupport": "技术支撑位",
    "callout": "调出",
    "code": "代码/名称/简拼",
    "bigdata": "大数据透视",
    "shortterm": "短期阻力位",
    "mainnews": "主力动态",
    "openday": "今开",
    "focus": "关注",
    "getfree": "免费领取诊断结果",
    "changehands": "换手",
    "collectedyesterday": "昨收",
    "lowest": "最低",
    "smart": "智能诊股",
    "hold": "持有",
    "mediamterm": "中期趋势",
    "amplitude": "振幅",
    "performance": "业绩成长",
    "million": "亿",
    "highest": "最高",
    "turnover": "成交量"
  },
  "setPhone": {
    "setNow": "立即设置",
    "phonePlaceholder": "请输入手机号"
  },
  "timeBao": {
    "transferInSubmit": "转入",
    "cancel": "取消",
    "next": "下一页",
    "transferAmountBao": "转出金额",
    "transferAmount": "转入金额",
    "back": "返回",
    "annualRate": "年化收益率",
    "title": "时时宝",
    "lastEarnings": "上8小时收益",
    "transferOutSubmit": "转出",
    "alreadyLastPage": "已经是最后一页",
    "cumulativeIncome": "累计收益",
    "transferOut": "从时时宝转出",
    "alreadyFirstPage": "已经是第一页",
    "previous": "上一页",
    "bill": "账单",
    "currentAmount": "当前资产",
    "timeTresureBao": "时时宝",
    "currentAssets": "上8小时收益",
    "confirm": "确认",
    "annualInterestRate": "年化利率",
    "enterCorrectAmount": "请输入正确金额",
    "transferIn": "转入时时宝",
    "transferableBalance": "可转余额",
    "interestRateDesc": "炒股理财时时赚钱 年化收益",
    "accountBalance": "账户余额"
  },
  "opeatemonth": {
    "intrestRate": "月利率",
    "managementFee": "管理费"
  },
  "withdrawInquiry": {
    "CommissionPrice": "委托价格",
    "unsoldQuantity": "未成交数量",
    "commissionStatus": "委托状态",
    "commissionTime": "委托时间",
    "nameCode": "名称代码",
    "back": "返回",
    "end": "没有更多了",
    "title": "撤单查询",
    "CommissionDirection": "委托方向",
    "OrderQuantity": "委托数量",
    "direction": "仓位方向"
  },
  " field": {
    "Home_Withdrawal_amount_of_the_day ": "当天提现金额",
    "Home_total_number_of_users ": "用户总量"
  },
  "foundWinners": {
    "highestPrice": "最高价",
    "registerToReadThree": "3456元/年, 金牌投顾每日推荐热点股, 注册可免费阅读",
    "more": "更多",
    "registerToReadFour": "7188元/年, 每日精选 狙击尾盘, 注册可免费阅读",
    "registerToRead": "2796元/年, 每日精选3-5只潜力股, 注册可免费阅读",
    "historyRanking": "近15日涨幅排\\n行榜",
    "lastChase": "尾盘追击",
    "biggestIncrease": "最大涨幅",
    "godOfWealt": "问财神",
    "latestStockPool": "最新股票池",
    "stockName": "股票名",
    "loginToAccess": "注册登陆可读",
    "bullStock": "牛人牛股",
    "shortTermTreasure": "短线宝",
    "registerToReadTwo": "3600元/年, 大数据选股 追踪实盘牛人, 注册可免费阅读",
    "promptLogin": "您还未登录,前去登录",
    "attention": "关注价",
    "registerToReadOne": "2796元/年, 每日精选3-5只潜力股, 注册可免费阅读"
  },
  "forgetpass": {
    "pleaseEnterYourCard": "请输入您的卡",
    "pleaseEnterNewPasswordAgain": "请再次输入新密码",
    "identificationNumber": "身份证号码：",
    "pleaseEnterYourRealName": "请输入您的真实姓名",
    "enterNewPasswordAgain": "再次输入新密码"
  },
  "header": {
    "userCenter": "用户中心",
    "fundAcc": "配资账户",
    "frontPage": "首页",
    "dainuOfficialWebsite": "港股官网",
    "appDownload": "APP下载",
    "marketCenter": "行情中心",
    "applyFunding": "申请配资",
    "longTrading": "做多交易",
    "bullStocks": "牛股",
    "login": "登录",
    "shortTrading": "做空交易",
    "activityArea": "活动专区",
    "firmOffer": "实盘交易",
    "quit": "退出",
    "myAccount": "我的账户",
    "register": "注册"
  },
  "tradingQuery": {
    "shortDirection": "做空",
    "longDirection": "做多",
    "positionDirection": "仓位方向"
  },
  "foundwinner": {
    "loginreadable": "登录可读",
    "sure": "确 定",
    "laststock": "最新股票池",
    "registerLoginReadable": " 注册登录可读"
  },
  "dealInquiry": {
    "inquire": "查询",
    "settlementFee": "结算费用",
    "back": "返回",
    "dealPrice": "成交价格",
    "transactionTime": "成交时间",
    "transactionDirection": "交易方向",
    "title": "会员中心",
    "platformFee": "平台费用",
    "sales": "卖出额",
    "productHandlingFee": "产品处理费",
    "brokerageCommission": "券商佣金",
    "buyAmount": "买入额",
    "stampDuty": "印花税",
    "nameCode": "名称代码",
    "transferFee": "过户费",
    "end": "没有更多了",
    "commissionDate": "委托日期",
    "transactionCount": "成交数量",
    "turnover": "成交金额",
    "direction": "仓位方向"
  },
  "modifyRealName": {
    "sure": "确定",
    "idCard": "身份证",
    "canNotEmpty": "不能为空",
    "verified": "实名认证",
    "name": "姓名",
    "back": "返回"
  },
  "operatehuhui": {
    "allocateFund": "我要配资",
    "microsoftYahei": "微软雅黑",
    "invest": "免息说明",
    "totalAllocation": "总配资金额",
    "times": "倍",
    "balance": "可用余额",
    "realPayment": "实付款",
    "warningLine": "预警线",
    "profit70IsYours": "盈利7成全归您",
    "fundLowerLiquidation": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓， 为避免平仓发生，请时刻关注本金是否充足",
    "allocation": "配资资金",
    "agreement": "《服务协议》",
    "ticket": "代金券",
    "profit50IsYours": "盈利5成全归您",
    "lossClosingLine": "亏损平仓线",
    "understand": "我已经明白",
    "yuan": "元",
    "fundingByDay": "按天配资",
    "fundBelowWaring": "当总配资资金低于预警线以下时，只能平仓不能建仓",
    "lossingWarning": "亏损预警线",
    "fundingInfo": "配资信息",
    "closeLine": "平仓线",
    "readAgreement": "请先阅读协议书",
    "loginFirst": "请先登录",
    "thirtydays": "30天",
    "deposit": "保证金"
  },
  "stockcard": {
    "optional": "自选"
  },
  "aboutUs": {
    "sectionAboutUs": "关于我们",
    "sectionTradingRules": "交易规则",
    "sectionCompanyQualification": "公司资质",
    "sectionRegistrationAgreement": "注册协议",
    "sectionContactUs": "联系我们",
    "back": "返回",
    "sectionHelpCenter": "帮助中心",
    "sectionFundAllocation": "配资指南",
    "sectionBeginner": "新手指引"
  },
  "footer": {
    "allocateFunds": "我要配资",
    "contactUs": "联系我们",
    "aboutUs": "关于我们",
    "copyright": "Copyright ©",
    "serviceLine": "服务电话",
    "noviceGuide": "新手指导",
    "promoteToMakeMoney": "推广赚钱",
    "companyQuali": "公司资质",
    "appDownload": "APP下载",
    "legalHoliday": "法定节日",
    "helpCenter": "帮助中心",
    "opHours": "工作时间",
    "interestFree": "免息配资",
    "fundingByDay": "按天配资",
    "commonProb": "常见问题",
    "monthlyAllo": "按月配资",
    "regAgree": "注册协议",
    "companyProfile": "公司简介",
    "fundByWeek": "按周配资",
    "allRightsReserved": " | All Rights Reserved（投资有风险，入市需谨慎）"
  },
  "lowerLevelDepot": {
    "date": "日期",
    "noMore": "没有更多了",
    "back": "返回",
    "positions": "下级持仓人数",
    "levelThree": "下三级持仓",
    "noOfDays": "天数",
    "dailySubtotal": "日小计",
    "levelOne": "下一级持仓",
    "month": "月份",
    "dailyUsers": "每日持仓人数总和",
    "levelTwo": "下二级持仓",
    "thisMonth": "本月",
    "dailyAvgUsers": "日均持仓人数"
  },
  "operatemonth": {
    "agreement": "《服务协议》",
    "lossClosing": "亏损平仓线",
    "automaticRenewal": "自动续期",
    "fundBelowLiquidation": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓， 为避免平仓发生，请时刻关注本金是否充足",
    "fundBelowWarning": "当总配资资金低于预警线以下时，只能平仓不能建仓",
    "agree": "我已阅读并同意",
    "lossWarning": "亏损预警线",
    "totalAllocation": "总配资金额",
    "allocationFunds": "配资资金",
    "yuan": "元",
    "times": "倍",
    "month": "月",
    "fundingInfo": "配资信息",
    "managementFee": "管理费",
    "deposit": "保证金"
  },
  "redEnvelope": {
    "redeemablePurchaseAmount": "可兑买入额",
    "type": "流水类型",
    "number": "红包编号",
    "RedEnvelopes": "红包流水",
    "redeemDate": "兑现日期",
    "buyingPrice": "买入价格",
    "cashHistory": "兑现历史",
    "unprocessed_orders": "您有未处理的兑现订单， 请联系客服处理。",
    "sendCashNumber": "送现金编号",
    "amoun": "红包额度",
    "redeemAmount": "兑现金额",
    "buyingQuantity": "买入数量",
    "type2": "类型",
    "serialNumber": "流水编号",
    "redeemableAmount": "可兑额",
    "stockCode": "名称/代码",
    "giveAwayRedEnvelopes": "赠送红包",
    "amountShouldBeHundredTimes": "金额应为百倍",
    "RedEnvelopeDate": "日期",
    "exceedAmount": "您的可兑现金额不足",
    "buyingTime": "买入时间",
    "totalAmountRedeemed": "已兑总额",
    "pendingWithdrawAmount": "冻结金额",
    "buyingAmount": "买入额",
    "cashAmount": "金额",
    "buyingHistory": "买入历史",
    "stockName": "股票名称/代码",
    "giveAwayCash": "赠送现金",
    "availableAmount": "可兑现金额：",
    "transactionAmount": "本次兑现金额：",
    "deductPurchaseAmount": "扣除买入额",
    "amount": "红包金额",
    "redeemTransaction": "兑现现金红包",
    "heading": "现金红包",
    "withdraw_success": "现金红包兑现申请成功，请联系客服审核处理",
    "giftDate": "赠送日期",
    "redemptionNumber": "红包兑现编号",
    "mainAccountBalance": "主账户余额",
    "transactionNumber": "成交编号",
    "quotaTotalRedeemed": "额度/已兑总额",
    "emptyAmount": "请输入提现金额",
    "purchaseAmount": "买入额",
    "priceQty": "价格/数量",
    "totalRedeemedAmount": "已兑总额",
    "approve": "后台派送",
    "amountRedeemed": "已兑额",
    "time": "时间",
    "deductableBuyingAmnt": "扣除/可兑买入额",
    "withdraw": "用户兑现",
    "register": "注册送"
  },
  "modifyPhone": {
    "currentPhone": "当前手机号",
    "newPhoneLable": "新手机号",
    "newPhone": "新手机号",
    "currentPhoneLable": "请输入手机号",
    "sure": "确定",
    "changePhone": "更换手机号",
    "enterData": "请输入数据",
    "smsVerification": "短信验证码",
    "back": "返回",
    "smsVerificationLable": "请输入短信验证码",
    "getVerification": "获取验证码",
    "noFormatIncorrect": "手机号码格式不正确"
  },
  "kline": {
    "TimeShare": "分时度假",
    "downLimit": "跌停",
    "avgPrice": "均价",
    "buy": "买入",
    "circulationValue": "流通值",
    "volumeRatio": "量比",
    "hundredMil": "亿",
    "peRatio": "市盈率",
    "amplitude": "振幅",
    "tenThousandHands": "万手",
    "totMarketCapitalization": "总市值",
    "openToday": "今开",
    "day": "日K",
    "turnover": "成交量",
    "hand": "手",
    "recievedYesterday": "昨收",
    "bibi": "委比",
    "sell": "卖出",
    "optional": "自选",
    "timeSharing": "分时",
    "zhou": "周K",
    "lowest": "最低",
    "minute": "分钟",
    "billionHands": "亿手",
    "dayLimit": "涨停",
    "month": "月K",
    "highest": "最高",
    "turnoverRate": "换手率"
  },
  "modifyWithdrawPassword": {
    "sure": "确定",
    "back": "返回",
    "phoneNo": "手机号",
    "password": "输入密码",
    "phoneNoLable": "请输入手机号",
    "verificationLable": "请输入验证码",
    "getVerfication": "获取验证码",
    "smsVerification": "短信验证码",
    "getVerficationCode": "获取验证码",
    "smsVerificationLable": "请输入短信验证码",
    "confirmPassword": "确认密码",
    "passwordLable": "请输入密码",
    "verification": "验证码",
    "withdraw": "修改提款密码"
  },
  "title": {
    "evaluation": "评价",
    "recharge": "充值",
    "shopJoin": "商铺入住",
    "serviceDetail": "服务详情",
    "myTeam": "我的团队",
    "personalJoin": "个人入住",
    "capitalFlow": "资金流水",
    "myAccount": "我的资产",
    "serviceTechnician": "服务技师",
    "withdraw": "提现"
  },
  "common": {
    "allow": "允许",
    "prohibit": "禁止",
    "funding": "配资交易",
    "quote": "行情自选",
    "chat": "专属客服",
    "userTerms": "条款与协议",
    "share": "分享",
    "customerCare": "客服",
    "Profile": "我的",
    "account": "账户",
    "home": "首页"
  },
  "tabpage": {
    "image": "图片管理",
    "cashManager": "现金经理",
    "upload": "上传配置",
    "en": "英文",
    "otp": "OTP",
    "zh": "简体中文",
    "home": "首页菜单",
    "extend": "扩展信息",
    "system": "系统配置",
    "trade": "交易配置",
    "trc20": "TRC20配置",
    "pragmatic": "实用游戏",
    "ja": "日语",
    "sms": "短信配置",
    "redpacket": "红包设置",
    "company": "公司信息",
    "payment": "支付",
    "detail": "详细描述",
    "basic": "基本信息",
    "email": "邮件设置",
    "others": "其他的",
    "riskManagement": "风险管理"
  },
  "closedCapitalInfo": {
    "tradingProfitLoss": "交易盈亏",
    "riskMargin": "风险保证金",
    "profitDistribution": "盈利分配",
    "revenueShare": "收益分成",
    "contractNo": "合同编号",
    "lossClosingLine": "亏损平仓线",
    "lossCompensation": "亏损赔付",
    "transactionTime": "成交时间",
    "title": "历史操盘",
    "transactionFlow": "交易流水(点击查看更多明细)",
    "applicationQuota": "申请额度",
    "priceQuantity": "价格/数量",
    "freeze": "冻结",
    "lossWarningLine": "亏损警戒线",
    "totalTradingFunds": "总操盘资金",
    "deduction": "扣减",
    "tradingVariety": "交易品种",
    "nameCode": "名称代码",
    "profitLossDistribution": "交易盈亏分配",
    "managementFee": "管理费",
    "buyStatus": "买卖/状态",
    "thaw": "解冻",
    "totalFunds": "总配资资金"
  },
  "noticeDetail": {
    "back": "返回",
    "announcement": "公告详情"
  },
  "technician": {
    "imageOver3": "图片超过3张",
    "storeRequired": "添加技师需要店铺",
    "personStoreNoAdd": "个人店铺不能添加技师",
    "earliestReserve": "最早可约",
    "distanceNear": "距离最近",
    "orderCounts": "订单数量",
    "female": "女技师",
    "male": "男技师"
  },
  "helpstatement": {
    "legalProtection": "法律保障"
  },
  "home": {
    "shenzhenStockExchangeIndex": "深证指数",
    "clickCustomerService": "点击联系客服",
    "independentHouseHold": "独立成户",
    "interestRates": "利率低至",
    "freeTrial": "免费体验",
    "equilityExperienceFund": "最高保证金",
    "qqCustomerService": "客服QQ",
    "TenThousandYuan": "万元",
    "registeredNumber": "注册会员",
    "firmOffer": "实盘,同步股市数据",
    "recentRegisterSuccess": "近期已注册成功",
    "leadingLosers": "领跌股",
    "realDeal": "真实交易",
    "maximumMargin": "最高保证金",
    "mutualFund": "免息配资",
    "announcement": "公告",
    "discover": "发现牛股",
    "commonText": "配资{value1}万实盘资金盈利{value2}万",
    "specialUses": "资金第三方监管,专款专用",
    "belongsToYou": "归您",
    "agentQQ": "代理QQ",
    "telephone": "电话",
    "stableAndEfficient": "稳定高效",
    "firmOfferExperience": "实盘体验",
    "lightingWithdrawal": "闪电提现,最快三分钟到账",
    "fastWithdrwal": "快捷提现",
    "customerService": "在线客服",
    "weeklyKLine": "周K线",
    "minimumAmount": "起配金额",
    "weekFund": "免费体验",
    "dailyKLine": "日K线",
    "thirdPartyCustody": "资金三方托管/保险双保障/全实盘交易",
    "leveragedCapitalTotal": "杠杆配资",
    "dayFund": "按天配资",
    "acting": "代理",
    "successRegister": "今日已注册成功",
    "leadingStock": "领涨股",
    "aboutUs": "活动专区",
    "profitIsYours": "盈利归您",
    "brokers": "知名品牌券商",
    "fundingGuarantee": "资金保障",
    "monthlyKLine": "月K线",
    "timeLine": "分时线",
    "clickToUpdate": "点击更新",
    "login": "登录",
    "notify": "通知",
    "customerExperienceFirst": "客户体验至上为宗旨",
    "allotmentFirmOffer": "配资8万实盘资金盈利0",
    "stockName": "股票名称",
    "noDataCurrently": "当前无数据",
    "danielCustomerService": "客服",
    "companyProfile": "公司简介",
    "free": "全免",
    "profit": "盈利",
    "professionalService": "专业服务",
    "copyrightWarning": "(投资有风险，入市需谨慎)",
    "news": "新闻动态",
    "noInterestCharge": "不收取利息",
    "yuanDivTenThousand": "元/1万",
    "monthFund": "按月配资",
    "stockType": "安全配资 上大牛证券",
    "revenueShare": "收益分成",
    "more": "更多",
    "appDownload": "APP下载",
    "trader": "操盘达人",
    "appDownLoadSimple": "app下载",
    "shanghaiCompositeIndex": "上证指数",
    "topUpDay": "今日充值",
    "partner": "合作伙伴",
    "securityCertificationBrand": "券商实盘 专业安全 认证品牌",
    "stockMarketInformation": "股市资讯",
    "return": "返回",
    "register": "注册"
  },
  "memberInformation": {
    "unbound": "未绑定",
    "mail": "邮箱",
    "bankCard": "银行卡",
    "notSet": "未设置",
    "verified": "实名认证",
    "withdrawalPasswordfield": "提款密码",
    "back": "返回",
    "hasSet": "已设置",
    "title": "完善资料",
    "notRealName": "未实名",
    "password": "密码",
    "bindBankCard": "已绑定银行卡",
    "phone": "手机",
    "loginPassword": "登录密码",
    "nickname": "昵称",
    "withdrawalPassword": "未设置"
  },
  "opeatevip": {
    "warningLine": "预警线",
    "maxMin": "最少100,最多200万,1百整倍数"
  },
  "detailed": {
    "moderated": "等待审核",
    "rechargeSuccessfull": "充值成功",
    "rechargeFailed": "充值失败"
  },
  "agencyComponent": {
    "amount": "金额:",
    "noMore": "没有更多了",
    "balance": "余额:",
    "account": "账号："
  },
  "capitallAccount": {
    "depositFee": "预存管理费"
  },
  "myTeam": {
    "allMembers": "所有会员",
    "noMore": "没有更多了",
    "rechargeMember": "充值会员",
    "myTeam": "我的团队",
    "back": "返回",
    "noRechargeMember": "无充值会员",
    "totalRecharge": "充值总额:"
  },
  "helpoffice": {
    "officeEnvironment": "办公环境"
  },
  "user": {
    "confirmNewPassword": "确认新密码",
    "topUp": "手机充值",
    "passwordPlaceholder": "输入密码",
    "notSet": "没有设置",
    "login": "这里登录",
    "phnNo": "手机号",
    "signUp": "在此注册",
    "forgotPassword": "忘记密码？",
    "bank": "银行",
    "alreadyHaveAccount": "已有账户？",
    "changePhone": "新手机号",
    "payPass": "支付密码",
    "me": "我的",
    "loginPass": "登录密码",
    "copy": "复制",
    "resetPass": "重置您的密码",
    "email": "邮箱",
    "settings": "设置",
    "address": "钱包地址",
    "welcomeMessage": "你好",
    "otpCode": "OTP代码",
    "otp": "OTP",
    "transactions": "交易",
    "userId": "用户ID",
    "currentPassword": "当前密码",
    "changeName": "更改您的名字",
    "confPass": "确认密码",
    "phonePlaceholder": "输入电话号码",
    "enterCode": "输入代码",
    "signIn": "登录",
    "name": "姓名",
    "noAccount": "没有帐户？",
    "newEmail": "新邮箱",
    "accountBalance": "账户余额",
    "jcaptcha": "验证码验证错误",
    "refCode": "参考 代码",
    "collect": "收藏"
  },
  "account": {
    "cancel": "取消",
    "positionInquiry": "持仓查询",
    "cancellationInquiry": "撤单查询",
    "voucher": "代金券",
    "companyName": "{company_name}",
    "buildNumber": "包号",
    "firmOffer": "实盘交易",
    "optionalStock": "自选股票",
    "balance": "余额",
    "onlineService": "在线客服",
    "fundingDetails": "资金明细",
    "contactCustomerService": "联系客服",
    "others": "其他 ",
    "pleaseActiveRealName": "请实名激活 ",
    "patformAnnounce": "平台公告",
    "margin": "保证金 {bond} 元",
    "signOut": "退出登录",
    "myCoupon": "我的好友现金券",
    "shortTrading": "做空交易",
    "promotionAccount": "推广账号",
    "earnMoney": "炒股理财时时赚钱 年化收益 {timebao_annualized_rate} %",
    "transactionInquiry": "成交查询",
    "tradenow": "立即配资交易",
    "topUpNow": "立即充值",
    "updateInfo": "完善资料",
    "versionbuildNumber": "版本号 / 包号",
    "riskControlNotice": "风控通知",
    "login": "登录",
    "friendCashCoupon": "好友现金券",
    "realNameNow": "立即实名",
    "recharge": "充值",
    "lineSwitching": "线路切换",
    "lineThree": "线路三",
    "memberCentre": "会员中心",
    "myService": "我的服务",
    "noRealName": "您还没有实名",
    "fundingAccount": "配资账户",
    "moreActions": "更多操作",
    "longTrading": "做多交易",
    "versionNumber": "版本号",
    "yuan": "元",
    "cumIncome": "累计收益:",
    "promotionAcoount": "申请配资",
    "giftMoney": "元礼金",
    "checkIn": "签到",
    "accountList": "账号列表",
    "commissionedInquiry": "委托查询",
    "totalUserAsset": "我的资产",
    "timeTreasure": "时时宝",
    "register": "注册",
    "withdraw": "提现"
  },
  "operateweek": {
    "allocation": "配资资金",
    "week": "周",
    "agreement": "《服务协议》",
    "ticketPrice": "代金券",
    "allocateFund": "我要配资",
    "lossClosing": "亏损平仓线",
    "automaticRenewal": "自动续期",
    "understand": "我已经明白",
    "minMax": "最少100,最多200万,1百整倍数",
    "fundBelowLiquidation": "当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓， 为避免平仓发生，请时刻关注本金是否充足",
    "fundBelowWarning": "当总配资资金低于预警线以下时，只能平仓不能建仓",
    "agree": "我已阅读并同意",
    "managmentFee": "管理费",
    "lossWarning": "亏损预警线",
    "totalAllocation": "总配资金额",
    "yuan": "元",
    "weeklyRate": "周利率",
    "balance": "可用余额",
    "fundingInfo": "配资信息",
    "managementFee": "管理费",
    "fundByDay": "按天配资",
    "deposit": "保证金",
    "realPayment": "实付款",
    "weekToVoucher": "周-代金券"
  },
  "withdraw": {
    "cancel": "取消",
    "instructions": "提现说明",
    "goToSettings": "去设置",
    "selectWithdrawType": "请选择提现类型",
    "withdrawPasswordEnter": "请输入提现金额",
    "fee": "提现手续费",
    "back": "返回",
    "modifyWithdrawPassword": "修改提现密码",
    "transferTo": "转入时时宝, 每8小时收益 {timebao_rate} \\n开市炒股，休市理财，时时赚钱\\n随进随出，实时到账，年化收益率 {timebao_annualized_interest_rate}%",
    "bankNotBound": "请先设置提现银行卡才能提现",
    "withdrawPassword": "提现密码",
    "gold": "金币",
    "friendlyReminder": "友情提醒",
    "bindBankCard": "还未绑定银行卡,请前去绑定银行卡才可提现",
    "withdrawPasswordNotset": "您还没有设置提现密码，不能提现，请前去设置",
    "noNewWithdraw": "非新提现",
    "arrivalTime": "到账时间",
    "instruct2": "2、如提现遇到问题，请联系客服；",
    "maxWithdraw": "最大提现",
    "instruct1": "1、提现成功后，资金将在2小时内已现金红包发至您的微信系统通知账户，请在24小时内领取，过期将失效；",
    "receiptAmt": "到账金额",
    "timebaoleft": "转入时时宝",
    "withdrawAmount": "提现金额",
    "amount": "提现额度",
    "estimateTime": "预计2小时内到账",
    "reminder": "温馨提醒 : ",
    "enterWithdrawPassword": "请输入提现密码",
    "withdrawAcc": "提现账户",
    "currentBalance": "当前余额",
    "confirmWithdraw": "确认提现 预计5分钟-3小时到账",
    "contToWithdraw": "继续新提现",
    "ordinary": "普通账户",
    "reminderConf": "提现手续费按提现金额的 { withdrawFeePercentage} %收取 , {withdrawFeeMin } 元起。",
    "yuan": "元",
    "withdrawAmountEnter": "请输入提现金额",
    "nextStep": "下一步",
    "sameAmountReview": "您已提交一笔同金额的提现正在审核处理中\\n若非新提现请勿重复提交 提示",
    "withdrawTo": "提现到",
    "timebaoright": "继续提现",
    "enterWithdrawAmount": "请输入提现金额",
    "withdraw": "提现"
  },
  "memberDetailedLog": {
    "rechargeDetails": "充值明细",
    "balance": "余额",
    "loanDetails": "借款明细",
    "withdrawalDetails": "提现明细",
    "back": "返回",
    "managementCost": "管理费用",
    "fullDetails": "全部明细",
    "title": "资金明细",
    "cashBack": "赠返现金",
    "priceTicket": "代金券"
  }
}



// WEBPACK FOOTER //
// ./src/locale/zh.js